<!--
 * @Author:
 * @Description:
 * @Date: 2024-12-18 16:30:37
 * @LastEditors: Please set LastEditors
 * @FilePath: /rhcn-checkout-web/src/views/aggregate/pc/PaymentForm.vue
-->
<!-- eslint-disable indent -->
<template>
  <div>
    <!-- <h2 class="payment-title-text">{{ $t('message.checkout.payWithCard') }}</h2> -->
    <div>
      <div class="checkout-wrapper">
        <div v-if="order">
          <div v-if="viewCountryBtn !== false && form && form.CARD" class="country-wrapper">
            <div class="filed-title">{{ $t('message.checkout.country') }}</div>
            <CountrySelect v-model="form.CARD.country" @focus="clickCountryHandler" @change="countryChangeHandler"
              :disabled='submitBtnLoading' />
          </div>
          <!-- TODO NEMO: 特殊支付方式 applePay googlePay -->
          <div class="special-payment-wrapper" v-if="supportApplePay || supportGooglePay">
            <!-- applePay -->
            <div class="special-payment-item" v-if="supportApplePay && applePayBtnShow === 1">
              <apple-pay-button class="apple-pay-btn" v-if="applePayBtnShow === 1" buttonstyle="black"
                :type="(order && order.subProductType === 'SUBSCRIBE' && order.subscription) ? 'subscribe' : 'plain'"
                :locale="APPLE_PAY_LANG[lang]" @click="handleApplePayClick"></apple-pay-button>
              <div class="submiting_disable_bg" v-if="submitBtnLoading"></div>
            </div>
            <!-- googlePay -->
            <div class="special-payment-item" v-if="supportGooglePay && googleScriptLoaded === 'success'">
              <div class="google-pay-button" style="height: 38px;" @click.stop="handleGooglePayClick"></div>
              <div class="submiting_disable_bg" v-if="submitBtnLoading"></div>
            </div>
            <!-- onlyCard代表只有一种支付方式 卡支付 -->
            <!-- onlyShowCardPayMethod代表[卡支付/applePay]、[卡支付/GooglePay]、[卡支付/GooglePay/applePay]\[卡支付] -->
            <!-- onlySpecialPayment代表只有一种支付方式 特殊支付方式，这个时候不展示其他支付区域 -->
            <div class="special-payment-divider" v-if="!onlySpecialPayment">{{ onlyShowCardPayMethod ?
              $t('message.checkout.specialPaymentDivider')
              : $t('message.checkout.anotherPayment') }}</div>
          </div>

          <div
            :class="['_payment-wrapper', (!supportApplePay && !supportGooglePay && !onlyShowCardPayMethod) || onlyCard ? 'onlyShowCardPayMethod' : '', { 'card-info-loading': cardInfoLoading }]"
            v-loading="cardInfoLoading">
            <div class="payment-content-wrapper" v-if="payMethods?.length && !onlySpecialPayment">
              <div class="payment-content order-box">
                <div class="filed-title payment-method-title" v-if="!onlyShowCardPayMethod">{{
                  $t('message.checkout.paymentMethod') }}</div>
                <div class="payment-method-wrapper" :class="{ onlyShowCardPayMethod }">
                  <el-collapse accordion v-model="activePaymentMethod">
                    <el-collapse-item v-for="(item, index) in payMethods" :key="index" :name="index"
                      v-show="item.cardName !== 'ApplePay' && item.cardName !== 'GooglePay'" :disabled="true"
                      class="method-collapse-item" :class="{
                        'before': Number.isInteger(activePaymentMethod) && activePaymentMethod === index + 1,
                        'after': Number.isInteger(activePaymentMethod) && activePaymentMethod === index - 1,
                      }">
                      <template slot="title">
                        <div class="padding-left-3 method-title">
                          <el-radio :disabled="submitBtnLoading" v-model="activePaymentMethod" :label="index"
                            @change="methodChange" class="card-type-radio">
                            <div class="card-name">
                              <!-- 左侧LOGO -->
                              <span class="card-img-wrapper">
                                <img v-if="item && item.cardName === 'CARD'" class="card-img"
                                  src="~@/assets/images/cards/Credit.png" />
                                <img v-else-if="item && item.cardName && ['Alipay+', 'Konbini'].includes(item.cardName)"
                                  class="card-img" :src="item.logoUrl" />
                                <img v-else class="card-img"
                                  :src="item.cardTypeInfo && item.cardTypeInfo.length && item.cardTypeInfo[0].logoPath" />
                              </span>
                              <span class="card-type-name" v-if="item.cardTypeName === 'DANA_VA'">Virtual Account</span>
                              <span class="card-type-name" v-else-if="item.cardTypeName === 'DANA_Checkout'">DANA</span>
                              <span class="card-type-name" v-else-if="item.cardTypeName === 'CARD'">Card</span>
                              <span class="card-type-name" v-else>{{ item.cardTypeName }}</span>

                            </div>
                          </el-radio>
                          <!-- CARD -->
                          <div class="payments-support"
                            v-if="item && item.cardName && ['CARD'].includes(item.cardName) && item.cardTypeInfo && item.cardTypeInfo.length && payMethods[activePaymentMethod] && payMethods[activePaymentMethod].cardName !== 'CARD'">
                            <div class="card-info-suffix">
                              <div class="card-info-suffix-content">
                                <img v-for="(item) in supportCardTypes.slice(0, 3)" :key="item.logoPath"
                                  :src="item.logoPath" alt="" class="fixed-item" />
                                <div class="fade-carousel" v-show="supportCardTypes.length > 3">
                                  <img v-for="(card, index) in supportCardTypes.slice(3)" :key="card.logoPath"
                                    :src="card.logoPath" class="fade-item"
                                    :class="{ active: index === supportCardActiveIndex }" alt="" />
                                </div>
                              </div>
                            </div>
                          </div>
                          <!-- 非CARD -->
                          <div class="payments-support"
                            v-if="item && item.cardName && ['Alipay+'].includes(item.cardName) && item.cardTypeInfo && item.cardTypeInfo.length">
                            <template v-for="(cardItem, idx) of item.cardTypeInfo">
                              <img class="img" :src="cardItem.logoPath" height="20" />
                            </template>
                            <!-- 右边logo多于3个 -->
                            <template v-if="item.cardTypeInfo && item.cardTypeInfo.length > 3">
                              <span class="card-number">+{{ item.cardTypeInfo.length - 3 }}</span>
                            </template>
                          </div>
                          <!-- ALIPAY LOGO -->
                          <!-- <div class="payments-support" v-if="ALIPAY.includes(item.cardName)">
                          <el-tooltip effect="dark" :content="item.cardName">
                            <img class="img" src="../../assets/images/alipay/alipay.png" height="20" />
                          </el-tooltip>
                        </div> -->
                        </div>
                      </template>
                      <div class="payment-contents">
                        <!-- 支付方式标题 - 只在卡支付且有Token卡片时显示 -->
                        <div v-if="item.cardName === 'CARD' && showTokenSwitchBtn"
                          class="card-payment-mode-title mobile-padding" :class="[
                            onlyShowCardPayMethod ? '' : 'padding-left-10 padding-right-10',
                            { 'clickable': useTokenPayment && checkoutTokenInfos.length > 1 }
                          ]"
                          @click="useTokenPayment && checkoutTokenInfos.length > 1 && (tokenCardsExpanded = !tokenCardsExpanded)">
                          {{ useTokenPayment ? $t('message.checkout.useSavedCard') : $t('message.checkout.useNewCard')
                          }}
                          <img v-if="useTokenPayment && checkoutTokenInfos.length > 1"
                            src="@/componentsV2/busi/PaymentForm/arror.png"
                            :class="{ 'arrow-open': !tokenCardsExpanded }" class="arrow-icon" />
                        </div>

                        <!-- Token支付模块 - 在卡支付折叠面板内部 -->
                        <div v-show="useTokenPayment && item.cardName === 'CARD'"
                          class="token-payment-wrapper mobile-padding"
                          :class="[onlyShowCardPayMethod ? '' : 'padding-left-10 padding-right-10']">
                          <token-payment v-if="useTokenPayment && item.cardName === 'CARD'" :order="order"
                            :token-cards="checkoutTokenInfos" :submit-btn-loading="submitBtnLoading"
                            :selected-card-id.sync="selectedTokenCardId" :expanded="tokenCardsExpanded"
                            @submit="submitWithToken" @switch-to-card="switchToCardPayment"
                            @remove-card="removeTokenCard">
                          </token-payment>
                        </div>

                        <!-- 原有卡支付表单 - 非Token模式时显示 -->
                        <div v-show="!(useTokenPayment && item.cardName === 'CARD')">
                          <div v-for="bankCardName in BankCardNames" :key="bankCardName">
                            <div class="DANA_wrap padding-left-10 padding-right-10 mobile-padding"
                              v-if="item && item.cardName === bankCardName">
                              <template v-for="(bank, bankIndex) in getBankOptions(bankCardName)">

                                <div class="DANA_item" :class="selectedBankCode === bank.code ? 'DANA_active' : ''"
                                  :key="bankIndex" @click="selectBank(bank.code)">
                                  <img :src="bank.image" alt="">
                                </div>
                              </template>
                            </div>
                          </div>
                          <el-form :hide-required-asterisk="true" label-position="top"
                            :model="item && item.cardName === 'CARD' ? form.CARD : form.LOCAL"
                            :rules="(item.children && item.children.length) ? (activeChildPaymentMethod === '' ? {} : item.children[activeChildPaymentMethod].rules) : item.rules"
                            ref="formRef">
                            <div class="mobile-padding"
                              :class="[onlyShowCardPayMethod ? '' : 'padding-left-10 padding-right-10']">
                              <!-- 支付信息 -->
                              <el-row :gutter="device.device === 'WAP' ? 5 : 30" class="fields-row">
                                <template v-for="(paymentField, paymentIndex) in item.paymentConfigurationFields">
                                  <template v-if="paymentField.name === 'cardNum'">
                                    <el-col :key="paymentIndex" :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
                                      <el-form-item :show-message="false" :ref="`cardNumRef${refSuffix[paymentType]}`">
                                        <template slot="label">
                                          <div class="form-label">
                                            <span>{{ $t('message.checkout.cardInfo') }}</span>
                                            <span v-if="isCardInformationRequired" class="required-tip">{{
                                              $t('message.validator.required') }}</span>
                                          </div>
                                        </template>
                                        <div>
                                          <card-information :ref="`cardInformationRef${activePaymentMethod}`"
                                            :rules="(item.children && item.children.length) ? (activeChildPaymentMethod === '' ? {} : item.children[activeChildPaymentMethod].rules) : item.rules"
                                            :cardTypeInfo="item && item.cardTypeInfo"
                                            :cardNum.sync="form[paymentType].cardNum"
                                            :effectiveDate.sync="form[paymentType].effectiveDate"
                                            :cvv.sync="form[paymentType].cvv" @cardNumberBlur="cardNumberBlur"
                                            @inputFocus="handleCardInfoInputFocus"
                                            @inputChange="handleCardInfoInputChange"></card-information>
                                        </div>
                                      </el-form-item>
                                    </el-col>
                                  </template>
                                  <template v-else-if="!['cardNum', 'jpLastName'].includes(paymentField.name)">
                                    <el-col :class="paymentField.name"
                                      v-if="paymentField.name != 'cardHolderName' || (paymentField.name === 'cardHolderName' && !hideCardHolderName)"
                                      :key="paymentIndex"
                                      :xs="['effectiveDate', 'cvv'].includes(paymentField.name) ? 12 : 24" :sm="24"
                                      :md="24" :lg="24" :xl="24">

                                      <el-form-item v-if="paymentField.name === 'cardHolderName'"
                                        :label="$t('message.checkout.holderName')" prop="cardHolderName"
                                        :ref="`cardHolderNameRef${refSuffix[paymentType]}`">
                                        <template slot="label">
                                          <div class="form-label">
                                            <span>{{ $t('message.checkout.holderName') }}</span>
                                            <span
                                              v-show="judgeRequired('cardHolderName', form[paymentType].cardHolderName)"
                                              class="required-tip">{{
                                                $t('message.validator.required') }}</span>
                                          </div>
                                        </template>
                                        <el-input maxlength="50" autocomplete="cc-name"
                                          v-model="form[paymentType].cardHolderName"
                                          :placeholder="$t('message.checkout.holderNameTips')"
                                          @focus="sendPaymentInfoFocusEvent(paymentField.name)"
                                          @change="sendPaymentInfoInputEvent(paymentField.name)" />
                                      </el-form-item>
                                      <el-form-item v-if="paymentField.name === 'walletAccountName'"
                                        :label="$t('message.checkout.walletAccountName')" prop="walletAccountName"
                                        :ref="`walletAccountNameRef${refSuffix[paymentType]}`">
                                        <template slot="label">
                                          <div class="form-label">
                                            <span>{{ $t('message.checkout.walletAccountName') }}</span>
                                            <span
                                              v-show="judgeRequired('walletAccountName', form[paymentType].walletAccountName)"
                                              class="required-tip">{{ $t('message.validator.required') }}</span>
                                          </div>
                                        </template>
                                        <el-input maxlength="50" autocomplete="off"
                                          v-model="form[paymentType].walletAccountName"
                                          @focus="sendPaymentInfoFocusEvent(paymentField.name)"
                                          @change="sendPaymentInfoInputEvent(paymentField.name)" />
                                      </el-form-item>
                                      <el-form-item v-if="paymentField.name === 'prepaidNumber'"
                                        :label="$t('message.checkout.cardNumber')" prop="prepaidNumber"
                                        :ref="`prepaidNumber${refSuffix[paymentType]}`">
                                        <template slot="label">
                                          <div class="form-label">
                                            <span>{{ $t('message.checkout.cardNumber') }}</span>
                                            <span
                                              v-show="judgeRequired('prepaidNumber', form[paymentType].prepaidNumber)"
                                              class="required-tip">{{
                                                $t('message.validator.required') }}</span>
                                          </div>
                                        </template>
                                        <el-input maxlength="16" autocomplete="off"
                                          v-model="form[paymentType].prepaidNumber" inputmode="numeric"
                                          @focus="sendPaymentInfoFocusEvent(paymentField.name)"
                                          @change="sendPaymentInfoInputEvent(paymentField.name)" />
                                      </el-form-item>
                                      <el-form-item v-if="paymentField.name === 'blikcode'"
                                        :label="$t('message.checkout.blikcode')" prop="blikcode"
                                        :ref="`blikcode${refSuffix[paymentType]}`">
                                        <template slot="label">
                                          <div class="form-label">
                                            <span>{{ $t('message.checkout.blikcode') }}</span>
                                            <span v-show="judgeRequired('blikcode', form[paymentType].blikcode)"
                                              class="required-tip">{{
                                                $t('message.validator.required') }}</span>
                                          </div>
                                        </template>
                                        <el-input autocomplete="off" v-model="form[paymentType].blikcode" :maxlength="6"
                                          @focus="sendPaymentInfoFocusEvent(paymentField.name)"
                                          @change="sendPaymentInfoInputEvent(paymentField.name)"></el-input>
                                      </el-form-item>
                                      <el-form-item v-if="paymentField.name === 'identityNumber'"
                                        :label="identityNumberFormLabel" prop="identityNumber"
                                        :ref="`identityNumberRef${refSuffix[paymentType]}`">
                                        <template slot="label">
                                          <div class="form-label">
                                            <span>{{ identityNumberFormLabel }}</span>
                                            <span
                                              v-show="judgeRequired('identityNumber', form[paymentType].identityNumber)"
                                              class="required-tip">{{
                                                $t('message.validator.required') }}</span>
                                          </div>
                                        </template>
                                        <el-input maxlength="64" autocomplete="off"
                                          v-model="form[paymentType].identityNumber" @input="onIdentityNumberInput"
                                          @focus="sendPaymentInfoFocusEvent(paymentField.name)"
                                          @change="sendPaymentInfoInputEvent(paymentField.name)" />
                                      </el-form-item>
                                      <el-form-item v-if="paymentField.name === 'birthDate'"
                                        @input.native="birthDateChangeHandler" :label="$t('message.checkout.birthDate')"
                                        prop="birthDate" :ref="`birthDateRef${refSuffix[paymentType]}`">
                                        <template slot="label">
                                          <div class="form-label">
                                            <span>{{ $t('message.checkout.birthDate') }}</span>
                                            <span v-show="judgeRequired('birthDate', form[paymentType].birthDate)"
                                              class="required-tip">{{
                                                $t('message.validator.required') }}</span>
                                          </div>
                                        </template>
                                        <el-input maxlength="14" autocomplete="off"
                                          v-model="form[paymentType].birthDate" placeholder="YYYY / MM / DD"
                                          @focus="sendPaymentInfoFocusEvent(paymentField.name)"
                                          @change="sendPaymentInfoInputEvent(paymentField.name)" />
                                      </el-form-item>
                                      <el-form-item v-if="paymentField.name === 'issueDate'"
                                        :label="$t('message.checkout.issueDate')" prop="issueDate"
                                        :ref="`issueDateRef${refSuffix[paymentType]}`">
                                        <template slot="label">
                                          <div class="form-label">
                                            <span>{{ $t('message.checkout.issueDate') }}</span>
                                            <span v-show="judgeRequired('issueDate', form[paymentType].issueDate)"
                                              class="required-tip">{{
                                                $t('message.validator.required') }}</span>
                                          </div>
                                        </template>
                                        <el-input maxlength="7" placeholder="MM / YY" autocomplete="off"
                                          v-model="form[paymentType].issueDate" @input.native="issueDateChangeHandler"
                                          @focus="sendPaymentInfoFocusEvent(paymentField.name)"
                                          @change="sendPaymentInfoInputEvent(paymentField.name)" />
                                      </el-form-item>
                                      <el-form-item v-if="paymentField.name === 'bankName'"
                                        :label="$t('message.checkout.bankName')" prop="bankName"
                                        :ref="`bankNameRef${refSuffix[paymentType]}`">
                                        <template slot="label">
                                          <div class="form-label">
                                            <span>{{ $t('message.checkout.bankName') }}</span>
                                            <span v-show="judgeRequired('bankName', form[paymentType].bankName)"
                                              class="required-tip">{{
                                                $t('message.validator.required') }}</span>
                                          </div>
                                        </template>
                                        <el-select filterable v-model="form[paymentType].bankName"
                                          :error="judgeRequired('bankName', form[paymentType].bankName)"
                                          @visible-change="clickSelectHandler($event, 'payment', paymentField.name)"
                                          @change="sendPaymentInfoInputEvent(paymentField.name)">
                                          <el-option v-for="(bank, bankIndex) in (BANK_OPTIONS[item.cardName] || [])"
                                            :key="bankIndex" :value="bank.code" :label="bank.name"></el-option>
                                        </el-select>
                                      </el-form-item>
                                      <el-form-item v-if="paymentField.name === 'iBan'"
                                        :label="$t('message.checkout.iBan')" prop="iBan"
                                        :ref="`iBanRef${refSuffix[paymentType]}`">
                                        <template slot="label">
                                          <div class="form-label">
                                            <span>{{ $t('message.checkout.iBan') }}</span>
                                            <span v-show="judgeRequired('iBan', form[paymentType].iBan)"
                                              class="required-tip">{{
                                                $t('message.validator.required') }}</span>
                                          </div>
                                        </template>
                                        <el-input maxlength="64" autocomplete="off" v-model="form[paymentType].iBan"
                                          @focus="sendPaymentInfoFocusEvent(paymentField.name)"
                                          @change="sendPaymentInfoInputEvent(paymentField.name)" />
                                      </el-form-item>
                                      <el-row :gutter="device.device === 'WAP' ? 5 : 10"
                                        v-if="paymentField.name === 'jpFirstName'">
                                        <el-col :xs="12" :sm="12" :md="12" :lg="12" :xl="12">
                                          <el-form-item label="姓/カタカナ" prop="jpFirstName"
                                            :ref="`jpFirstNameRef${refSuffix[paymentType]}`" class="nowrap-text">
                                            <template slot="label">
                                              <div class="form-label">
                                                <span>姓/カタカナ</span>
                                                <span
                                                  v-show="judgeRequired('jpFirstName', form[paymentType].jpFirstName)"
                                                  class="required-tip">{{
                                                    $t('message.validator.required') }}</span>
                                              </div>
                                            </template>
                                            <el-input maxlength="64" autocomplete="off"
                                              v-model="form[paymentType].jpFirstName" placeholder="姓/カタカナ"
                                              @focus="sendPaymentInfoFocusEvent(paymentField.name)"
                                              @change="sendPaymentInfoInputEvent(paymentField.name)" />
                                          </el-form-item>
                                        </el-col>
                                        <el-col :xs="12" :sm="12" :md="12" :lg="12" :xl="12">
                                          <el-form-item label="名/カタカナ" prop="jpLastName"
                                            :ref="`jpLastNameRef${refSuffix[paymentType]}`" class="margin-top-0">
                                            <template slot="label">
                                              <div class="form-label">
                                                <span>名/カタカナ</span>
                                                <span v-show="judgeRequired('jpLastName', form[paymentType].jpLastName)"
                                                  class="required-tip">{{
                                                    $t('message.validator.required') }}</span>
                                              </div>
                                            </template>
                                            <el-input maxlength="64" autocomplete="off"
                                              v-model="form[paymentType].jpLastName" placeholder="名/カタカナ"
                                              @focus="sendPaymentInfoFocusEvent('jpLastName')"
                                              @change="sendPaymentInfoInputEvent('jpLastName')" />
                                          </el-form-item>
                                        </el-col>
                                      </el-row>
                                    </el-col>
                                  </template>
                                </template>
                              </el-row>
                              <el-row :gutter="device.device === 'WAP' ? 5 : 30" class="fields-row"
                                v-if="item && item.cardName === 'CARD' && order.canInstallment">
                                <!-- 分期 -->
                                <el-col :sm="24" :md="24" :lg="24" :xl="24">
                                  <el-form-item prop="periodValue" :label="$t('message.checkout.intallment')">
                                    <el-select v-model="form.CARD.periodValue" :disabled="instalmentDisabled"
                                      :placeholder="$t('message.checkout.intallment')" popper-class="loading-select"
                                      @focus="getInstalmentList" filterable autocomplete="off" auto-complete="off"
                                      @visible-change="clickSelectHandler($event, 'billing', 'periodValue')"
                                      @change="sendBillingInfoInputEvent('periodValue')">
                                      <template v-if="!instalmentLoading && instalmentInfo && instalmentInfo.stages">
                                        <template v-for="(instalmentItem, index) in instalmentInfo.stages">
                                          <el-option v-if="instalmentItem.stageNumber === '1'" :key="index"
                                            :value="instalmentItem.stageNumber"
                                            :label="`${$t('message.checkout.payInFull')}`"></el-option>
                                          <el-option v-else :key="index" :value="instalmentItem.stageNumber"
                                            :label="`${$t('message.checkout.payIn', { count: instalmentItem.stageNumber })} ${instalmentInfo.institution === 'DLOCAL' ? `- ${instalmentItem.stageName}` : ''}`">
                                          </el-option>
                                        </template>
                                      </template>
                                      <el-option v-if="instalmentLoading" :key="'loading'" label="加载中..." disabled
                                        value="loading" class="select-loading-item">
                                        <div class="installment-loading-pc" v-loading="instalmentLoading"
                                          element-loading-background="transparent"></div>
                                      </el-option>
                                    </el-select>
                                    <p v-if="!['', '1'].includes(form.CARD.periodValue)" class="intallment-text">{{
                                      $t('message.checkout.intallmentTip') }}</p>
                                  </el-form-item>
                                </el-col>
                              </el-row>
                            </div>
                            <!-- 子支付方式 -->
                            <div v-if="item.children && item.children.length" class="sub-payment-method">
                              <el-collapse accordion v-model="activeChildPaymentMethod">
                                <template v-for="(childPayMethod, childIdx) in item.children">
                                  <el-collapse-item :key="childIdx" :name="childIdx" :disabled="true"
                                    class="sub-method-collapse-item" :class="{ first: childIdx === 0 }">
                                    <template slot="title">
                                      <div class="sub-method-title">
                                        <el-radio fill="#182058" v-model="activeChildPaymentMethod" :label="childIdx"
                                          @change="subMethodChange" class="sub-method-radio">
                                          <span class="sub-method-img-wrapper">
                                            <img
                                              :src="childPayMethod.cardTypeInfo && childPayMethod.cardTypeInfo.length && childPayMethod.cardTypeInfo[0].logoPath" />
                                          </span>
                                          <span class="sub-method-name">{{ childPayMethod.cardTypeName }}</span>
                                        </el-radio>
                                      </div>
                                    </template>
                                    <!-- 子支付方式 支付信息 -->
                                    <div>
                                      <el-row :gutter="device.device === 'WAP' ? 5 : 30"
                                        v-if="childPayMethod.paymentConfigurationFields && childPayMethod.paymentConfigurationFields.length">
                                        <template
                                          v-for="(paymentField, paymentIndex) in childPayMethod.paymentConfigurationFields">
                                          <template v-if="paymentField.name === 'cardNum'">
                                            <el-col :key="paymentIndex" :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
                                              <el-form-item prop="cardNum" :label="$t('message.checkout.cardNumber')"
                                                :ref="`cardNumRef${childIdx}`">
                                                <template slot="label">
                                                  <div class="form-label">
                                                    <span>{{ $t('message.checkout.cardNumber') }}</span>
                                                    <span v-show="judgeRequired('cardNum', form.cardNum)"
                                                      class="required-tip">{{
                                                        $t('message.validator.required') }}</span>
                                                  </div>
                                                </template>
                                                <div>
                                                  <card-information :ref="`cardInformationRef${activePaymentMethod}`"
                                                    :rules="(item.children && item.children.length) ? (activeChildPaymentMethod === '' ? {} : item.children[activeChildPaymentMethod].rules) : item.rules"
                                                    :cardTypeInfo="item && item.cardTypeInfo"
                                                    :cardNum.sync="form[paymentType].cardNum"
                                                    :effectiveDate.sync="form[paymentType].effectiveDate"
                                                    :cvv.sync="form[paymentType].cvv" @cardNumberBlur="cardNumberBlur"
                                                    @inputFocus="handleCardInfoInputFocus"
                                                    @inputChange="handleCardInfoInputChange"></card-information>

                                                </div>
                                              </el-form-item>
                                            </el-col>
                                          </template>
                                          <template v-else-if="!['cardNum', 'jpLastName'].includes(paymentField.name)">
                                            <el-col
                                              v-if="paymentField.name != 'cardHolderName' || (paymentField.name === 'cardHolderName' && !hideCardHolderName)"
                                              :key="paymentIndex"
                                              :xs="['effectiveDate', 'cvv'].includes(paymentField.name) ? 12 : 24"
                                              :sm="24" :md="24" :lg="24" :xl="24">

                                              <el-form-item
                                                v-if="paymentField.name === 'cardHolderName' && !hideCardHolderName"
                                                :label="$t('message.checkout.holderName')" prop="cardHolderName"
                                                :ref="`cardHolderNameRef${childIdx}`">
                                                <template slot="label">
                                                  <div class="form-label">
                                                    <span>{{ $t('message.checkout.holderName') }}</span>
                                                    <span
                                                      v-show="judgeRequired('cardHolderName', form[paymentType].cardHolderName)"
                                                      class="required-tip">{{
                                                        $t('message.validator.required') }}</span>
                                                  </div>
                                                </template>
                                                <el-input maxlength="50" autocomplete="cc-name"
                                                  v-model="form[paymentType].cardHolderName"
                                                  :placeholder="$t('message.checkout.holderNameTips')"
                                                  @focus="sendPaymentInfoFocusEvent(paymentField.name)"
                                                  @change="sendPaymentInfoInputEvent(paymentField.name)" />
                                              </el-form-item>
                                              <el-form-item v-if="paymentField.name === 'walletAccountName'"
                                                :label="$t('message.checkout.walletAccountName')"
                                                prop="walletAccountName" :ref="`walletAccountNameRef${childIdx}`">
                                                <template slot="label">
                                                  <div class="form-label">
                                                    <span>{{ $t('message.checkout.walletAccountName') }}</span>
                                                    <span
                                                      v-show="judgeRequired('walletAccountName', form[paymentType].walletAccountName)"
                                                      class="required-tip">{{
                                                        $t('message.validator.required') }}</span>
                                                  </div>
                                                </template>
                                                <el-input maxlength="50" autocomplete="off"
                                                  v-model="form[paymentType].walletAccountName"
                                                  @focus="sendPaymentInfoFocusEvent(paymentField.name)"
                                                  @change="sendPaymentInfoInputEvent(paymentField.name)" />
                                              </el-form-item>
                                              <el-form-item v-if="paymentField.name === 'prepaidNumber'"
                                                :label="$t('message.checkout.cardNumber')" prop="prepaidNumber"
                                                :ref="`prepaidNumber${childIdx}`">
                                                <template slot="label">
                                                  <div class="form-label">
                                                    <span>{{ $t('message.checkout.cardNumber') }}</span>
                                                    <span
                                                      v-show="judgeRequired('prepaidNumber', form[paymentType].prepaidNumber)"
                                                      class="required-tip">{{
                                                        $t('message.validator.required') }}</span>
                                                  </div>
                                                </template>
                                                <el-input maxlength="16" autocomplete="off"
                                                  v-model="form[paymentType].prepaidNumber" inputmode="numeric"
                                                  @focus="sendPaymentInfoFocusEvent(paymentField.name)"
                                                  @change="sendPaymentInfoInputEvent(paymentField.name)" />
                                              </el-form-item>
                                              <el-form-item v-if="paymentField.name === 'blikcode'"
                                                :label="$t('message.checkout.blikcode')" prop="blikcode"
                                                :ref="`blikcode${childIdx}`">
                                                <template slot="label">
                                                  <div class="form-label">
                                                    <span>{{ $t('message.checkout.blikcode') }}</span>
                                                    <span v-show="judgeRequired('blikcode', form[paymentType].blikcode)"
                                                      class="required-tip">{{
                                                        $t('message.validator.required') }}</span>
                                                  </div>
                                                </template>
                                                <el-input autocomplete="off" v-model="form[paymentType].blikcode"
                                                  :maxlength="6" @focus="sendPaymentInfoFocusEvent(paymentField.name)"
                                                  @change="sendPaymentInfoInputEvent(paymentField.name)"></el-input>
                                              </el-form-item>
                                              <el-form-item v-if="paymentField.name === 'identityNumber'"
                                                :label="identityNumberFormLabel" prop="identityNumber"
                                                :ref="`identityNumberRef${childIdx}`">
                                                <template slot="label">
                                                  <div class="form-label">
                                                    <span>{{ identityNumberFormLabel }}</span>
                                                    <span
                                                      v-show="judgeRequired('identityNumber', form[paymentType].identityNumber)"
                                                      class="required-tip">{{
                                                        $t('message.validator.required') }}</span>
                                                  </div>
                                                </template>
                                                <el-input maxlength="64" autocomplete="off"
                                                  v-model="form[paymentType].identityNumber"
                                                  @input="onIdentityNumberInput"
                                                  @focus="sendPaymentInfoFocusEvent(paymentField.name)"
                                                  @change="sendPaymentInfoInputEvent(paymentField.name)" />
                                              </el-form-item>
                                              <el-form-item v-if="paymentField.name === 'birthDate'"
                                                @input.native="birthDateChangeHandler"
                                                :label="$t('message.checkout.birthDate')" prop="birthDate"
                                                :ref="`birthDateRef${childIdx}`">
                                                <template slot="label">
                                                  <div class="form-label">
                                                    <span>{{ $t('message.checkout.birthDate') }}</span>
                                                    <span
                                                      v-show="judgeRequired('birthDate', form[paymentType].birthDate)"
                                                      class="required-tip">{{
                                                        $t('message.validator.required') }}</span>
                                                  </div>
                                                </template>
                                                <el-input maxlength="14" autocomplete="off"
                                                  v-model="form[paymentType].birthDate" placeholder="YYYY / MM / DD"
                                                  @focus="sendPaymentInfoFocusEvent(paymentField.name)"
                                                  @change="sendPaymentInfoInputEvent(paymentField.name)" />
                                              </el-form-item>
                                              <el-form-item v-if="paymentField.name === 'bankName'"
                                                :label="$t('message.checkout.bankName')" prop="bankName"
                                                :ref="`bankNameRef${childIdx}`">
                                                <template slot="label">
                                                  <div class="form-label">
                                                    <span>{{ $t('message.checkout.bankName') }}</span>
                                                    <span v-show="judgeRequired('bankName', form[paymentType].bankName)"
                                                      class="required-tip">{{
                                                        $t('message.validator.required') }}</span>
                                                  </div>
                                                </template>
                                                <el-select filterable v-model="form[paymentType].bankName"
                                                  :error="judgeRequired('bankName', form[paymentType].bankName)"
                                                  @visible-change="clickSelectHandler($event, 'payment', paymentField.name)"
                                                  @change="sendPaymentInfoInputEvent(paymentField.name)">
                                                  <el-option
                                                    v-for="(bank, bankIndex) in (BANK_OPTIONS[item.cardName] || [])"
                                                    :key="bankIndex" :value="bank.code" :label="bank.name"></el-option>
                                                </el-select>
                                              </el-form-item>
                                              <el-form-item v-if="paymentField.name === 'iBan'"
                                                :label="$t('message.checkout.iBan')" prop="iBan"
                                                :ref="`iBanRef${childIdx}`">
                                                <template slot="label">
                                                  <div class="form-label">
                                                    <span>{{ $t('message.checkout.iBan') }}</span>
                                                    <span v-show="judgeRequired('iBan', form[paymentType].iBan)"
                                                      class="required-tip">{{
                                                        $t('message.validator.required') }}</span>
                                                  </div>
                                                </template>
                                                <el-input maxlength="64" autocomplete="off"
                                                  v-model="form[paymentType].iBan"
                                                  @focus="sendPaymentInfoFocusEvent(paymentField.name)"
                                                  @change="sendPaymentInfoInputEvent(paymentField.name)" />
                                              </el-form-item>
                                              <el-row :gutter="device.device === 'WAP' ? 5 : 10"
                                                v-if="paymentField.name === 'jpFirstName'">
                                                <el-col :xs="12" :sm="12" :md="12" :lg="12" :xl="12">
                                                  <el-form-item label="姓/カタカナ" prop="jpFirstName"
                                                    :ref="`jpFirstNameRef${childIdx}`" class="nowrap-text">
                                                    <template slot="label">
                                                      <div class="form-label">
                                                        <span>姓/カタカナ</span>
                                                        <span
                                                          v-show="judgeRequired('jpFirstName', form[paymentType].jpFirstName)"
                                                          class="required-tip">{{
                                                            $t('message.validator.required') }}</span>
                                                      </div>
                                                    </template>
                                                    <el-input maxlength="64" autocomplete="off"
                                                      v-model="form[paymentType].jpFirstName" placeholder="姓/カタカナ"
                                                      @focus="sendPaymentInfoFocusEvent(paymentField.name)"
                                                      @change="sendPaymentInfoInputEvent(paymentField.name)" />
                                                  </el-form-item>
                                                </el-col>
                                                <el-col :xs="12" :sm="12" :md="12" :lg="12" :xl="12">
                                                  <el-form-item label="名/カタカナ" prop="jpLastName"
                                                    :ref="`jpLastNameRef${childIdx}`" class="margin-top-0">
                                                    <template slot="label">
                                                      <div class="form-label">
                                                        <span>名/カタカナ</span>
                                                        <span
                                                          v-show="judgeRequired('jpLastName', form[paymentType].jpLastName)"
                                                          class="required-tip">{{
                                                            $t('message.validator.required') }}</span>
                                                      </div>
                                                    </template>
                                                    <el-input maxlength="64" autocomplete="off"
                                                      v-model="form[paymentType].jpLastName" placeholder="名/カタカナ"
                                                      @focus="sendPaymentInfoFocusEvent('jpLastName')"
                                                      @change="sendPaymentInfoInputEvent('jpLastName')" />
                                                  </el-form-item>
                                                </el-col>
                                              </el-row>
                                            </el-col>
                                          </template>
                                        </template>
                                      </el-row>
                                    </div>
                                    <div>
                                      <div
                                        v-if="childPayMethod.billConfigurationFields && childPayMethod.billConfigurationFields.length">
                                        <div class="billing-title">{{ $t('message.checkout.billingAddress') }}</div>
                                        <div class="margin-top-10">
                                          <el-row :gutter="device.device === 'WAP' ? 5 : 30">
                                            <template
                                              v-for="(field, fieldIndex) in childPayMethod.billConfigurationFields">
                                              <!-- 子支付方式只有非本地支付存在: 账单地址 -->
                                              <!-- 国家 -->
                                              <el-col v-if="field.name === 'country'" :key="fieldIndex" :xs="24"
                                                :sm="24" :md="24" :lg="24" :xl="24">
                                                <el-form-item :label="$t('message.checkout.country')" prop="country"
                                                  :ref="`countryRef${childIdx}`">
                                                  <template slot="label">
                                                    <div class="form-label">
                                                      <span>{{ $t('message.checkout.country') }}</span>
                                                      <span v-show="judgeRequired('country', form.LOCAL.country)"
                                                        class="required-tip">{{
                                                          $t('message.validator.required') }}</span>
                                                    </div>
                                                  </template>
                                                  <on-select disabled filterable v-model="form.LOCAL.country" :options="COUNTRY_OPTIONS.map(item => ({
                                                    label: $t(`message.country.${item.code}`),
                                                    value: item.code
                                                  }))">
                                                  </on-select>
                                                </el-form-item>
                                              </el-col>
                                              <!-- 州 -->
                                              <el-col v-if="field.name === 'province'" :key="fieldIndex" :xs="24"
                                                :sm="24" :md="24" :lg="24" :xl="24">
                                                <el-form-item :label="$t('message.checkout.province')" prop="province"
                                                  :ref="`provinceRef${childIdx}`">
                                                  <template slot="label">
                                                    <div class="form-label">
                                                      <span>{{ $t('message.checkout.province') }}</span>
                                                      <span v-show="judgeRequired('province', form.LOCAL.country)"
                                                        class="required-tip">{{
                                                          $t('message.validator.required') }}</span>
                                                    </div>
                                                  </template>
                                                  <!-- 国家为【US/CA/CN】时为select,其它为input -->
                                                  <on-select v-if="selectStateCountry.includes(form.LOCAL.country)"
                                                    filterable v-model="form.LOCAL.province"
                                                    :error="judgeRequired('province', form.LOCAL.province)"
                                                    @visible-change="clickSelectHandler($event, 'billing', field.name)"
                                                    @change="sendBillingInfoInputEvent(field.name)" :options="STATES_OPTIONS[form.LOCAL.country].map(item => ({
                                                      label: $t(`message.state.${form.LOCAL.country}.${item.value}`),
                                                      value: item.value
                                                    }))">
                                                    <!-- <el-option v-for="(s, sindex) in STATES_OPTIONS[form.LOCAL.country]"
                                                    :key="sindex" :value="s.value"
                                                    :label="$t(`message.state.${form.LOCAL.country}.${s.value}`)"></el-option> -->
                                                  </on-select>
                                                  <el-input v-else maxlength="64" v-model="form.LOCAL.province"
                                                    autocomplete="address-level1"
                                                    @focus="sendBillingInfoFocusEvent(field.name)"
                                                    @change="sendBillingInfoInputEvent(field.name)" />
                                                </el-form-item>
                                              </el-col>
                                              <!-- Address -->
                                              <el-col v-if="field.name === 'address'" :key="fieldIndex" :xs="24"
                                                :sm="24" :md="24" :lg="24" :xl="24">
                                                <el-form-item :label="$t('message.checkout.address')" prop="address"
                                                  :ref="`addressRef${childIdx}`">
                                                  <template slot="label">
                                                    <div class="form-label">
                                                      <span>{{ $t('message.checkout.address') }}</span>
                                                      <span v-show="judgeRequired('address', form.LOCAL.address)"
                                                        class="required-tip">{{
                                                          $t('message.validator.required') }}</span>
                                                    </div>
                                                  </template>
                                                  <el-input maxlength="256" autocomplete="street-address"
                                                    type="textarea" :resize="'false'"
                                                    :autosize="{ minRows: 3, maxRows: 3 }" v-model="form.LOCAL.address"
                                                    @focus="sendBillingInfoFocusEvent(field.name)"
                                                    @change="sendBillingInfoInputEvent(field.name)" />
                                                </el-form-item>
                                              </el-col>
                                              <!-- Town/City -->
                                              <el-col v-if="field.name === 'city'" :key="fieldIndex" :xs="24" :sm="24"
                                                :md="24" :lg="24" :xl="24">
                                                <el-form-item :label="$t('message.checkout.city')" prop="city"
                                                  :ref="`cityRef${childIdx}`">
                                                  <template slot="label">
                                                    <div class="form-label">
                                                      <span>{{ $t('message.checkout.city') }}</span>
                                                      <span v-show="judgeRequired('city', form.LOCAL.city)"
                                                        class="required-tip">{{
                                                          $t('message.validator.required') }}</span>
                                                    </div>
                                                  </template>
                                                  <el-input maxlength="64" autocomplete="off" v-model="form.LOCAL.city"
                                                    @focus="sendBillingInfoFocusEvent(field.name)"
                                                    @change="sendBillingInfoInputEvent(field.name)" />
                                                </el-form-item>
                                              </el-col>
                                              <!-- 邮编 -->
                                              <el-col v-if="field.name === 'postalCode'" :key="fieldIndex" :xs="24"
                                                :sm="24" :md="24" :lg="24" :xl="24">
                                                <el-form-item :label="$t('message.checkout.postalCode')"
                                                  prop="postalCode" :ref="`postalCodeRef${childIdx}`">
                                                  <template slot="label">
                                                    <div class="form-label">
                                                      <span>{{ $t('message.checkout.postalCode') }}</span>
                                                      <span v-show="judgeRequired('postalCode', form.LOCAL.postalCode)"
                                                        class="required-tip">{{
                                                          $t('message.validator.required') }}</span>
                                                    </div>
                                                  </template>
                                                  <el-input maxlength="32" autocomplete="postal-code"
                                                    v-model="form.LOCAL.postalCode" @input="onPostalCodeInput"
                                                    @focus="sendBillingInfoFocusEvent(field.name)"
                                                    @change="sendBillingInfoInputEvent(field.name)" />
                                                </el-form-item>
                                              </el-col>
                                              <!-- 邮箱 -->
                                              <el-col v-if="field.name === 'email'" :key="fieldIndex" :xs="24" :sm="24"
                                                :md="24" :lg="24" :xl="24">
                                                <el-form-item :label="$t('message.checkout.email')" prop="email"
                                                  :ref="`emailRef${childIdx}`">
                                                  <template slot="label">
                                                    <div class="form-label">
                                                      <span>{{ $t('message.checkout.email') }}</span>
                                                      <span v-show="judgeRequired('email', form.LOCAL.email)"
                                                        class="required-tip">{{
                                                          $t('message.validator.required') }}</span>
                                                    </div>
                                                  </template>
                                                  <el-autocomplete :maxlength="256" autocomplete="email"
                                                    v-model="form.LOCAL.email" :trigger-on-focus="false"
                                                    :fetch-suggestions="queryEmailSearch"
                                                    @focus="sendBillingInfoFocusEvent(field.name)"
                                                    @change="sendBillingInfoInputEvent(field.name)" />
                                                </el-form-item>
                                              </el-col>
                                              <!-- Contact Name -->
                                              <el-col v-if="field.name === 'firstName'" :key="fieldIndex" :xs="24"
                                                :sm="24" :md="24" :lg="24" :xl="24">
                                                <el-row :gutter="device.device === 'WAP' ? 6 : 10">
                                                  <el-col :xs="12" :sm="12" :md="12" :lg="12" :xl="12">
                                                    <el-form-item
                                                      :label="lang === 'ja' ? $t('message.checkout.firstName') : $t('message.checkout.contactName')"
                                                      prop="firstName" :ref="`firstNameRef${childIdx}`"
                                                      class="nowrap-text">
                                                      <template slot="label">
                                                        <div class="form-label">
                                                          <span>{{ lang === 'ja' ? $t('message.checkout.firstName') :
                                                            $t('message.checkout.contactName') }}</span>
                                                          <span
                                                            v-show="judgeRequired('firstName', form.LOCAL.firstName)"
                                                            class="required-tip">{{
                                                              $t('message.validator.required') }}</span>
                                                        </div>
                                                      </template>
                                                      <el-input maxlength="64" autocomplete="off"
                                                        v-model="form.LOCAL.firstName"
                                                        :placeholder="$t('message.checkout.firstName')"
                                                        @focus="sendBillingInfoFocusEvent(field.name)"
                                                        @change="sendBillingInfoInputEvent(field.name)" />
                                                    </el-form-item>
                                                  </el-col>
                                                  <el-col :xs="12" :sm="12" :md="12" :lg="12" :xl="12">
                                                    <el-form-item
                                                      :label="lang === 'ja' ? $t('message.checkout.lastName') : ''"
                                                      prop="lastName" :ref="`lastNameRef${childIdx}`">
                                                      <template slot="label">
                                                        <div class="form-label">
                                                          <span>{{ lang === 'ja' ? $t('message.checkout.lastName') :
                                                            '&nbsp;' }}</span>
                                                          <span v-show="judgeRequired('lastName', form.LOCAL.lastName)"
                                                            class="required-tip">{{
                                                              $t('message.validator.required') }}</span>
                                                        </div>
                                                      </template>
                                                      <el-input maxlength="64" autocomplete="off"
                                                        v-model="form.LOCAL.lastName"
                                                        :placeholder="$t('message.checkout.lastName')"
                                                        @focus="sendBillingInfoFocusEvent('lastName')"
                                                        @change="sendBillingInfoInputEvent('lastName')" />
                                                    </el-form-item>
                                                  </el-col>
                                                </el-row>
                                              </el-col>
                                              <!-- 手机号码 -->
                                              <el-col v-if="field.name === 'phone'" :key="fieldIndex" :xs="24" :sm="24"
                                                :md="24" :lg="24" :xl="24">
                                                <el-form-item :label="$t('message.checkout.phone')" prop="phone"
                                                  :ref="`phoneRef${childIdx}`">
                                                  <template slot="label">
                                                    <div class="form-label">
                                                      <span>{{ $t('message.checkout.phone') }}</span>
                                                      <span v-show="judgeRequired('phone', form.LOCAL.phone)"
                                                        class="required-tip">{{
                                                          $t('message.validator.required') }}</span>
                                                    </div>
                                                  </template>
                                                  <el-input type="number" maxlength="32" autocomplete="off"
                                                    inputmode="numeric" v-model="form.LOCAL.phone"
                                                    @focus="sendBillingInfoFocusEvent(field.name)"
                                                    @change="sendBillingInfoInputEvent(field.name)" />
                                                </el-form-item>
                                              </el-col>
                                              <!-- Street -->
                                              <el-col v-if="field.name === 'street'" :key="fieldIndex" :xs="24" :sm="24"
                                                :md="24" :lg="24" :xl="24">
                                                <el-form-item :label="$t('message.checkout.street')" prop="street"
                                                  :ref="`streetRef${childIdx}`">
                                                  <template slot="label">
                                                    <div class="form-label">
                                                      <span>{{ $t('message.checkout.street') }}</span>
                                                      <span v-show="judgeRequired('street', form.LOCAL.street)"
                                                        class="required-tip">{{
                                                          $t('message.validator.required') }}</span>
                                                    </div>
                                                  </template>
                                                  <el-input maxlength="64" autocomplete="off"
                                                    v-model="form.LOCAL.street"
                                                    @focus="sendBillingInfoFocusEvent(field.name)"
                                                    @change="sendBillingInfoInputEvent(field.name)" />
                                                </el-form-item>
                                              </el-col>
                                              <!-- 门牌号 -->
                                              <el-col v-if="field.name === 'number'" :key="fieldIndex" :xs="24" :sm="24"
                                                :md="24" :lg="24" :xl="24">
                                                <el-form-item :label="$t('message.checkout.number')" prop="number"
                                                  :ref="`numberRef${childIdx}`">
                                                  <template slot="label">
                                                    <div class="form-label">
                                                      <span>{{ $t('message.checkout.number') }}</span>
                                                      <span v-show="judgeRequired('number', form.LOCAL.number)"
                                                        class="required-tip">{{
                                                          $t('message.validator.required') }}</span>
                                                    </div>
                                                  </template>
                                                  <el-input maxlength="64" autocomplete="off"
                                                    v-model="form.LOCAL.number"
                                                    @focus="sendBillingInfoFocusEvent(field.name)"
                                                    @change="sendBillingInfoInputEvent(field.name)" />
                                                </el-form-item>
                                              </el-col>
                                            </template>
                                          </el-row>
                                        </div>
                                      </div>
                                    </div>
                                    <div class="btns" style="padding: 0;">
                                      <!-- <el-button @click="submit" type="primary" class="btn-submit margin-top-12">
                                      {{ $t('message.checkout.pay') }} {{ order && order.txnAmount }} {{ order && order.txnCurrency }}
                                    </el-button> -->
                                      <on-button @click="submit" type="primary" class="margin-top-12"
                                        :loading="submitBtnLoading">
                                        {{ $t('message.checkout.pay') }} {{ order && formatAmount(order.txnAmount) }} {{
                                          order && order.txnCurrency
                                        }}
                                      </on-button>
                                    </div>
                                  </el-collapse-item>
                                </template>
                              </el-collapse>
                            </div>
                            <!-- 没有子支付方式的账单地址 -->
                            <div v-if="item.billConfigurationFields && item.billConfigurationFields.length"
                              class="billing-section">
                              <!-- class="billing-title margin-top-5 mobile-padding" -->
                              <h2 class="billing-title" style="padding-top: 0;"
                                @click="showBillingForm = !showBillingForm"
                                :class="[onlyShowCardPayMethod ? 'margin-top-5 mobile-padding' : 'mobile-padding padding-left-10 padding-right-10']">
                                {{ $t('message.checkout.billingAddress') }}
                                <img src="@/componentsV2/busi/PaymentForm/arror.png"
                                  :class="{ 'arrow-open': !showBillingForm }" class="arrow-icon" />
                              </h2>
                              <transition name="collapse">
                                <div class="margin-top-20 mobile-padding" v-show="showBillingForm"
                                  :class="[onlyShowCardPayMethod ? '' : 'padding-left-10 padding-right-10']">
                                  <el-row :gutter="device.device === 'WAP' ? 5 : 30">
                                    <template v-for="(field, fieldIndex) in item.billConfigurationFields">
                                      <!-- 卡支付账单地址 -->
                                      <template v-if="item && item.cardName === 'CARD'">
                                        <!-- 国家 -->
                                        <el-col v-if="field.name === 'country'" :key="fieldIndex" :xs="24" :sm="24"
                                          :md="24" :lg="24" :xl="24">
                                          <el-form-item :label="$t('message.checkout.country')" prop="country"
                                            ref="countryRefCard">
                                            <template slot="label">
                                              <div class="form-label">
                                                <span>{{ $t('message.checkout.country') }}</span>
                                                <span v-show="judgeRequired('country', form.LOCAL.country)"
                                                  class="required-tip">{{
                                                    $t('message.validator.required') }}</span>
                                              </div>
                                            </template>
                                            <on-select filterable v-model="form.CARD.country"
                                              autocomplete="new-password" auto-complete="new-password" disabled
                                              :options="COUNTRY_OPTIONS.map(item => ({
                                                label: $t(`message.country.${item.code}`),
                                                value: item.code
                                              }))">
                                            </on-select>
                                          </el-form-item>
                                        </el-col>
                                        <!-- 州 -->
                                        <el-col v-if="field.name === 'province'" :key="fieldIndex" :xs="24" :sm="24"
                                          :md="24" :lg="24" :xl="24">
                                          <el-form-item :label="$t('message.checkout.province')" prop="province"
                                            ref="provinceRefCard">
                                            <template slot="label">
                                              <div class="form-label">
                                                <span>{{ $t('message.checkout.province') }}</span>
                                                <span v-show="judgeRequired('province', form.CARD.province)"
                                                  class="required-tip">{{
                                                    $t('message.validator.required') }}</span>
                                              </div>
                                            </template>
                                            <!-- 国家为【US/CA】时为select,其它为input -->
                                            <on-select v-if="selectStateCountry.includes(form.CARD.country)" filterable
                                              v-model="form.CARD.province"
                                              :error="judgeRequired('province', form.CARD.province)"
                                              @visible-change="clickSelectHandler($event, 'billing', field.name)"
                                              @change="sendBillingInfoInputEvent(field.name)" :options="STATES_OPTIONS[form.CARD.country].map(item => ({
                                                label: $t(`message.state.${form.CARD.country}.${item.value}`),
                                                value: item.value
                                              }))">
                                              <!-- <el-option v-for="(s, sindex) in STATES_OPTIONS[form.CARD.country]"
                                            :key="sindex" :label="$t(`message.state.${form.CARD.country}.${s.value}`)"
                                            :value="s.value"></el-option> -->
                                            </on-select>
                                            <el-input v-else maxlength="64" autocomplete="address-level1"
                                              v-model="form.CARD.province"
                                              @focus="sendBillingInfoFocusEvent(field.name)"
                                              @change="sendBillingInfoInputEvent(field.name)" />
                                          </el-form-item>
                                        </el-col>
                                        <!-- Address -->
                                        <el-col v-if="field.name === 'address'" :key="fieldIndex" :xs="24" :sm="24"
                                          :md="24" :lg="24" :xl="24">
                                          <el-form-item :label="$t('message.checkout.address')" prop="address"
                                            ref="addressRefCard">
                                            <template slot="label">
                                              <div class="form-label">
                                                <span>{{ $t('message.checkout.address') }}</span>
                                                <span v-show="judgeRequired('address', form.CARD.address)"
                                                  class="required-tip">{{
                                                    $t('message.validator.required') }}</span>
                                              </div>
                                            </template>
                                            <el-input maxlength="256" autocomplete="street-address" type="textarea"
                                              :resize="'false'" :autosize="{ minRows: 3, maxRows: 3 }"
                                              v-model="form.CARD.address" @focus="sendBillingInfoFocusEvent(field.name)"
                                              @change="sendBillingInfoInputEvent(field.name)" />
                                          </el-form-item>
                                        </el-col>
                                        <!-- Town/City -->
                                        <el-col v-if="field.name === 'city'" :key="fieldIndex" :xs="24" :sm="24"
                                          :md="24" :lg="24" :xl="24">
                                          <el-form-item :label="$t('message.checkout.city')" prop="city"
                                            ref="cityRefCard">
                                            <template slot="label">
                                              <div class="form-label">
                                                <span>{{ $t('message.checkout.city') }}</span>
                                                <span v-show="judgeRequired('city', form.CARD.city)"
                                                  class="required-tip">{{
                                                    $t('message.validator.required') }}</span>
                                              </div>
                                            </template>
                                            <el-input maxlength="64" autocomplete="address-level2"
                                              v-model="form.CARD.city" @focus="sendBillingInfoFocusEvent(field.name)"
                                              @change="sendBillingInfoInputEvent(field.name)" />
                                          </el-form-item>
                                        </el-col>
                                        <!-- 邮编 -->
                                        <el-col v-if="field.name === 'postalCode'" :key="fieldIndex" :xs="24" :sm="24"
                                          :md="24" :lg="24" :xl="24">
                                          <el-form-item :label="$t('message.checkout.postalCode')" prop="postalCode"
                                            ref="postalCodeRefCard">
                                            <template slot="label">
                                              <div class="form-label">
                                                <span>{{ $t('message.checkout.postalCode') }}</span>
                                                <span v-show="judgeRequired('postalCode', form.CARD.postalCode)"
                                                  class="required-tip">{{
                                                    $t('message.validator.required') }}</span>
                                              </div>
                                            </template>
                                            <el-input maxlength="32" autocomplete="postal-code"
                                              v-model="form.CARD.postalCode" @input="onPostalCodeInput"
                                              @focus="sendBillingInfoFocusEvent(field.name)"
                                              @change="sendBillingInfoInputEvent(field.name)" />
                                          </el-form-item>
                                        </el-col>
                                        <!-- 邮箱 -->
                                        <el-col v-if="field.name === 'email'" :key="fieldIndex" :xs="24" :sm="24"
                                          :md="24" :lg="24" :xl="24">
                                          <el-form-item :label="$t('message.checkout.email')" prop="email"
                                            ref="emailRefCard">
                                            <template slot="label">
                                              <div class="form-label">
                                                <span>{{ $t('message.checkout.email') }}</span>
                                                <span v-show="judgeRequired('email', form.CARD.email)"
                                                  class="required-tip">{{
                                                    $t('message.validator.required') }}</span>
                                              </div>
                                            </template>
                                            <el-autocomplete :maxlength="256" autocomplete="email"
                                              v-model="form.CARD.email" :trigger-on-focus="false"
                                              :fetch-suggestions="queryEmailSearch"
                                              @focus="sendBillingInfoFocusEvent(field.name)"
                                              @change="sendBillingInfoInputEvent(field.name)" />
                                          </el-form-item>
                                        </el-col>
                                        <!-- Contact Name -->
                                        <el-col v-if="field.name === 'firstName'" :key="fieldIndex" :xs="24" :sm="24"
                                          :md="24" :lg="24" :xl="24">
                                          <el-row :gutter="device.device === 'WAP' ? 6 : 10">
                                            <el-col :xs="12" :sm="12" :md="12" :lg="12" :xl="12">
                                              <el-form-item
                                                :label="lang === 'ja' ? $t('message.checkout.firstName') : $t('message.checkout.contactName')"
                                                prop="firstName" ref="firstNameRefCard" class="nowrap-text">
                                                <template slot="label">
                                                  <div class="form-label">
                                                    <span>{{ lang === 'ja' ? $t('message.checkout.firstName') :
                                                      $t('message.checkout.contactName') }}</span>
                                                    <span v-show="judgeRequired('firstName', form.CARD.firstName)"
                                                      class="required-tip">{{
                                                        $t('message.validator.required') }}</span>
                                                  </div>
                                                </template>
                                                <el-input maxlength="64" autocomplete="off"
                                                  v-model="form.CARD.firstName"
                                                  :placeholder="$t('message.checkout.firstName')"
                                                  @focus="sendBillingInfoFocusEvent(field.name)"
                                                  @change="sendBillingInfoInputEvent(field.name)" />
                                              </el-form-item>
                                            </el-col>
                                            <el-col :xs="12" :sm="12" :md="12" :lg="12" :xl="12">
                                              <el-form-item
                                                :label="lang === 'ja' ? $t('message.checkout.lastName') : ''"
                                                prop="lastName" ref="lastNameRefCard">
                                                <template slot="label">
                                                  <div class="form-label">
                                                    <span>{{ lang === 'ja' ? $t('message.checkout.lastName') : '&nbsp;'
                                                    }}</span>
                                                    <span v-show="judgeRequired('lastName', form.CARD.lastName)"
                                                      class="required-tip">{{
                                                        $t('message.validator.required') }}</span>
                                                  </div>
                                                </template>
                                                <el-input maxlength="64" autocomplete="off" v-model="form.CARD.lastName"
                                                  :placeholder="$t('message.checkout.lastName')"
                                                  @focus="sendBillingInfoFocusEvent('lastName')"
                                                  @change="sendBillingInfoInputEvent('lastName')" />
                                              </el-form-item>
                                            </el-col>
                                          </el-row>
                                        </el-col>
                                        <!-- 手机号码 -->
                                        <el-col v-if="field.name === 'phone'" :key="fieldIndex" :xs="24" :sm="24"
                                          :md="24" :lg="24" :xl="24">
                                          <el-form-item :label="$t('message.checkout.phone')" prop="phone"
                                            ref="phoneRefCard">
                                            <template slot="label">
                                              <div class="form-label">
                                                <span>{{ $t('message.checkout.phone') }}</span>
                                                <span v-show="judgeRequired('phone', form.CARD.phone)"
                                                  class="required-tip">{{
                                                    $t('message.validator.required') }}</span>
                                              </div>
                                            </template>
                                            <el-input inputmode="numeric" type="number" maxlength="32"
                                              autocomplete="off" v-model="form.CARD.phone"
                                              @focus="sendBillingInfoFocusEvent(field.name)"
                                              @change="sendBillingInfoInputEvent(field.name)" />
                                          </el-form-item>
                                        </el-col>
                                        <!-- Street -->
                                        <el-col v-if="field.name === 'street'" :key="fieldIndex" :xs="24" :sm="24"
                                          :md="24" :lg="24" :xl="24">
                                          <el-form-item :label="$t('message.checkout.street')" prop="street"
                                            ref="streetRefCard">
                                            <template slot="label">
                                              <div class="form-label">
                                                <span>{{ $t('message.checkout.street') }}</span>
                                                <span v-show="judgeRequired('street', form.CARD.street)"
                                                  class="required-tip">{{
                                                    $t('message.validator.required') }}</span>
                                              </div>
                                            </template>
                                            <el-input maxlength="64" autocomplete="off" v-model="form.CARD.street"
                                              @focus="sendBillingInfoFocusEvent(field.name)"
                                              @change="sendBillingInfoInputEvent(field.name)" />
                                          </el-form-item>
                                        </el-col>
                                        <!-- 门牌号 -->
                                        <el-col v-if="field.name === 'number'" :key="fieldIndex" :xs="24" :sm="24"
                                          :md="24" :lg="24" :xl="24">
                                          <el-form-item :label="$t('message.checkout.number')" prop="number"
                                            ref="numberRefCard">
                                            <template slot="label">
                                              <div class="form-label">
                                                <span>{{ $t('message.checkout.number') }}</span>
                                                <span v-show="judgeRequired('number', form.CARD.number)"
                                                  class="required-tip">{{
                                                    $t('message.validator.required') }}</span>
                                              </div>
                                            </template>
                                            <el-input maxlength="64" autocomplete="off" v-model="form.CARD.number"
                                              @focus="sendBillingInfoFocusEvent(field.name)"
                                              @change="sendBillingInfoInputEvent(field.name)" />
                                          </el-form-item>
                                        </el-col>
                                      </template>
                                      <!-- 本地支付账单地址 -->
                                      <template v-if="item && item.cardName !== 'CARD'">
                                        <!-- 国家 -->
                                        <el-col v-if="field.name === 'country'" :key="fieldIndex" :xs="24" :sm="24"
                                          :md="24" :lg="24" :xl="24">
                                          <el-form-item :label="$t('message.checkout.country')" prop="country"
                                            ref="countryRef">
                                            <template slot="label">
                                              <div class="form-label">
                                                <span>{{ $t('message.checkout.country') }}</span>
                                                <span v-show="judgeRequired('country', form.LOCAL.country)"
                                                  class="required-tip">{{
                                                    $t('message.validator.required') }}</span>
                                              </div>
                                            </template>
                                            <on-select disabled filterable v-model="form.LOCAL.country"
                                              autocomplete="new-password" auto-complete="new-password" :options="COUNTRY_OPTIONS.map(item => ({
                                                label: $t(`message.country.${item.code}`),
                                                value: item.code
                                              }))">
                                            </on-select>
                                          </el-form-item>
                                        </el-col>
                                        <!-- 州 -->
                                        <el-col v-if="field.name === 'province'" :key="fieldIndex" :xs="24" :sm="24"
                                          :md="24" :lg="24" :xl="24">
                                          <el-form-item :label="$t('message.checkout.province')" prop="province"
                                            ref="provinceRef">
                                            <template slot="label">
                                              <div class="form-label">
                                                <span>{{ $t('message.checkout.province') }}</span>
                                                <span v-show="judgeRequired('province', form.LOCAL.province)"
                                                  class="required-tip">{{
                                                    $t('message.validator.required') }}</span>
                                              </div>
                                            </template>
                                            <!-- 国家为【US/CA】时为select,其它为input -->
                                            <on-select v-if="selectStateCountry.includes(form.LOCAL.country)" filterable
                                              v-model="form.LOCAL.province"
                                              :error="judgeRequired('province', form.LOCAL.province)"
                                              @visible-change="clickSelectHandler($event, 'billing', field.name)"
                                              @change="sendBillingInfoInputEvent(field.name)" :options="STATES_OPTIONS[form.LOCAL.country].map(item => ({
                                                label: $t(`message.state.${form.LOCAL.country}.${item.value}`),
                                                value: item.value
                                              }))">
                                              <!-- <el-option v-for="(s, sindex) in STATES_OPTIONS[form.LOCAL.country]"
                                            :key="sindex" :value="s.value"
                                            :label="$t(`message.state.${form.LOCAL.country}.${s.value}`)"></el-option> -->
                                            </on-select>
                                            <el-input v-else maxlength="64" v-model="form.LOCAL.province"
                                              autocomplete="address-level1"
                                              @focus="sendBillingInfoFocusEvent(field.name)"
                                              @change="sendBillingInfoInputEvent(field.name)" />
                                          </el-form-item>
                                        </el-col>
                                        <!-- Address -->
                                        <el-col v-if="field.name === 'address'" :key="fieldIndex" :xs="24" :sm="24"
                                          :md="24" :lg="24" :xl="24">
                                          <el-form-item :label="$t('message.checkout.address')" prop="address"
                                            ref="addressRef">
                                            <template slot="label">
                                              <div class="form-label">
                                                <span>{{ $t('message.checkout.address') }}</span>
                                                <span v-show="judgeRequired('address', form.LOCAL.address)"
                                                  class="required-tip">{{
                                                    $t('message.validator.required') }}</span>
                                              </div>
                                            </template>
                                            <el-input maxlength="256" autocomplete="street-address" type="textarea"
                                              :resize="'false'" :autosize="{ minRows: 3, maxRows: 3 }"
                                              v-model="form.LOCAL.address"
                                              @focus="sendBillingInfoFocusEvent(field.name)"
                                              @change="sendBillingInfoInputEvent(field.name)" />
                                          </el-form-item>
                                        </el-col>
                                        <!-- Town/City -->
                                        <el-col v-if="field.name === 'city'" :key="fieldIndex" :xs="24" :sm="24"
                                          :md="24" :lg="24" :xl="24">
                                          <el-form-item :label="$t('message.checkout.city')" prop="city" ref="cityRef">
                                            <template slot="label">
                                              <div class="form-label">
                                                <span>{{ $t('message.checkout.city') }}</span>
                                                <span v-show="judgeRequired('city', form.LOCAL.city)"
                                                  class="required-tip">{{
                                                    $t('message.validator.required') }}</span>
                                              </div>
                                            </template>
                                            <el-input maxlength="64" autocomplete="address-level2"
                                              v-model="form.LOCAL.city" @focus="sendBillingInfoFocusEvent(field.name)"
                                              @change="sendBillingInfoInputEvent(field.name)" />
                                          </el-form-item>
                                        </el-col>
                                        <!-- 邮编 -->
                                        <el-col v-if="field.name === 'postalCode'" :key="fieldIndex" :xs="24" :sm="24"
                                          :md="24" :lg="24" :xl="24">
                                          <el-form-item :label="$t('message.checkout.postalCode')" prop="postalCode"
                                            ref="postalCodeRef">
                                            <template slot="label">
                                              <div class="form-label">
                                                <span>{{ $t('message.checkout.postalCode') }}</span>
                                                <span v-show="judgeRequired('postalCode', form.LOCAL.postalCode)"
                                                  class="required-tip">{{
                                                    $t('message.validator.required') }}</span>
                                              </div>
                                            </template>
                                            <el-input maxlength="32" autocomplete="postal-code"
                                              v-model="form.LOCAL.postalCode" @input="onPostalCodeInput"
                                              @focus="sendBillingInfoFocusEvent(field.name)"
                                              @change="sendBillingInfoInputEvent(field.name)" />
                                          </el-form-item>
                                        </el-col>
                                        <!-- 邮箱 -->
                                        <el-col v-if="field.name === 'email'" :key="fieldIndex" :xs="24" :sm="24"
                                          :md="24" :lg="24" :xl="24">
                                          <el-form-item :label="$t('message.checkout.email')" prop="email"
                                            ref="emailRef">
                                            <template slot="label">
                                              <div class="form-label">
                                                <span>{{ $t('message.checkout.email') }}</span>
                                                <span v-show="judgeRequired('email', form.LOCAL.email)"
                                                  class="required-tip">{{
                                                    $t('message.validator.required') }}</span>
                                              </div>
                                            </template>
                                            <el-autocomplete :maxlength="256" autocomplete="email"
                                              v-model="form.LOCAL.email" :trigger-on-focus="false"
                                              :fetch-suggestions="queryEmailSearch"
                                              @focus="sendBillingInfoFocusEvent(field.name)"
                                              @change="sendBillingInfoInputEvent(field.name)" />
                                          </el-form-item>
                                        </el-col>
                                        <!-- Contact Name -->
                                        <el-col v-if="field.name === 'firstName'" :key="fieldIndex" :xs="24" :sm="24"
                                          :md="24" :lg="24" :xl="24">
                                          <el-row :gutter="device.device === 'WAP' ? 5 : 10">
                                            <el-col :xs="12" :sm="12" :md="12" :lg="12" :xl="12">
                                              <el-form-item
                                                :label="lang === 'ja' ? $t('message.checkout.firstName') : $t('message.checkout.contactName')"
                                                prop="firstName" ref="firstNameRef" class="nowrap-text">
                                                <template slot="label">
                                                  <div class="form-label">
                                                    <span>{{ lang === 'ja' ? $t('message.checkout.firstName') :
                                                      $t('message.checkout.contactName') }}</span>
                                                    <span v-show="judgeRequired('firstName', form.LOCAL.firstName)"
                                                      class="required-tip">{{
                                                        $t('message.validator.required') }}</span>
                                                  </div>
                                                </template>
                                                <el-input maxlength="64" autocomplete="off"
                                                  v-model="form.LOCAL.firstName"
                                                  :placeholder="$t('message.checkout.firstName')"
                                                  @focus="sendBillingInfoFocusEvent(field.name)"
                                                  @change="sendBillingInfoInputEvent(field.name)" />
                                              </el-form-item>
                                            </el-col>
                                            <el-col :xs="12" :sm="12" :md="12" :lg="12" :xl="12">
                                              <el-form-item
                                                :label="lang === 'ja' ? $t('message.checkout.lastName') : ''"
                                                prop="lastName" ref="lastNameRef">
                                                <template slot="label">
                                                  <div class="form-label">
                                                    <span>{{ lang === 'ja' ? $t('message.checkout.lastName') : '&nbsp;'
                                                    }}</span>
                                                    <span v-show="judgeRequired('lastName', form.LOCAL.lastName)"
                                                      class="required-tip">{{
                                                        $t('message.validator.required') }}</span>
                                                  </div>
                                                </template>
                                                <el-input maxlength="64" autocomplete="off"
                                                  v-model="form.LOCAL.lastName"
                                                  :placeholder="$t('message.checkout.lastName')"
                                                  @focus="sendBillingInfoFocusEvent('lastName')"
                                                  @change="sendBillingInfoInputEvent('lastName')" />
                                              </el-form-item>
                                            </el-col>
                                          </el-row>
                                        </el-col>
                                        <!-- 手机号码 -->
                                        <el-col v-if="field.name === 'phone'" :key="fieldIndex" :xs="24" :sm="24"
                                          :md="24" :lg="24" :xl="24">
                                          <el-form-item :label="$t('message.checkout.phone')" prop="phone"
                                            ref="phoneRef">
                                            <template slot="label">
                                              <div class="form-label">
                                                <span>{{ $t('message.checkout.phone') }}</span>
                                                <span v-show="judgeRequired('phone', form.LOCAL.phone)"
                                                  class="required-tip">{{
                                                    $t('message.validator.required') }}</span>
                                              </div>
                                            </template>
                                            <el-input inputmode="numeric" type="number" maxlength="32"
                                              autocomplete="off" v-model="form.LOCAL.phone"
                                              @focus="sendBillingInfoFocusEvent(field.name)"
                                              @change="sendBillingInfoInputEvent(field.name)" />
                                          </el-form-item>
                                        </el-col>
                                        <!-- Street -->
                                        <el-col v-if="field.name === 'street'" :key="fieldIndex" :xs="24" :sm="24"
                                          :md="24" :lg="24" :xl="24">
                                          <el-form-item :label="$t('message.checkout.street')" prop="street"
                                            ref="streetRef">
                                            <template slot="label">
                                              <div class="form-label">
                                                <span>{{ $t('message.checkout.street') }}</span>
                                                <span v-show="judgeRequired('street', form.LOCAL.street)"
                                                  class="required-tip">{{
                                                    $t('message.validator.required') }}</span>
                                              </div>
                                            </template>
                                            <el-input maxlength="64" autocomplete="off" v-model="form.LOCAL.street"
                                              @focus="sendBillingInfoFocusEvent(field.name)"
                                              @change="sendBillingInfoInputEvent(field.name)" />
                                          </el-form-item>
                                        </el-col>
                                        <!-- 门牌号 -->
                                        <el-col v-if="field.name === 'number'" :key="fieldIndex" :xs="24" :sm="24"
                                          :md="24" :lg="24" :xl="24">
                                          <el-form-item :label="$t('message.checkout.number')" prop="number"
                                            ref="numberRef">
                                            <template slot="label">
                                              <div class="form-label">
                                                <span>{{ $t('message.checkout.number') }}</span>
                                                <span v-show="judgeRequired('number', form.LOCAL.number)"
                                                  class="required-tip">{{
                                                    $t('message.validator.required') }}</span>
                                              </div>
                                            </template>
                                            <el-input maxlength="64" autocomplete="off" v-model="form.LOCAL.number"
                                              @focus="sendBillingInfoFocusEvent(field.name)"
                                              @change="sendBillingInfoInputEvent(field.name)" />
                                          </el-form-item>
                                        </el-col>
                                      </template>
                                    </template>
                                  </el-row>
                                </div>
                              </transition>
                            </div>
                            <!-- 保存卡片勾选框 - 新增 -->
                            <div class="save-card-checkbox-wrapper mobile-padding"
                              :class="[onlyShowCardPayMethod ? '' : 'margin-left-10 margin-right-10']"
                              v-if="item && item.cardName === 'CARD' && enableCheckoutToken && !useTokenPayment && checkoutTokenInfos.length < 9">
                              <el-checkbox v-model="checkoutBindCard" :disabled="submitBtnLoading">
                                <span class="checkbox-label">{{ $t('message.checkout.saveCardForFasterCheckout')
                                  }}</span>
                              </el-checkbox>
                              <div class="checkbox-desc">
                                {{ $t('message.checkout.saveCardDesc', { AppURL: order.website }) }}
                              </div>
                            </div>
                            <!-- 卡支付Pay按钮 - 添加v-if条件 -->
                            <div class="btns checkout-btn submit-btn-wrapper"
                              v-if="item && (!useTokenPayment || item.cardName !== 'CARD') && (!item.children || !item.children.length) && !BankCardNames.includes(item.cardName)">
                              <on-button :loading="submitBtnLoading" type="button"
                                v-if="item && item.cardName !== 'GooglePay' && item.cardName !== 'ApplePay'"
                                @click.stop="submit">
                                {{ (item && item.cardName !== 'CARD' || (item && item.cardName === 'CARD' && ['',
                                  '1'].includes(form.CARD.periodValue))) ?
                                  submitBtnLabel : $t('message.checkout.pay') }}

                              </on-button>
                            </div>

                            <!-- 切换到Token支付按钮 - 新增 -->
                            <div class="switch-to-token-wrapper"
                              v-if="!useTokenPayment && showTokenSwitchBtn && isCardPayment && item && (!item.children || !item.children.length) && !BankCardNames.includes(item.cardName)">
                              <div class="use-saved-card-btn" @click="switchToTokenPayment">
                                {{ $t('message.checkout.useSavedCard') }}
                              </div>
                            </div>

                            <!-- DANA 按钮 -->
                            <div class="btns checkout-btn submit-btn-wrapper"
                              v-if="item && BankCardNames.includes(item.cardName)">
                              <on-button :disabled="!selectedBankCode" :loading="submitBtnLoading" type="button"
                                @click.stop="submit">
                                {{ submitBtnLabel }}
                              </on-button>
                            </div>
                          </el-form>
                        </div>
                      </div>
                    </el-collapse-item>

                  </el-collapse>
                </div>
              </div>

            </div>

          </div>
        </div>
      </div>
    </div>

    <policy @viewPolicy="viewPolicy"></policy>
    <div v-if="order && order.subscription">
      <p class="subsciption" v-if='order && order.subscription.trialDays'>
        * {{ $t('message.checkout.subscriptionNo1', {
          num:
            formatAmount(order.txnAmount) + orderGetter.txnCurrency
        }) }}
        {{ formatFrequencyLabel(order.subscription.frequencyType, order.subscription.frequencyPoint) +
          fullStopTextByLang +
          $t('message.checkout.subscriptionNo3') }}

      </p>
      <p class="subsciption" v-else>
        {{ $t('message.checkout.subscriptionNo') }}
      </p>
    </div>
    <Privacy :open="showPolicy" @on-close="showPolicy = false"></Privacy>
    <div class="btn-cancel-box">
      <span v-if="viewCancelBtn" class="btn-cancel" @click="onCancel">
        <img src="@/assets/images/back.png" alt="" class="back">
        <span class="btn-cancel-text">{{ $t('message.checkout.returnMerchant') }}</span>
      </span>
    </div>
    <PaymentNotSupport :visible.sync="showPayReturnAlert" :return-url="payReturnUrl"></PaymentNotSupport>
    <ValidateCVVPopup :identityNumberFormLabel="identityNumberFormLabel" :open="showValidateCvvPopup"
      @cancel="handleValidateCvvPopupCancel" @done="onGooglePay" :form="validateGooglePayCVVForm"></ValidateCVVPopup>

    <ResponsiveDialog ref="responsiveDialog" :order-info="order" @confirm="handleResponsiveDialogConfirm"
      @close="handleDialogClose" @cancel="handleDialogClose">
    </ResponsiveDialog>

  </div>
</template>
<script>
import {
  getOrderInfo_aggregate,
  payment,
  googlePayValidateMerchant,
} from '@/api/aggregate';
import {
  getFieldConfig_checkout,
  getInstallmentInfo,
  unbindCard,
} from '@/api/checkout';
import { addLog } from '@/api/common';
import policy from '@/components/policy/index.vue';
import Privacy from '@/components/privacy/index.vue';
import ValidateCVVPopup from '@/components/validate-cvv-popup/index.vue';
import OnButton from '@/componentsV2/base/button/index.vue';
import { OnMessage } from '@/componentsV2';
import TokenPayment from '@/views/aggregate/components/TokenPayment.vue';
import { BankCardNames, getBankOptions } from '@/manager/bank-selector-manager';
import { deviceFingerprintManager } from '@/plugins/eventTrackManager/deviceFingerprintManager';
import { APPLE_PAY_LANG, ApplePay } from '@/utils/tools/apple_pay';
import BANK_OPTIONS from '@/utils/tools/bank';
import { initCardPaymentFields } from '@/utils/tools/cardPaymentBasicForm';
import { CASH_MY_OPTIONS } from '@/utils/tools/Cash_MY';
import COUNTRY_OPTIONS from '@/utils/tools/country';
import { DANA_BANK_OPTIONS } from '@/utils/tools/dana_banks';
import { DOKU_BANK_OPTIONS } from '@/utils/tools/doku_banks';
import EMAIL_OPTIONS from '@/utils/tools/email';
import { formatFrequencyLabel, formatMoneyWithCommas, dotsCommasCountries, formatAmountWithDotsCommas } from '@/utils/tools/format';
import { GooglePay } from '@/utils/tools/google_pay';
import { INTERNET_BANKING_MY_OPTIONS } from '@/utils/tools/Internet_Banking_MY';
import STATES_OPTIONS from '@/utils/tools/state';
import { scrollToTop } from '@/utils/tools/utils';
import CardInformation from '@/views/aggregate/components/card-information/index.vue';
import PaymentNotSupport from '@/views/aggregate/components/paymentNotSupport.vue';
import ResponsiveDialog from '@/views/aggregate/components/responsive-dialog/index.vue';
import {
  identityNumberLabel,
  selectStateCountry,
  paymentFields,
  billingFields,
  paymentFieldsSort,
  billingFieldsSort,
  fieldConfigurationRulesAndNamesHandler,
  deleteFieldConfigurationRules,
  showMessage,
  getCardExpiredFullYear,
  // ALIPAY,
  getDevice,
  getBrowerInfo,
  showVenmoPayMethod,
  unzipOrder,
} from '@/views/aggregate/pc/utils/utils.js';
import { allRules, cardFormRules, getCard, luhn } from '@/views/aggregate/pc/utils/validator.js';

import { CHECKOUT_STATUS } from './config';
import moment from 'moment';

export default {
  // CardNumber
  components: { CardInformation, Privacy, PaymentNotSupport, ValidateCVVPopup, policy, ResponsiveDialog, OnButton, TokenPayment },
  data() {
    return {
      CHECKOUT_STATUS,
      DANA_BANK_OPTIONS,
      DOKU_BANK_OPTIONS,
      CASH_MY_OPTIONS,
      INTERNET_BANKING_MY_OPTIONS,
      BankCardNames,
      isShowErr: false,
      isShowTips: false,
      showPolicy: false,
      marginBottom: '10px',
      device: getDevice(),
      BANK_OPTIONS,
      COUNTRY_OPTIONS,
      STATES_OPTIONS,
      // ALIPAY,
      countryList: [],
      cardInfoLoading: false,
      freshFieldConfigSuccess: false,
      order: null,
      activePaymentMethod: '',
      activeChildPaymentMethod: '',
      selectStateCountry,
      identityNumberLabel,
      payMethods: null,
      cardPayMethods: -1,
      hideCardHolderName: false,
      viewTxnId: true,
      viewCancelBtn: false,
      viewCountryBtn: true, // 是否展示国家选择项
      canShowPayReturnAlert: true,
      showPayReturnAlert: false,
      payReturnUrl: '',
      selectedBankCode: '', // dana选中的银行
      // 添加账单信息折叠状态
      showBillingForm: false,
      form: {
        CARD: {
          cardNum: '',
          effectiveDate: '',
          cvv: '',
          cardHolderName: '',
          walletAccountName: '',
          country: this.$route.query.c ? this.$route.query.c : '',
          province: '',
          address: '',
          city: '',
          postalCode: '',
          email: '',
          firstName: '',
          lastName: '',
          jpFirstName: '',
          jpLastName: '',
          birthDate: '',
          phone: '',
          identityNumber: '',
          street: '',
          number: '',
          intallment: 2,
          periodValue: '',
          prepaidNumber: '',
          iBan: '',
          bankName: '',
          blikcode: '',
          issueDate: '',
        },
        LOCAL: {
          cardNum: '',
          effectiveDate: '',
          cardHolderName: '',
          walletAccountName: '',
          cvv: '',
          country: this.$route.query.c ? this.$route.query.c : '',
          province: '',
          address: '',
          city: '',
          postalCode: '',
          email: '',
          firstName: '',
          lastName: '',
          jpFirstName: '',
          jpLastName: '',
          birthDate: '',
          phone: '',
          identityNumber: '',
          street: '',
          number: '',
          periodValue: '',
          bankName: '',
          iBan: '',
          prepaidNumber: '',
          blikcode: '',
          issueDate: '',
        },
      },
      older: {
        country: '',
        method: '',
        subMethod: '',
        cardNumber: '',
        cardType: '',
      },
      supportCardTypeNames: [],
      supportCardTypes: [],
      key: this.$route.query.key ? this.$route.query.key : this.$route.params.id,
      googleScriptLoaded: 'loading',
      googlePayConfig: null,
      googleBtnLoading: false,
      googlePayGatewayMerchantId: null,
      googlePayMerchantId: null,
      gatewayName: null,
      APPLE_PAY_LANG,
      applePayScriptLoaded: 'loading',
      applePayBtnLoading: false,
      applePayBtnShow: 0, // 默认0， 1显示Apple Pay, 2显示设备不支持提示
      applePayMerchantIdentifier: '',
      applePayGatewayName: null,
      refSuffix: {
        CARD: 'Card',
        LOCAL: '',
      },
      paymentType: 'CARD',
      instalmentLoading: false,
      instalmentDisabled: true,
      instalmentRefresh: true,
      instalmentInfo: null,
      showValidateCvvPopup: false,
      validateGooglePayCVVForm: {},
      showRetryReason: true,
      retryInfo: {
        retry: '',
        retryAdvice: '',
        transSceneFlag: '1',
        CollapseTips: 'More',
      },
      submitBtnLoading: false,
      /**
       * 现在拿到所有支付方式 会循环渲染一个折叠面板
       * 每一个面板内部都有一个form表单，index就是标识
       * 需要通过表单的校验，才能触发对应的支付
       *
       * 现在把googlePay拿出去了，但是校验逻辑还是按照原来的不动，因此需要初始化的时候拿到googlePay在接口返回的payMethods的下标
       *
       * applePay同理
       */
      googlePayFormIndex: undefined,
      applePayFormIndex: undefined,
      googlePayRequestData: {},
      applePayRequestData: {},
      isPayRequired: false,
      orderInfoTop: 0,
      supportCardActiveIndex: 0,
      onlyShowCardPayMethod: false, // TODO:新增需求 如果支持[卡支付/applePay]、[卡支付/GooglePay]、[卡支付/GooglePay/applePay]\[卡支付] 支付方式的标识
      // 是否需要重置ap、gp的账单信息表单（切换国家等重新请求配置后）
      resetApplePayOrGooglePayForm: false,
      // googlePay初始化后的实例
      googlePayInstance: null,
      // 当前选中的支付方式 apple, google
      currentPaymentMethod: '',
      scrollPosition: 0,
      lastPaymentMethod: undefined,
      // Token支付相关 - 新增
      enableCheckoutToken: false,      // 是否支持Token支付
      checkoutTokenInfos: [],          // 已保存的Token卡片列表
      useTokenPayment: false,          // 是否使用Token支付模式
      selectedTokenCardId: '',         // 选中的Token卡片ID
      checkoutBindCard: false,         // 是否保存卡片（勾选框状态）
      tokenCardsExpanded: true,        // Token卡片列表是否展开 - 开发者：Nemo
    };
  },
  computed: {
    lang() {
      return this.$i18n.locale;
    },
    // 是否要格式化金额
    isFormatAmount() {
      return dotsCommasCountries.includes(this.order?.paymentCountry);
    },
    identityNumberFormLabel() {
      if (this.form.CARD.country) {
        return identityNumberLabel[this.form.CARD.country] ? identityNumberLabel[this.form.CARD.country] : this.$t('message.checkout.identityNumber');
      }
      return this.$t('message.checkout.identityNumber');
    },

    DeviceType() {
      return this.$store.state.app.gaDeviceinfo.device_type;
    },

    supportGooglePay() {
      return !!(this.payMethods?.find(item => item.cardName === 'GooglePay')) || false;
    },
    supportApplePay() {
      return !!(this.payMethods?.find(item => item.cardName === 'ApplePay')) || false;
    },
    // 只有卡支付
    onlyCard() {
      return (!!(this.payMethods?.find(item => item.cardName === 'CARD')) && this.payMethods.length === 1) || false;
    },
    // 只有applepay或googlepay的时候 或者一共只有applepay或googlepay的时候
    onlySpecialPayment() {
      // 判断特殊支付方式的数量
      const specialPaymentCount = (this.supportApplePay ? 1 : 0) + (this.supportGooglePay ? 1 : 0);

      // 支付方式数量等于特殊支付方式数量，说明只有特殊支付方式
      return this.payMethods.length === specialPaymentCount && specialPaymentCount > 0;
    },
    // 卡信息整体必填
    isCardInformationRequired() {
      try {
        const rules = this.payMethods[this.cardPayMethods]?.rules;
        const cardNum = rules?.cardNum || [];
        const effectiveDate = rules?.effectiveDate || [];
        const cvv = rules?.cvv || [];
        return [...cardNum, ...effectiveDate, ...cvv]?.some(item => item.name === 'required' && item.required) &&
          (!this.form[this.paymentType].cardNum || !this.form[this.paymentType].effectiveDate || !this.form[this.paymentType].cvv);
      } catch (error) {
        return false;
      }
    },
    orderGetter() {
      return this.order;
    },

    // 提交按钮文案
    submitBtnLabel() {
      if (this.order?.subscription?.trialDays) {
        return this.$t('message.checkout.startTrial');
      } else if (this.order?.subProductType === 'SUBSCRIBE') {
        return this.$t('message.checkout.subscribe') + ' - ' + this.formatAmount(this.order.txnAmount) + ' ' + this.order.txnCurrency;
      } else {
        return this.$t('message.checkout.pay') + ' ' + this.formatAmount(this.order.txnAmount) + ' ' + this.order.txnCurrency;
      }
    },

    // 分期付款选项
    installmentOptions() {
      const options = [];

      // 如果正在加载分期信息，显示loading选项
      if (this.instalmentLoading) {
        options.push({
          value: 'loading',
          label: this.$t('message.status.loading'),
          disabled: true,
        });
        return options;
      }

      // 如果有分期信息
      if (this.instalmentInfo && this.instalmentInfo.stages) {
        this.instalmentInfo.stages.forEach((instalmentItem) => {
          if (instalmentItem.stageNumber === '1') {
            // 全额付款选项
            options.push({
              value: instalmentItem.stageNumber,
              label: this.$t('message.checkout.payInFull'),
              disabled: false,
            });
          } else {
            // 分期付款选项
            const label = this.$t('message.checkout.payIn', { count: instalmentItem.stageNumber });
            const fullLabel = this.instalmentInfo.institution === 'DLOCAL'
              ? `${label} - ${instalmentItem.stageName}`
              : label;

            options.push({
              value: instalmentItem.stageNumber,
              label: fullLabel,
              disabled: false,
            });
          }
        });
      }

      return options;
    },

    // 根据语言返回 句点
    fullStopTextByLang() {
      if (['zh-cn', 'zh-tw', 'zh'].includes(this.lang)) {
        return '。';
      }

      return '.';
    },

    /**
     * 是否有可用的Token卡片
     * @author Nemo
     */
    hasAvailableTokenCards() {
      return this.checkoutTokenInfos?.length > 0;
    },

    /**
     * 是否显示Token支付切换按钮
     * @author Nemo
     */
    showTokenSwitchBtn() {
      return this.hasAvailableTokenCards &&
        this.payMethods.some(item => item.cardName === 'CARD');
    },

    /**
     * 当前是否为卡支付
     * @author Nemo
     */
    isCardPayment() {
      return this.payMethods[this.activePaymentMethod]?.cardName === 'CARD';
    },
  },
  beforeCreate() {
    const key = this.$route.query.key ? this.$route.query.key : this.$route.params.id;
    // DM
    const { MD_ORI_ID, MD_MERCHANT_ID } = require('@/config/env.' + process.env.NODE_ENV);
    const script = document.createElement('script');
    script.src = `https://h.online-metrix.net/fp/tags.js?org_id=${MD_ORI_ID}&session_id=${MD_MERCHANT_ID}${key}`;
    document.body.appendChild(script);
    try {
      window.sessionStorage.setItem(`checkout_type_${key}`, '2');
      addLog({
        key,
        message: '进入收银台:' + window.location.href,
      });
    } catch (error) { }
  },
  created() {
    const { GOOGLE_PAY } = require('@/config/env.' + process.env.NODE_ENV);
    this.googlePayConfig = GOOGLE_PAY;
    this.addGooglePayScript();
    this.addApplePayScript();
    this.initMethod();
    window.addEventListener('beforeunload', this.beforeUnloadEvent);
    this.$bus.$off('lang_components').$on('lang_components', eventName => {
      this.sendGaEvent(this.order, eventName);
    });
    this.initCountryList();
  },
  mounted() {
    this.updateOrderInfoTop();
    window.addEventListener('scroll', this.foldSelect);
    window.addEventListener('scroll', this.updateOrderInfoTop);
    this.startCarousel();
  },
  beforeDestroy() {
    // gtag
    this.sendGaEvent(this.order, 'exit_checkout');
    this.sendRiskDeviceFingerPrint({ e: 'exit_checkout' });
    window.removeEventListener('beforeunload', this.beforeUnloadEvent);
    window.addEventListener('scroll', this.foldSelect);
    window.removeEventListener('scroll', this.updateOrderInfoTop);
  },

  methods: {
    formatFrequencyLabel,
    formatMoneyWithCommas,
    scrollToTop,
    getBankOptions,
    /**
     * 统一的金额格式化方法
     * @param {number|string} amount - 需要格式化的金额
     * @returns {string} - 格式化后的金额
     * @author Nemo
     */
    formatAmount(amount) {
      return this.isFormatAmount ? formatAmountWithDotsCommas(amount) : formatMoneyWithCommas(amount);
    },
    startCarousel() {
      setInterval(() => {
        this.supportCardActiveIndex = (this.supportCardActiveIndex + 1) % this.supportCardTypes.slice(3).length;
      }, 2000);
    },
    updateOrderInfoTop() {
      const orderSummaryDom = document.querySelector('.order-summary') || {};
      if (orderSummaryDom && orderSummaryDom.getBoundingClientRect) {
        this.orderInfoTop = orderSummaryDom?.getBoundingClientRect()?.bottom || 0;
      }
    },
    // 每次滑动时 收起下拉框
    foldSelect() {
      const countrySelectDom = this.$refs.countrySelectRef;
      if (countrySelectDom) {
        countrySelectDom.blur();
      }
    },
    selectBank(code) {
      this.selectedBankCode = code;
    },

    initMethod() {
      try {
        this.$emit('updateStatus', CHECKOUT_STATUS.LOADING);
        const checkoutDetail = this.$route.query.checkoutDetail;
        if (checkoutDetail) {
          this.requestingTime = -1;
          const info = unzipOrder(checkoutDetail);
          if (info) {
            const formatInfo = {
              ...info,
              checkoutModels: info.checkoutModels.map(item => {
                if (item.cardName === 'CARD') {
                  return initCardPaymentFields(item);
                } else {
                  return item;
                }
              }),
            };
            this.initOrder(formatInfo);

            this.cardInfoLoading = false;
            this.$emit('updateStatus', CHECKOUT_STATUS.FILLING);
            return;
          } else {
            try {
              addLog({
                key: this.key,
                message: '解密失败:' + checkoutDetail,
              });
            } catch (err) {
              //
            }
          }
        }
      } catch (err) {
        //
      }
      this.fetchOrder();
    },
    /** ***********  ✨ Codeium Command ⭐  *************/
    /**
   * Initialize order info
   * @param {object} orderInfo Order info
   * @returns {void}
   */
    /** ****  80bdb816-d560-43a6-a30f-0b72cac28908  *******/
    initOrder(orderInfo) {
      if (orderInfo.paymentCountry) {
        this.form.CARD.country = orderInfo.paymentCountry;
      }
      this.sendGaEvent(orderInfo, 'visit_checkout');
      this.sendRiskDeviceFingerPrint({ e: 'visit_checkout' });
      this.sendGaEvent(orderInfo, 'visit_checkout_time');
      if (orderInfo.status === 'F') { // F跳转，失败页面
        this.$emit('updateStatus', CHECKOUT_STATUS.FAILED, '', this.order);
        return;
      }
      // shopify
      if (orderInfo.newCheckout) {
        window.location.href = orderInfo.newCheckout;
        return;
      }
      if (!orderInfo.paymentCountry) {
        this.$router.push({
          path: '/address/a',
          query: { merchantTxnId: this.order?.merchantTxnId || '', key: this.$route.query.key ? this.$route.query.key : this.$route.params.id, type: '2' },
        });
        return;
      }
      this.$store.dispatch('app/setBrandInfo', { ...(orderInfo.brandConfig || {}), website: orderInfo.website });
      if (orderInfo.brandConfig) {
        this.viewTxnId = orderInfo.brandConfig.viewTxnId;
        this.viewCancelBtn = orderInfo.brandConfig.viewCancelBtn;
        this.viewCountryBtn = orderInfo.brandConfig.viewCountryBtn;
      }
      this.order = orderInfo;
      this.$emit('updateOrder', orderInfo);
      this.payReturnUrl = orderInfo.returnUrl;

      // 更新Token支付相关数据 - 开发者：Nemo
      this.enableCheckoutToken = orderInfo.enableCheckoutToken || false;
      this.checkoutTokenInfos = orderInfo.checkoutTokenInfos || [];

      // 如果有可用的Token卡片，自动切换到Token支付模式 - 开发者：Nemo
      if (this.checkoutTokenInfos.length > 0) {
        this.useTokenPayment = true;
      }

      // 如果当前在Token支付模式，检查选中的卡片是否还存在
      if (this.useTokenPayment && this.selectedTokenCardId) {
        const cardStillExists = this.checkoutTokenInfos.some(c => c.id === this.selectedTokenCardId);
        if (!cardStillExists) {
          // 如果选中的卡片不存在了，清空选中ID（组件会自动选择第一张可用卡）
          this.selectedTokenCardId = '';
        }
      }

      if (this.order.subscription) {
        if (this.order.subscription.expireDate) {
          if (this.order.subscription.expireDate) {
            this.order.subscription.expireDateShow = this.order.subscription.expireDate.split('-');
            this.order.subscription.expireDateShow[1] = Number(this.order.subscription.expireDateShow[1]);
          } else {
            this.order.subscription.expireDateShow = ['', ''];
          }
        }
      }
      this.form.CARD.country = orderInfo.paymentCountry;
      this.form.LOCAL.country = orderInfo.paymentCountry;
      // 安卓设备不显示ApplePay
      if (orderInfo.checkoutModels && orderInfo.checkoutModels.length) {
        if (this.device.device === 'WAP' && this.device.system === 'ANDROID') {
          for (let i = 0; i < orderInfo.checkoutModels.length; i++) {
            if (orderInfo.checkoutModels[i].cardName === 'ApplePay') {
              orderInfo.checkoutModels.splice(i, 1);
              break;
            }
          }
        }
      }
      // 初始化googlePay和applePay的form下标
      for (let i = 0; i < orderInfo.checkoutModels.length; i++) {
        if (orderInfo.checkoutModels[i].cardName === 'ApplePay') {
          this.applePayFormIndex = i;
        }
        if (orderInfo.checkoutModels[i].cardName === 'GooglePay') {
          this.googlePayFormIndex = i;
        }
      }

      // 没有支付方式时
      if (!orderInfo.checkoutModels || !orderInfo.checkoutModels.length) {
        this.showPayReturnAlert = true;
        // showMessage(this.$t('message.result.emptyPaymentMethod'));
        this.$emit('updateStatus', CHECKOUT_STATUS.FILLING);
        this.cardInfoLoading = false;
        this.submitBtnLoading = false;
        return;
      }
      // Venmo支付方式
      for (let i = 0; i < orderInfo.checkoutModels.length; i++) {
        const p = orderInfo.checkoutModels[i];
        if (p.cardName.toLowerCase() === 'venmo' && !showVenmoPayMethod()) {
          orderInfo.checkoutModels.splice(i, 1);
          break;
        }
      }
      // 查找卡支付
      const originPayments = orderInfo.checkoutModels;
      for (let i = 0; i < originPayments.length; i++) {
        if (originPayments[i].cardName === 'CARD') {
          this.cardPayMethods = i;
          break;
        }
      }
      this.payMethods = originPayments;
      if (this.payMethods.length > 1) {
        this.canShowPayReturnAlert = false;
      }
      // CARD支付处理
      if (this.cardPayMethods > -1) {
        this.$store.dispatch('app/setCards', this.payMethods[this.cardPayMethods].cardTypeInfo);
        // 卡信息回填
        if (orderInfo.cardInfo) {
          const cardNum = orderInfo.cardInfo.cardNumber;
          if (cardNum) {
            this.form.CARD.cardNum = cardNum.replace(/\s*/g, '').replace(/(.{4})/g, '$1 ').trim();
          }
          this.form.CARD.cvv = orderInfo.cardInfo.cvv;
          if (orderInfo.cardInfo.month && orderInfo.cardInfo.year) {
            const year = orderInfo.cardInfo.year;
            this.form.CARD.effectiveDate = `${orderInfo.cardInfo.month.trim()} / ${(year.trim()).substring(year.length - 2, year.length)}`;
          }
          // 隐藏姓名输入框
          if (orderInfo.cardInfo.holderName) {
            const holderNameArr = orderInfo.cardInfo.holderName.trim().split(' ');
            if (holderNameArr.length > 1) { // holderName有空格，隐藏holderName字段
              this.hideCardHolderName = true;
            }
            this.form.CARD.cardHolderName = orderInfo.cardInfo.holderName.trim();
          }
        }
      }
      if (this.payMethods.length > 0) {
        this.activePaymentMethod = 0;
        this.lastPaymentMethod = 0;  // 同时设置lastPaymentMethod
        this.older.method = 0;
        this.paymentType = this.payMethods[this.activePaymentMethod].cardName === 'CARD' ? 'CARD' : 'LOCAL';
        // 子支付方式
        if (this.payMethods[0].children && this.payMethods[0].children.length) {
          this.activeChildPaymentMethod = 0;
          this.older.subMethod = 0;
        }
        const isSetEqual = function (setA, setB) {
          if (setA.size !== setB.size) return false;
          for (const value of setA) {
            if (!setB.has(value)) return false;
          }
          return true;
        };
        const cardNameList = this.payMethods.map(item => item.cardName);
        const cardNameSet = new Set(cardNameList);
        const validSets = [
          new Set(['CARD']),
          new Set(['CARD', 'ApplePay']),
          new Set(['CARD', 'GooglePay']),
          new Set(['CARD', 'ApplePay', 'GooglePay']),
        ];
        if (validSets.some(validSet => isSetEqual(cardNameSet, validSet))) {
          this.onlyShowCardPayMethod = true;
          this.activePaymentMethod = this.cardPayMethods;
          this.lastPaymentMethod = this.cardPayMethods;  // 同时设置lastPaymentMethod
          this.paymentType = 'CARD';
        } else {
          this.onlyShowCardPayMethod = false;
        }
      }
      for (let i = 0; i < this.payMethods.length; i++) {
        // 商户指定支付方式,但是不能指定卡支付
        if (this.payMethods[i].isSelect === 'Y' && this.payMethods[i].cardName !== 'CARD') {
          this.activePaymentMethod = i;
          this.lastPaymentMethod = i;  // 同时设置lastPaymentMethod
          this.older.method = i;
          this.paymentType = this.payMethods[this.activePaymentMethod].cardName === 'CARD' ? 'CARD' : 'LOCAL';
          // 指定子支付方式
          if (this.payMethods[i].children && this.payMethods[i].children.length) {
            for (let j = 0; j < this.payMethods[i].children.length; j++) {
              const subMethod = this.payMethods[i].children[j];
              if (subMethod.isSelect === 'Y') {
                this.activeChildPaymentMethod = j;
                this.older.subMethod = j;
                break;
              }
            }
          }
        }
        // 排序
        if (this.payMethods[i].paymentConfigurationFields) {
          paymentFieldsSort(this.payMethods[i].paymentConfigurationFields);
        }
        if (this.payMethods[i].billConfigurationFields) {
          billingFieldsSort(this.payMethods[i].billConfigurationFields);
        }
        // 子支付方式
        if (this.payMethods[i].children && this.payMethods[i].children.length) {
          for (let j = 0; j < this.payMethods[i].children.length; j++) {
            const subMethod = this.payMethods[i].children[j];
            if (subMethod.paymentConfigurationFields) {
              paymentFieldsSort(subMethod.paymentConfigurationFields);
            }
            if (subMethod.billConfigurationFields) {
              billingFieldsSort(subMethod.billConfigurationFields);
            }
            subMethod.rules = {};
            const subMethodFields = [];
            if (subMethod.paymentConfigurationFields) {
              subMethodFields.push(...subMethod.paymentConfigurationFields);
            }
            if (subMethod.billConfigurationFields) {
              subMethodFields.push(subMethod.billConfigurationFields);
            }
            fieldConfigurationRulesAndNamesHandler(subMethodFields, subMethod.rules, this.order.paymentCountry);
            this.initFormData(subMethod.cardName, subMethodFields);
          }
        }
        const method = this.payMethods[i];
        // // 配置字段处理
        const methodFields = [];
        if (method.paymentConfigurationFields) {
          methodFields.push(...method.paymentConfigurationFields);
        }
        if (method.billConfigurationFields) {
          methodFields.push(...method.billConfigurationFields);
        }
        if (method.cardName === 'CARD') {
          method.rules = cardFormRules();
          this.cardFieldConfigurationNames = fieldConfigurationRulesAndNamesHandler(methodFields, method.rules, this.order.paymentCountry);
          this.getCardTypeInfos(method.cardTypeInfo);
        } else {
          if (method.paymentConfigurationFields) {
            method.rules = {};
            fieldConfigurationRulesAndNamesHandler(methodFields, method.rules, this.order.paymentCountry);
          }
        }
        this.initFormData(method.cardName, methodFields);
        if (method.cardName === 'GooglePay') {
          this.googlePayGatewayMerchantId = method.gatewayMerchantId;
          this.googlePayMerchantId = method.merchantId;
          this.gatewayName = method.gatewayName;
        } else if (method.cardName === 'ApplePay') {
          this.applePayMerchantIdentifier = method.merchantId;
          this.applePayGatewayName = method.gatewayName;
        }
      }
      this.cardInfoLoading = false;
      this.submitBtnLoading = false;
      this.$emit('updateStatus', CHECKOUT_STATUS.FILLING);
      // TODO NEMO
      this.$nextTick(() => {
        this.supportGooglePay && this.initGooglePayButton();
        this.supportApplePay && this.initApplePayButton();
      });
    },
    fetchOrder() {
      this.requestingTime = Date.now();
      getOrderInfo_aggregate({
        key: this.key,
        country: this.$route.query.c,
        paymentMode: this.device.device,
        osType: this.device.system,
      }).then((res) => {
        if (res.data.retry) {
          this.retryInfo.retry = res.data.retry;
          this.isShowErr = true;
          this.scrollToTop();
          this.retryInfo.retryAdvice = res.data.retryAdvice;
        }
        if (res.respCode !== '20000') {
          if (this.exceptionShow(res)) {
            return;
          }
          this.$emit('updateStatus', CHECKOUT_STATUS.ERROR, '', this.order);
          return;
        }
        if (res.data.paymentCountry) {
          this.form.CARD.country = res.data.paymentCountry;
        }
        this.sendGaEvent(res.data, 'visit_checkout');
        this.sendGaEvent(res.data, 'visit_checkout_time');
        this.sendRiskDeviceFingerPrint({ e: 'visit_checkout' });
        if (res.data.status === 'F') { // F跳转，失败页面
          this.$emit('updateStatus', CHECKOUT_STATUS.FAILED, '', this.order);
          return;
        }
        // shopify
        if (res.data.newCheckout) {
          window.location.href = res.data.newCheckout;
          return;
        }
        if (!res.data.paymentCountry) {
          this.$router.push({
            path: '/address/a',
            query: { merchantTxnId: this.order?.merchantTxnId || '', key: this.$route.query.key ? this.$route.query.key : this.$route.params.id, type: '2' },
          });
          return;
        }
        this.$store.dispatch('app/setBrandInfo', { ...(res.data.brandConfig || {}), website: res.data.website });
        if (res.data.brandConfig) {
          this.viewTxnId = res.data.brandConfig.viewTxnId;
          this.viewCancelBtn = res.data.brandConfig.viewCancelBtn;
          this.viewCountryBtn = res.data.brandConfig.viewCountryBtn;
        }
        this.order = res.data;
        this.$emit('updateOrder', res.data);
        this.payReturnUrl = res?.data?.redirectUrl;

        // 更新Token支付相关数据 - 开发者：Nemo
        this.enableCheckoutToken = res.data.enableCheckoutToken || false;
        this.checkoutTokenInfos = res.data.checkoutTokenInfos || [];

        // 如果有可用的Token卡片，自动切换到Token支付模式 - 开发者：Nemo
        if (this.checkoutTokenInfos.length > 0) {
          this.useTokenPayment = true;
        }

        // 如果当前在Token支付模式，检查选中的卡片是否还存在
        if (this.useTokenPayment && this.selectedTokenCardId) {
          const cardStillExists = this.checkoutTokenInfos.some(c => c.id === this.selectedTokenCardId);
          if (!cardStillExists) {
            // 如果选中的卡片不存在了，清空选中ID（组件会自动选择第一张可用卡）
            this.selectedTokenCardId = '';
          }
        }

        if (this.order.subscription) {
          if (this.order.subscription.expireDate) {
            this.order.subscription.expireDateShow = this.order.subscription.expireDate.split('-');
            this.order.subscription.expireDateShow[1] = Number(this.order.subscription.expireDateShow[1]);
          } else {
            this.order.subscription.expireDateShow = ['', ''];
          }
        }
        this.form.CARD.country = res.data.paymentCountry;
        this.form.LOCAL.country = res.data.paymentCountry;

        // 安卓设备不显示ApplePay
        if (res.data.checkoutModels && res.data.checkoutModels.length) {
          if (this.device.device === 'WAP' && this.device.system === 'ANDROID') {
            for (let i = 0; i < res.data.checkoutModels.length; i++) {
              if (res.data.checkoutModels[i].cardName === 'ApplePay') {
                res.data.checkoutModels.splice(i, 1);
                break;
              }
            }
          }
        }

        // 初始化googlePay和applePay的form下标
        for (let i = 0; i < res.data.checkoutModels.length; i++) {
          if (res.data.checkoutModels[i].cardName === 'ApplePay') {
            this.applePayFormIndex = i;
          }
          if (res.data.checkoutModels[i].cardName === 'GooglePay') {
            this.googlePayFormIndex = i;
          }
        }

        // 没有支付方式时
        if (!res.data.checkoutModels || !res.data.checkoutModels.length) {
          this.showPayReturnAlert = true;
          // showMessage(this.$t('message.result.emptyPaymentMethod'));
          this.cardInfoLoading = false;
          this.submitBtnLoading = false;
          this.$emit('updateStatus', CHECKOUT_STATUS.FILLING);
          return;
        }
        // Venmo支付方式
        for (let i = 0; i < res.data.checkoutModels.length; i++) {
          const p = res.data.checkoutModels[i];
          if (p.cardName.toLowerCase() === 'venmo' && !showVenmoPayMethod()) {
            res.data.checkoutModels.splice(i, 1);
            break;
          }
        }
        // 查找卡支付
        const originPayments = res.data.checkoutModels;
        for (let i = 0; i < originPayments.length; i++) {
          if (originPayments[i].cardName === 'CARD') {
            this.cardPayMethods = i;
            break;
          }
        }
        this.payMethods = originPayments;
        if (this.payMethods.length > 1) {
          this.canShowPayReturnAlert = false;
        }
        // CARD支付处理
        if (this.cardPayMethods > -1) {
          this.$store.dispatch('app/setCards', this.payMethods[this.cardPayMethods].cardTypeInfo);
          // 卡信息回填
          if (res.data.cardInfo) {
            const cardNum = res.data.cardInfo.cardNumber;
            if (cardNum) {
              this.form.CARD.cardNum = cardNum.replace(/\s*/g, '').replace(/(.{4})/g, '$1 ').trim();
            }
            this.form.CARD.cvv = res.data.cardInfo.cvv;
            if (res.data.cardInfo.month && res.data.cardInfo.year) {
              const year = res.data.cardInfo.year;
              this.form.CARD.effectiveDate = `${res.data.cardInfo.month.trim()} / ${(year.trim()).substring(year.length - 2, year.length)}`;
            }
            // 隐藏姓名输入框
            if (res.data.cardInfo.holderName) {
              const holderNameArr = res.data.cardInfo.holderName.trim().split(' ');
              if (holderNameArr.length > 1) { // holderName有空格，隐藏holderName字段
                this.hideCardHolderName = true;
              }
              this.form.CARD.cardHolderName = res.data.cardInfo.holderName.trim();
            }
          }
        }
        if (this.payMethods.length > 0) {
          this.activePaymentMethod = 0;
          this.lastPaymentMethod = 0;  // 同时设置lastPaymentMethod
          this.older.method = 0;
          this.paymentType = this.payMethods[this.activePaymentMethod].cardName === 'CARD' ? 'CARD' : 'LOCAL';
          // 子支付方式
          if (this.payMethods[0].children && this.payMethods[0].children.length) {
            this.activeChildPaymentMethod = 0;
            this.older.subMethod = 0;
          }
          const isSetEqual = function (setA, setB) {
            if (setA.size !== setB.size) return false;
            for (const value of setA) {
              if (!setB.has(value)) return false;
            }
            return true;
          };
          const cardNameList = this.payMethods.map(item => item.cardName);
          const cardNameSet = new Set(cardNameList);
          const validSets = [
            new Set(['CARD']),
            new Set(['CARD', 'ApplePay']),
            new Set(['CARD', 'GooglePay']),
            new Set(['CARD', 'ApplePay', 'GooglePay']),
          ];

          if (validSets.some(validSet => isSetEqual(cardNameSet, validSet))) {
            this.onlyShowCardPayMethod = true;
            this.activePaymentMethod = this.cardPayMethods;
            this.lastPaymentMethod = this.cardPayMethods;  // 同时设置lastPaymentMethod
            this.paymentType = 'CARD';
          } else {
            this.onlyShowCardPayMethod = false;
          }
        }

        for (let i = 0; i < this.payMethods.length; i++) {
          // 商户指定支付方式
          if (this.payMethods[i].isSelect === 'Y' && this.payMethods[i].cardName !== 'CARD') {
            this.activePaymentMethod = i;
            this.lastPaymentMethod = i;  // 同时设置lastPaymentMethod
            this.older.method = i;
            this.paymentType = this.payMethods[this.activePaymentMethod].cardName === 'CARD' ? 'CARD' : 'LOCAL';
            // 指定子支付方式
            if (this.payMethods[i].children && this.payMethods[i].children.length) {
              for (let j = 0; j < this.payMethods[i].children.length; j++) {
                const subMethod = this.payMethods[i].children[j];
                if (subMethod.isSelect === 'Y') {
                  this.activeChildPaymentMethod = j;
                  this.older.subMethod = j;
                  break;
                }
              }
            }
          }
          // 排序
          if (this.payMethods[i].paymentConfigurationFields) {
            paymentFieldsSort(this.payMethods[i].paymentConfigurationFields);
          }
          if (this.payMethods[i].billConfigurationFields) {
            billingFieldsSort(this.payMethods[i].billConfigurationFields);
          }
          // 子支付方式
          if (this.payMethods[i].children && this.payMethods[i].children.length) {
            for (let j = 0; j < this.payMethods[i].children.length; j++) {
              const subMethod = this.payMethods[i].children[j];
              if (subMethod.paymentConfigurationFields) {
                paymentFieldsSort(subMethod.paymentConfigurationFields);
              }
              if (subMethod.billConfigurationFields) {
                billingFieldsSort(subMethod.billConfigurationFields);
              }
              subMethod.rules = {};
              const subMethodFields = [];
              if (subMethod.paymentConfigurationFields) {
                subMethodFields.push(...subMethod.paymentConfigurationFields);
              }
              if (subMethod.billConfigurationFields) {
                subMethodFields.push(...subMethod.billConfigurationFields);
              }
              fieldConfigurationRulesAndNamesHandler(subMethodFields, subMethod.rules, this.order.paymentCountry);
              this.initFormData(subMethod.cardName, subMethodFields);
            }
          }
          const method = this.payMethods[i];
          // // 配置字段处理
          const methodFields = [];
          if (method.paymentConfigurationFields) {
            methodFields.push(...method.paymentConfigurationFields);
          }
          if (method.billConfigurationFields) {
            methodFields.push(...method.billConfigurationFields);
          }
          if (method.cardName === 'CARD') {
            method.rules = cardFormRules();
            this.cardFieldConfigurationNames = fieldConfigurationRulesAndNamesHandler(methodFields, method.rules, this.order.paymentCountry);
            this.getCardTypeInfos(method.cardTypeInfo);
          } else {
            if (method.paymentConfigurationFields) {
              method.rules = {};
              fieldConfigurationRulesAndNamesHandler(methodFields, method.rules, this.order.paymentCountry);
            }
          }
          this.initFormData(method.cardName, methodFields);
          if (method.cardName === 'GooglePay') {
            this.googlePayGatewayMerchantId = method.gatewayMerchantId;
            this.googlePayMerchantId = method.merchantId;
            this.gatewayName = method.gatewayName;
          } else if (method.cardName === 'ApplePay') {
            this.applePayMerchantIdentifier = method.merchantId;
            this.applePayGatewayName = method.gatewayName;
          }
        }
        this.cardInfoLoading = false;
        this.submitBtnLoading = false;
        this.$emit('updateStatus', CHECKOUT_STATUS.FILLING);
        // TODO NEMO
        this.$nextTick(() => {
          this.supportGooglePay && this.initGooglePayButton();
          this.supportApplePay && this.initApplePayButton();
        });
      }).catch(() => {
        this.cardInfoLoading = false;
        this.submitBtnLoading = false;
        this.$emit('updateStatus', CHECKOUT_STATUS.ERROR, '', this.order);
      });
    },

    methodChange(value) {
      // 支付方式切换时，清空银行选择
      this.selectedBankCode = undefined;
      this.paymentType = this.payMethods[value].cardName === 'CARD' ? 'CARD' : 'LOCAL';
      // 当卡支付和本地支付国家一致时，账单地址数据不隔离，否则账单地址数据隔离
      const newMethod = this.payMethods[value].cardName;
      const oldMethod = this.payMethods[this.older.method].cardName;
      if ((newMethod === 'CARD' || oldMethod === 'CARD') && (this.form.CARD.country === this.form.LOCAL.country)) {
        if (newMethod === 'CARD') {
          for (const localItem in this.form.LOCAL) {
            if (this.form.LOCAL[localItem]) {
              this.form.CARD[localItem] = this.form.LOCAL[localItem];
            }
          }
        } else {
          for (const cardItem in this.form.CARD) {
            if (this.form.CARD[cardItem]) {
              this.form.LOCAL[cardItem] = this.form.CARD[cardItem];
            }
          }
        }
      }
      this.older.method = value;
      if (newMethod === 'GooglePay') {
        this.initGooglePayButton();
      } else if (newMethod === 'ApplePay') {
        this.initApplePayButton();
      }
      this.sendGaEvent(this.order, 'select_payment_method');
      this.sendRiskDeviceFingerPrint({ e: 'select_payment_method' });
    },
    subMethodChange(value) {
      this.$refs.formRef[this.activePaymentMethod].clearValidate();
    },
    cardNumberBlur() {
      const cardNum = this.form[this.paymentType].cardNum.replace(/\s*/g, '');
      const card = getCard(this.form[this.paymentType].cardNum, false);

      // 若输出卡种不对，则分期不可选，否则分期可选
      if (cardNum.length > 10 && luhn(cardNum)) {
        this.instalmentDisabled = false;
        if (this.older.cardNum !== cardNum) {
          this.form.CARD.periodValue = '';
          this.instalmentRefresh = true;
        }
      } else {
        this.instalmentDisabled = true;
        this.form.CARD.periodValue = '';
      }

      /**
       * 更新卡种、账单、分期信息
       * 1. 没找到前端正则匹配卡种，不同卡号，且卡号长度>10
       * 2. 前端正则可匹配到卡种，且与老卡种不同, 且卡号长度>10
       */
      const diffCardNumber = !card && this.older.cardNum !== cardNum;
      const diffCardType = card && card.cardType !== this.older.cardType;
      if ((diffCardNumber || diffCardType || !this.freshFieldConfigSuccess) && cardNum.length > 10 && luhn(cardNum)) {
        this.fieldConfigurationUpdate(cardNum);
      }
      this.older.cardNum = cardNum;
      if (card) {
        this.older.cardType = card.cardType;
      }
      if (cardNum > 0) {
        this.formInlineItemBlurHandler();
      }
    },
    /**
     * 处理卡信息输入事件
     * event数据格式
     * @typedef {Object} event
     * @property {string} name - 表单名称
     * @property {string} value - 表单值
     */
    handleCardInfoInputFocus(event) {
      this.sendPaymentInfoFocusEvent(event.name);
    },
    handleCardInfoInputChange(event) {
      this.sendPaymentInfoInputEvent(event.name);
    },
    onIdentityNumberInput() {
      const country = this.form[this.paymentType].country;
      const value = this.form[this.paymentType].identityNumber;
      if (country === 'BR' && value) {
        let newValue = value.replace(/[^\d]/g, '');
        if (newValue.length === 11) {
          newValue = `${newValue.slice(0, 3)}.${newValue.slice(3, 6)}.${newValue.slice(6, 9)}-${newValue.slice(9, 11)}`;
        } else if (newValue.length === 14) {
          newValue = `${newValue.slice(0, 2)}.${newValue.slice(2, 5)}.${newValue.slice(5, 8)}/${newValue.slice(8, 12)}-${newValue.slice(12, 14)}`;
        }
        this.form[this.paymentType].identityNumber = newValue;
      }
    },
    onPostalCodeInput() {
      const country = this.form[this.paymentType].country;
      const value = this.form[this.paymentType].postalCode;
      if (country === 'US' && value) {
        if (value.length === 9 && value.indexOf('-') === -1) {
          const newValue = `${value.slice(0, 5)}-${value.slice(5, value.length)}`;
          this.form[this.paymentType].postalCode = newValue;
        }
      }
    },
    keyupName(evt, key) {
      this.form.CARD[key] = evt.target.value.replace(/[\u4e00-\u9fa5]/ig, '');
    },
    effectiveDateChangeHandler(evt) {
      if (evt.inputType === 'deleteContentBackward') {
        return;
      }
      const cardName = this.payMethods[this.activePaymentMethod].cardName;
      const formType = cardName === 'CARD' ? 'CARD' : 'LOCAL';
      this.form[formType].effectiveDate = this.form[formType].effectiveDate.replace(/[^\d/]/g, '');
      if (this.form[formType].effectiveDate.length > 0) {
        const dateArray = this.form[formType].effectiveDate.split('');
        if (dateArray[0] === '0' && dateArray[1] === '0') {
          dateArray[1] = 1;
          this.form[formType].effectiveDate = dateArray.join('');
        }
        if (dateArray.length >= 2 && dateArray.filter(i => { return i === '/'; }).length < 1) {
          dateArray[2] = '/';
          this.form[formType].effectiveDate = dateArray.join('');
        }
      }
    },
    issueDateChangeHandler(evt) {
      if (evt.inputType === 'deleteContentBackward') {
        return;
      }
      const cardName = this.payMethods[this.activePaymentMethod].cardName;
      const formType = cardName === 'CARD' ? 'CARD' : 'LOCAL';
      // 保留数字、斜杠和空格，移除其他字符
      this.form[formType].issueDate = this.form[formType].issueDate.replace(/[^\d/\s]/g, '');
      if (this.form[formType].issueDate.length > 0) {
        // 移除多余的空格，只保留数字和斜杠
        let cleanValue = this.form[formType].issueDate.replace(/\s/g, '').replace(/[^\d]/g, '');

        if (cleanValue.length > 0) {
          // 如果前两位是00，则将第二位改为1
          if (cleanValue.length >= 2 && cleanValue[0] === '0' && cleanValue[1] === '0') {
            cleanValue = '0' + '1' + cleanValue.substring(2);
          }

          // 格式化为 MM / YY 格式
          if (cleanValue.length >= 2) {
            const month = cleanValue.substring(0, 2);
            const year = cleanValue.substring(2, 4);
            if (cleanValue.length === 2) {
              this.form[formType].issueDate = month;
            } else {
              this.form[formType].issueDate = month + ' / ' + year;
            }
          } else {
            this.form[formType].issueDate = cleanValue;
          }
        }
      }
    },
    birthDateChangeHandler(evt) {
      if (evt.inputType === 'deleteContentBackward') {
        return;
      }
      const cardName = this.payMethods[this.activePaymentMethod].cardName;
      const formType = cardName === 'CARD' ? 'CARD' : 'LOCAL';
      // 只保留数字
      const digits = this.form[formType].birthDate.replace(/[^\d]/g, '');
      let value = digits;

      // 按 YYYY / MM / DD 格式添加分隔符
      if (digits.length >= 4) {
        value = digits.substring(0, 4) + ' / ' + digits.substring(4);
      }
      if (digits.length >= 6) { // 输入月份后自动添加第二个分隔符
        value = digits.substring(0, 4) + ' / ' + digits.substring(4, 6) + ' / ' + digits.substring(6);
      }

      this.form[formType].birthDate = value;
    },
    cvvChangeHandler() {
      if (this.paymentType === 'CARD') {
        this.form.CARD.cvv = this.form.CARD.cvv.replace(/[^\d]/g, '');
      } else {
        this.form.LOCAL.cvv = this.form.LOCAL.cvv.replace(/[^\d]/g, '');
      }
    },
    countryChange(value) { // 只有卡支付会触发此动作
      // 卡支付时国家变化，特定国家identityNumber字段名变化
      if (this.cardFieldConfigurationNames.includes('identityNumber')) {
        if ((!!this.identityNumberLabel[value]) !== (!!this.identityNumberLabel[this.older.country])) { // identityNumber Label有变动
          const rules = this.payMethods[this.activePaymentMethod].rules;
          if (rules.identityNumber && rules.identityNumber.length) {
            if (this.identityNumberLabel[value]) {
              rules.identityNumber[0] = allRules.required(this.identityNumberLabel[value], false, false);
            } else {
              rules.identityNumber[0] = allRules.required('message.checkout.identityNumber');
            }
          }
          const fieldRef = this.$refs.identityNumberRefCard[0];
          if (fieldRef.$el.className.indexOf('is-error') > -1) {
            this.$refs.formRef[this.activePaymentMethod].validateField('identityNumber');
          }
        }
      }
      // CARD支付国家切换时，state如果不符合，需要置空
      if (selectStateCountry.includes(value)) {
        let hasProvince = false;
        for (let i = 0; i < STATES_OPTIONS[value].length; i++) {
          if (this.form.CARD.province === STATES_OPTIONS[value][i].value) {
            hasProvince = true;
            break;
          }
        }
        if (!hasProvince) {
          this.form.CARD.province = '';
        }
      }
      // 国家变化，根据帐单国家或卡种+帐单国家动态获取字段配置中的帐单地址，不论是否分期支付
      this.fieldConfigurationUpdate(this.older.cardNumber);
      this.older.country = value;
    },
    countryChangeHandler(data) { // 切换国家
      const value = data.code;
      this.resetApplePayOrGooglePayForm = true;
      this.cardInfoLoading = true;
      // 置空分期信息
      this.form.CARD.periodValue = '';
      this.instalmentInfo = null;
      this.instalmentRefresh = true;
      getOrderInfo_aggregate({
        key: this.$route.query.key ? this.$route.query.key : this.$route.params.id,
        country: value,
        paymentMode: this.device.device,
        osType: this.device.system,
      }).then((res) => {
        this.submitBtnLoading = false;
        this.cardInfoLoading = false;
        this.$emit('updateStatus', CHECKOUT_STATUS.FILLING);
        if (res.respCode !== '20000') {
          if (this.exceptionShow(res)) {
            return;
          }
          this.$emit('updateStatus', CHECKOUT_STATUS.ERROR, '', this.order);
          return;
        }
        if (res.data.status === 'F') { // F跳转，失败页面
          this.$emit('updateStatus', CHECKOUT_STATUS.FAILED, '', this.order);
          return;
        }
        if (!res.data.paymentCountry) {
          this.$router.push({
            path: '/address/a',
            query: { merchantTxnId: this.order?.merchantTxnId || '', key: this.$route.query.key ? this.$route.query.key : this.$route.params.id, type: '2' },
          });
          return;
        }
        this.$store.dispatch('app/setBrandInfo', { ...(res.data.brandConfig || {}), website: res.data.website });
        if (res.data.brandConfig) {
          this.viewTxnId = res.data.brandConfig.viewTxnId;
          this.viewCancelBtn = res.data.brandConfig.viewCancelBtn;
          this.viewCountryBtn = res.data.brandConfig.viewCountryBtn;
        }
        this.order = res.data;
        this.$emit('updateOrder', res.data, true);

        // 更新Token支付相关数据 - 开发者：Nemo
        this.enableCheckoutToken = res.data.enableCheckoutToken || false;
        this.checkoutTokenInfos = res.data.checkoutTokenInfos || [];

        // 如果当前在Token支付模式，检查选中的卡片是否还存在
        if (this.useTokenPayment && this.selectedTokenCardId) {
          const cardStillExists = this.checkoutTokenInfos.some(c => c.id === this.selectedTokenCardId);
          if (!cardStillExists) {
            // 如果选中的卡片不存在了，清空选中ID（组件会自动选择第一张可用卡）
            this.selectedTokenCardId = '';
          }
        }

        if (this.order.subscription) {
          if (this.order.subscription.expireDate) {
            this.order.subscription.expireDateShow = this.order.subscription.expireDate.split('-');
            this.order.subscription.expireDateShow[1] = Number(this.order.subscription.expireDateShow[1]);
          } else {
            this.order.subscription.expireDateShow = ['', ''];
          }
        }
        this.form.CARD.country = res.data.paymentCountry;
        this.form.LOCAL.country = res.data.paymentCountry;
        // 安卓设备不显示ApplePay
        if (res.data.checkoutModels && res.data.checkoutModels?.length) {
          if (this.device.device === 'WAP' && this.device.system === 'ANDROID') {
            for (let i = 0; i < res.data.checkoutModels.length; i++) {
              if (res.data.checkoutModels[i].cardName === 'ApplePay') {
                res.data.checkoutModels.splice(i, 1);
                break;
              }
            }
          }
        }

        // 初始化googlePay和applePay的form下标
        for (let i = 0; i < res.data.checkoutModels?.length; i++) {
          if (res.data.checkoutModels[i].cardName === 'ApplePay') {
            this.applePayFormIndex = i;
          }
          if (res.data.checkoutModels[i].cardName === 'GooglePay') {
            this.googlePayFormIndex = i;
          }
        }

        // 没有支付方式时
        if (!res.data.checkoutModels || !res.data.checkoutModels.length) {
          showMessage(this.$t('message.result.emptyPaymentMethod'));
          this.cardInfoLoading = false;
          this.submitBtnLoading = false;
          this.$emit('updateStatus', CHECKOUT_STATUS.FILLING);
          this.payMethods = null;
          return;
        }
        // Venmo支付方式
        for (let i = 0; i < res.data.checkoutModels.length; i++) {
          const p = res.data.checkoutModels[i];
          if (p.cardName.toLowerCase() === 'venmo' && !showVenmoPayMethod()) {
            res.data.checkoutModels.splice(i, 1);
            break;
          }
        }
        // 查找卡支付
        const originPayments = res.data.checkoutModels;
        this.cardPayMethods = -1;
        for (let i = 0; i < originPayments.length; i++) {
          if (originPayments[i].cardName === 'CARD') {
            this.cardPayMethods = i;
            break;
          }
        }
        this.payMethods = originPayments;
        // CARD支付处理
        if (this.cardPayMethods > -1) {
          this.$store.dispatch('app/setCards', this.payMethods[this.cardPayMethods].cardTypeInfo);
          this.getCardTypeInfos(this.payMethods[this.cardPayMethods].cardTypeInfo);
        }
        // 默认选中第一个
        if (this.payMethods.length > 0) {
          this.activePaymentMethod = 0;
          this.lastPaymentMethod = 0;  // 同时设置lastPaymentMethod
          this.older.method = 0;
          this.activeChildPaymentMethod = '';
          this.older.subMethod = '';
          const findCardMethod = this.payMethods.find(item => item.cardName === 'CARD');
          if (findCardMethod) {
            this.activePaymentMethod = this.cardPayMethods;
            this.lastPaymentMethod = this.cardPayMethods;  // 同时设置lastPaymentMethod
          }
          if (this.payMethods[0].children && this.payMethods[0].children.length) {
            this.activeChildPaymentMethod = 0;
            this.older.subMethod = 0;
          }
          this.paymentType = this.payMethods[this.activePaymentMethod].cardName === 'CARD' ? 'CARD' : 'LOCAL';
        }
        for (let i = 0; i < this.payMethods.length; i++) {
          // TODO:商户指定支付方式， 这里原来的逻辑是清理掉了card支付方式
          if (this.payMethods[i].isSelect === 'Y' && this.payMethods[i].cardName !== 'CARD') {
            this.activePaymentMethod = i;
            this.lastPaymentMethod = i;  // 同时设置lastPaymentMethod
            this.older.method = i;
            this.paymentType = this.payMethods[this.activePaymentMethod].cardName === 'CARD' ? 'CARD' : 'LOCAL';
            if (this.payMethods[i].children && this.payMethods[i].children.length) {
              for (let j = 0; j < this.payMethods[i].children.length; j++) {
                const subMethod = this.payMethods[i].children[j];
                if (subMethod.isSelect === 'Y') {
                  this.activeChildPaymentMethod = j;
                  this.older.subMethod = j;
                  break;
                }
              }
            }
          }
          // 排序
          if (this.payMethods[i].paymentConfigurationFields) {
            paymentFieldsSort(this.payMethods[i].paymentConfigurationFields);
          }
          if (this.payMethods[i].billConfigurationFields) {
            billingFieldsSort(this.payMethods[i].billConfigurationFields);
          }
          // 子支付方式
          if (this.payMethods[i].children && this.payMethods[i].children.length) {
            for (let j = 0; j < this.payMethods[i].children.length; j++) {
              const subMethod = this.payMethods[i].children[j];
              paymentFieldsSort(subMethod.paymentConfigurationFields);
              billingFieldsSort(subMethod.billingFieldsSort);
              subMethod.rules = {};
              const subMethodFields = [];
              if (subMethod.paymentConfigurationFields) {
                subMethodFields.push(...subMethod.paymentConfigurationFields);
              }
              if (subMethod.billConfigurationFields) {
                subMethodFields.push(...subMethod.billConfigurationFields);
              }
              fieldConfigurationRulesAndNamesHandler(subMethodFields, subMethod.rules, this.order.paymentCountry);
              this.initFormData(subMethod.cardName, subMethodFields);
            }
          }
          const method = this.payMethods[i];
          const methodFields = [];
          if (method.paymentConfigurationFields) {
            methodFields.push(...method.paymentConfigurationFields);
          }
          if (method.billConfigurationFields) {
            methodFields.push(...method.billConfigurationFields);
          }
          // 配置字段处理
          if (method.cardName === 'CARD') {
            method.rules = cardFormRules();
            this.cardFieldConfigurationNames = fieldConfigurationRulesAndNamesHandler(methodFields, method.rules, this.order.paymentCountry);
          } else {
            method.rules = {};
            fieldConfigurationRulesAndNamesHandler(methodFields, method.rules, this.order.paymentCountry);
          }
          this.initFormData(method.cardName, methodFields);
          if (method.cardName === 'GooglePay') {
            this.googlePayGatewayMerchantId = method.gatewayMerchantId;
            this.googlePayMerchantId = method.merchantId;
            this.gatewayName = method.gatewayName;
          } else if (method.cardName === 'ApplePay') {
            this.applePayMerchantIdentifier = method.merchantId;
            this.applePayGatewayName = method.gatewayName;
          }
        }
        // 切换国家，初始化
        this.$nextTick(() => {
          this.supportGooglePay && this.initGooglePayButton();
          this.supportApplePay && this.initApplePayButton();
        });
        this.cardInfoLoading = false;
        this.submitBtnLoading = false;
        this.$emit('updateStatus', CHECKOUT_STATUS.FILLING);
      }).catch(() => {
        this.cardInfoLoading = false;
        this.submitBtnLoading = false;
      });
      this.sendGaEvent(this.order, 'select_country');
      this.sendRiskDeviceFingerPrint({ e: 'select_country' });
    },
    CloseEventerr() {
      this.isShowErr = false;
    },
    getInstalmentList() {
      if (!this.instalmentRefresh) {
        return;
      }
      this.instalmentLoading = true;

      const params = {
        appId: this.order.appId,
        merchantNo: this.order.merchantNo,
        amount: this.order.txnAmount,
        currency: this.order.txnCurrency,
        cardInfo: {
          cardNumber: this.form.CARD.cardNum.replace(/\s*/g, ''),
        },
        country: this.form.CARD.country,
      };
      getInstallmentInfo(params).then((res) => {
        if (res.respCode === '20000') {
          this.instalmentRefresh = false;
          this.instalmentInfo = res.data;
        }

        this.instalmentLoading = false;

        // 使用$nextTick确保installmentOptions计算属性更新完成后再设置默认值
        this.$nextTick(() => {
          if (this.instalmentInfo && this.instalmentInfo.stages && this.instalmentInfo?.stages?.find(item => item.stageNumber === '1')) {
            this.$set(this.form.CARD, 'periodValue', '1');
          }
        });
      }).catch(() => {
        this.instalmentLoading = false;
        showMessage(this.$t('message.error.timeout'));
      });
    },
    intallmentChange(item) {
      // 当选择分期，分期没选项时提示错误消息
      const value = this.form.CARD.intallment;
      if (value === 1 && (!item.stagesInformation || !item.stagesInformation.length)) {
        this.form.CARD.intallment = 2;
        this.form.CARD.periodValue = '';
        showMessage(this.$t('message.validator.intallmentCardOrCountryNotSupport'));
      }
    },
    initFormData(type, fieldConfiguration) {
      const formType = type === 'CARD' ? 'CARD' : 'LOCAL';
      fieldConfiguration && fieldConfiguration.forEach((field) => {
        if (field.value && !['cardNum', 'cvv', 'effectiveDate', 'cardHolderName'].includes(field.name)) {
          this.form[formType][field.name] = field.value;
          if (field.name === 'province' && selectStateCountry.includes(this.order.paymentCountry)) {
            let rightProvince = false;
            for (let i = 0; i < STATES_OPTIONS[this.order.paymentCountry].length; i++) {
              if (field.value && (field.value.toUpperCase().trim() === STATES_OPTIONS[this.order.paymentCountry][i].value)) {
                this.form[formType][field.name] = field.value.toUpperCase().trim();
                rightProvince = true;
                break;
              }
            }
            if (!rightProvince) {
              this.form[formType][field.name] = '';
            }
          }

          if (field.name === 'identityNumber') { // 格式化 identityNumber
            this.onIdentityNumberInput();
          }

          if (field.name === 'postalCode') {
            this.onPostalCodeInput();
          }
        }
      });
    },
    fieldConfigurationUpdate(cardNumber) { // 卡支付更新配置信息
      this.cardInfoLoading = true;
      // 置空分期信息
      this.form.CARD.periodValue = '';
      this.instalmentInfo = null;
      this.instalmentRefresh = true;
      getFieldConfig_checkout({
        key: this.$route.query.key ? this.$route.query.key : this.$route.params.id,
        cardNumber,
        country: this.form.CARD.country,
      }).then((res) => {
        if (res.respCode !== '20000') {
          if (this.exceptionShow(res)) {
            return;
          }
          this.freshFieldConfigSuccess = false;
          this.cardInfoLoading = false;
          this.submitBtnLoading = false;
          this.$emit('updateStatus', CHECKOUT_STATUS.FILLING);
          if (res.respCode === '00020|50036') {
            showMessage(this.$t('message.error.cardNumber'));
          } else {
            showMessage(this.$t('message.error.timeout'));
          }
          return;
        }
        this.freshFieldConfigSuccess = true;
        // 更新fieldConfiguration信息
        deleteFieldConfigurationRules(this.payMethods[this.cardPayMethods].rules);
        paymentFieldsSort(res.data.paymentConfigurationFields);
        billingFieldsSort(res.data.billConfigurationFields);
        const fields = [];
        if (res.data.paymentConfigurationFields) {
          fields.push(...res.data.paymentConfigurationFields);
        }
        if (res.data.billConfigurationFields) {
          fields.push(...res.data.billConfigurationFields);
        }
        this.cardFieldConfigurationNames = fieldConfigurationRulesAndNamesHandler(fields, this.payMethods[this.cardPayMethods].rules, this.order.paymentCountry);
        this.payMethods[this.cardPayMethods].rules = { ...this.payMethods[this.cardPayMethods].rules };
        // 更新页面的验证提示消息
        this.$nextTick(() => {
          const timer = setTimeout(() => {
            this.$refs.formRef[this.activePaymentMethod].validate();
            clearTimeout(timer);
          });
        });
        this.payMethods[this.cardPayMethods].paymentConfigurationFields = res.data.paymentConfigurationFields;
        this.payMethods[this.cardPayMethods].billConfigurationFields = res.data.billConfigurationFields;
        this.order.canInstallment = res.data.canInstallment;

        this.cardInfoLoading = false;
        this.submitBtnLoading = false;
        this.$emit('updateStatus', CHECKOUT_STATUS.FILLING);
      }).catch(() => {
        this.cardInfoLoading = false;
        this.submitBtnLoading = false;
        this.$emit('updateStatus', CHECKOUT_STATUS.FILLING);
        this.freshFieldConfigSuccess = false;
        showMessage(this.$t('message.error.timeout'));
      });
    },

    // 只有点击支付按钮才进行 必填校验 因此点击时将必填规则设置为true
    setRequiredRule() {
      const that = this;
      // 这里取消缓存的原因是因为，可能会有规则刷新的情况（切换国家），以防万一，每次点支付都重置「必填设置」
      return new Promise((resolve) => {
        try {
          that.isPayRequired = true;
          const requiredRules = {};
          for (const key in that.payMethods[that.activePaymentMethod]?.rules) {
            requiredRules[key] = that.payMethods[that.activePaymentMethod]?.rules[key]?.map((item) => {
              return { ...item, required: item?.name === 'required' };
            });
          }
          // 不修改引用地址 不会触发子组件的computed更新
          that.payMethods[that.activePaymentMethod].rules = { ...requiredRules };
          // that.payMethods = [];
          that.payMethods = [...that.payMethods];

          resolve(true);
        } catch (error) {
          resolve(false);
        }
      });
    },

    // 定义一个统一的滚动处理函数
    scrollToFirstError() {
      setTimeout(() => {
        this.$nextTick(() => {
          // 确保账单信息区域展开
          if (!this.showBillingForm) {
            this.showBillingForm = true;
          }

          // 获取所有错误元素，包括 .is-error 和 .is-invalid
          const errorElements = document.querySelectorAll('.is-error, .is-invalid');
          if (errorElements && errorElements.length > 0) {
            // 获取所有错误元素的位置信息
            const positions = Array.from(errorElements).map(el => ({
              element: el,
              top: el.getBoundingClientRect().top + window.pageYOffset,
            }));

            // 找到最顶部的错误元素
            const firstError = positions.reduce((prev, curr) =>
              prev.top < curr.top ? prev : curr,
            );

            // 滚动到该元素
            firstError.element.scrollIntoView({
              block: 'center',
              behavior: 'smooth',
            });
          }
        });
      }, 100); // 给予一个小延迟，确保验证状态已经应用
    },

    async submit() {
      this.sendGaEvent(this.order, 'click_payment_button');
      this.sendRiskDeviceFingerPrint({ e: 'click_payment_button' });

      // 只有卡支付才会做提交的时候做必填校验，其他的必填校验
      const setResult = await this.setRequiredRule();
      if (!setResult) {
        return;
      }

      // 收集并发送校验失败埋点
      this.trackAllValidationErrors();

      if (this.activePaymentMethod === this.cardPayMethods) {
        try {
          if (this.$refs[`cardInformationRef${this.activePaymentMethod}`][0]) {
            const cardValidateResult = this.$refs[`cardInformationRef${this.activePaymentMethod}`][0].getValidateResult();
            if (!cardValidateResult) {
              this.scrollToFirstError();
              return;
            }
          }
        } catch (error) {

        }
      }
      this.$refs.formRef[this.activePaymentMethod].validate((valid) => {
        this.sendGaEvent(this.order, 'click_result', '', { result: valid ? 'S' : 'F' });
        this.sendRiskDeviceFingerPrint({ e: 'click_result' });

        if (valid) {
          // 避免重复提交
          if (this.submitBtnLoading) return;
          this.submitBtnLoading = true;
          // this.cardInfoLoading = true;
          // this.$emit('updateStatus', CHECKOUT_STATUS.SUBMITTING);
          const submitData = this.getPaymentData();

          this.requestPayment(submitData);
        } else {
          this.scrollToFirstError();
        }
      });
      this.formInlineItemBlurHandler();
    },

    requestPayment(submitData, applePaySession = null) {
      // 开始调用支付
      this.sendRiskDeviceFingerPrint({ e: 'start_request_payment' });

      if (this.retryInfo.retry === '1') {
        submitData.transSceneFlag = this.retryInfo.transSceneFlag;
      }

      payment(submitData).then((res) => {
        this.$emit('updateStatus', CHECKOUT_STATUS.FILLING);
        try {
          this.sendGaEvent(this.order, 'payment_result', '', { result: res.data && res.data.status ? res.data.status : 'F', result_desc: res.respMsg });
          this.sendRiskDeviceFingerPrint({ e: 'payment_result' });
        } catch (err) { }

        if (res.respCode === '20000') {
          if (res.data.status === 'F') {
            if (applePaySession) {
              applePaySession.completePayment(applePaySession.STATUS_FAILURE);
            }
            // 重试标记，0 - 否，1 - 可重试
            // 新增允许重试，如果配置的商户允许重试，重试标记为1
            // 允许重这个订单不做失效处理
            if (res.data.retry === '1') {
              this.isShowErr = true;
              this.scrollToTop();
              this.retryInfo.retry = res.data.retry;
              this.retryInfo.retryAdvice = res.data.retryAdvice;
              this.form.CARD.cvv = '';
              this.form.LOCAL.cvv = '';
              this.cardInfoLoading = false;
              this.submitBtnLoading = false;
              this.activePaymentMethod = this.lastPaymentMethod;
              this.$emit('updateStatus', CHECKOUT_STATUS.FILLING);
              this.$emit('updateOrder', { ...this.order, ...res.data });
              return;
            }
            this.$emit('updateStatus', CHECKOUT_STATUS.FAILED, res.data?.reason || res.respMsg || '', {
              ...this.order,
              redirectUrl: res?.data?.redirectUrl,
            });
            return;
          } if (res.data.status === 'S') {
            this.submitBtnLoading = false;
            if (applePaySession) {
              applePaySession.completePayment(applePaySession.STATUS_SUCCESS);
            }
            this.$emit('updateStatus', CHECKOUT_STATUS.SUCCESS, '', {
              ...this.order,
              redirectUrl: res?.data?.redirectUrl,
            });
          } else if (res.data.status === 'P') {
            if (applePaySession) {
              applePaySession.completePayment(applePaySession.STATUS_SUCCESS);
            }
            this.$emit('updateStatus', CHECKOUT_STATUS.PENDING, '', this.order);
          } else if (res.data.status === 'R') {
            if (applePaySession) {
              applePaySession.completePayment(applePaySession.STATUS_SUCCESS);
            }
            if (res.data.redirectEnum === 'QrCode') {
              // 取displayType=IMAGE的作为QRCODE
              let qrcode = '';
              if (res.data.codeForm.codeDetails) {
                for (let i = 0; i < res.data.codeForm.codeDetails.length; i++) {
                  if (res.data.codeForm.codeDetails[i].displayType === 'IMAGE') {
                    qrcode = res.data.codeForm.codeDetails[i].codeValue;
                    break;
                  }
                }
              }
              this.$router.push({
                path: '/payment/qrcode',
                query: {
                  merchantTxnId: this.order?.merchantTxnId || '',
                  key: this.$route.query.key ? this.$route.query.key : this.$route.params.id,
                  code: qrcode,
                  type: '2',
                },
              });
            } else if (res.data.redirectEnum === 'ShowContext') {
              const { paymentMethod } = res.data;
              const _paymentMethod = paymentMethod.toUpperCase();
              const payType = _paymentMethod.split('_')[0];
              switch (payType) {
                // QR_PH:这个值是后端配置的 后端配置的时候一定要存在QR且已"QR_"开头
                case 'QR':
                  this.$router.push({
                    // 这是个公共页面QR页面
                    path: '/payment/local/qrcode',
                    // eslint-disable-next-line indent
                    query: {
                      txnId: res.data.txnId,
                      type: '2',
                    },
                  });
                  break;
                case 'DANA':
                  this.$router.push({
                    // 这是个公共页面QR页面
                    path: '/payment/local/dana',
                    // eslint-disable-next-line indent
                    query: {
                      txnId: res.data.txnId,
                      type: '2',
                    },
                  });
                  break;
                case 'DOKU':
                  this.$router.push({
                    path: '/payment/local/doku',
                    query: {
                      txnId: res.data.txnId,
                      type: '2',
                    },
                  });
                  break;
                case 'QRIS':
                  this.$router.push({
                    path: '/payment/local/qris',
                    query: {
                      txnId: res.data.txnId,
                      type: '2',
                      key: this.key,
                    },
                  });
                  break;
                case 'PROMPTPAY':
                  this.$router.push({
                    path: '/payment/local/qris',
                    // eslint-disable-next-line indent
                    query: {
                      txnId: res.data.txnId,
                      type: '2',
                      key: this.key,
                    },
                  });
                  break;
                case 'TRUEMONEY':
                  this.$router.push({
                    path: '/payment/local/qris',
                    // eslint-disable-next-line indent
                    query: {
                      txnId: res.data.txnId,
                      type: '2',
                      key: this.key,
                    },
                  });
                  break;
                default:
                  // 历史遗留 默认的PIX支付页面
                  this.$router.push({
                    path: '/payment/local',
                    query: {
                      txnId: res.data.txnId,
                      type: '2',
                    },
                  });
                  break;
              }
            } else {
              const { activePaymentMethod, payMethods } = this;
              const currentMethod = payMethods.find((item, index) => index === activePaymentMethod);
              if (currentMethod && currentMethod.cardName === 'NINE_PAY_EWALLET') {
                const link = document.createElement('a');
                link.href = res?.data?.redirectUrl;
                link.rel = 'noreferrer';
                document.body.appendChild(link);
                link.click(); // 模拟点击跳转
                document.body.removeChild(link);
                return;
              }
              window.location.href = res?.data?.redirectUrl;
            }
          }
        } else {
          // 重试标记，0 - 否，1 - 可重试
          // 新增允许重试，如果配置的商户允许重试，重试标记为1
          // 允许重这个订单不做失效处理
          if (res?.data?.retry === '1') {
            this.isShowErr = true;
            this.scrollToTop();
            this.retryInfo.retry = res.data.retry;
            this.retryInfo.retryAdvice = res.data.retryAdvice;
            this.form.CARD.cvv = '';
            this.form.LOCAL.cvv = '';
            this.cardInfoLoading = false;
            this.submitBtnLoading = false;
            this.activePaymentMethod = this.lastPaymentMethod;
            this.$emit('updateStatus', CHECKOUT_STATUS.FILLING);
            this.$emit('updateOrder', { ...this.order, ...res.data });
            return;
          }
          if (applePaySession) {
            applePaySession.completePayment(applePaySession.STATUS_FAILURE);
          }
          if (!this.exceptionShow(res)) {
            this.$emit('updateStatus', CHECKOUT_STATUS.FAILED, res.respMsg || res.data?.reason || res.msg || '', {
              ...this.order,
              redirectUrl: res?.data?.redirectUrl,
            });
          } else {
            this.cardInfoLoading = false;
            this.submitBtnLoading = false;
            this.$emit('updateStatus', CHECKOUT_STATUS.FILLING);
          }
        }
      }).catch(() => {
        this.submitBtnLoading = false;
        this.activePaymentMethod = this.lastPaymentMethod;
        this.cardInfoLoading = false;

        // 针对提交支付这个动作，发生任何的错误或异常，原则上来说都不能做继续输入的操作了，统一跳转到报错页
        this.$emit('updateStatus', CHECKOUT_STATUS.FAILED);

        if (applePaySession) {
          applePaySession.completePayment(applePaySession.STATUS_FAILURE);
        }
      });
    },
    updateValidateTip() { // 卡支付更新配置字段时触发
      [...paymentFields, ...billingFields].forEach((field) => {
        const element = this.$refs[`${field}RefCard`] && this.$refs[`${field}RefCard`][0];
        if (element) {
          if (element.$el.className.indexOf('is-error') > -1) {
            this.$refs.formRef[this.activePaymentMethod].clearValidate(field);
          }
        }
      });
    },
    getPaymentData(payToken = '') {
      const currentMethod = this.payMethods[this.activePaymentMethod];
      const fieldConfiguration = [];
      if (currentMethod.paymentConfigurationFields) {
        fieldConfiguration.push(...currentMethod.paymentConfigurationFields);
      }
      if (currentMethod.billConfigurationFields) {
        fieldConfiguration.push(...currentMethod.billConfigurationFields);
      }
      let methodType = currentMethod.cardName;
      if (currentMethod.children && currentMethod.children.length) {
        const subMethod = currentMethod.children[this.activeChildPaymentMethod];
        methodType = subMethod.cardName;
        if (subMethod.paymentConfigurationFields) {
          fieldConfiguration.push(...subMethod.paymentConfigurationFields);
        }
        if (subMethod.billConfigurationFields) {
          fieldConfiguration.push(...subMethod.billConfigurationFields);
        }
      }
      const browerInfo = getBrowerInfo();
      const submitData = {
        key: this.$route.query.key ? this.$route.query.key : this.$route.params.id,
        cardName: methodType,
        paymentMode: this.device.device,
        osType: this.device.system,
        sessionId: this.key,
        referer: window.document.referrer,
        ...browerInfo,
      };
      if (methodType === 'CARD') {
        submitData.cardNumber = this.form.CARD.cardNum.replace(/\s*/g, '');
        submitData.month = this.form.CARD.effectiveDate.split('/')[0]?.trim();
        submitData.year = getCardExpiredFullYear(this.form.CARD.effectiveDate.split('/')[1]?.trim());
        submitData.cvv = this.form.CARD.cvv;
        submitData.holderName = this.form.CARD.cardHolderName?.trim();
        // 保存卡片标识 - 只有为true时才添加
        if (this.checkoutBindCard === true) {
          submitData.checkoutBindCard = true;
        }
        if (this.form.CARD.periodValue) {
          submitData.periodValue = this.form.CARD.periodValue;
          if (this.instalmentInfo.institution === 'DLOCAL') {
            for (let i = 0; i < this.instalmentInfo.stages.length; i++) {
              const stage = this.instalmentInfo.stages[i];
              if (stage.stageNumber === this.form.CARD.periodValue) {
                submitData.installmentPlanId = stage.installmentPlanId;
                break;
              }
            }
          }
        }
        if (fieldConfiguration && fieldConfiguration.length) {
          fieldConfiguration.forEach((item) => {
            if (!['cardNum', 'effectiveDate', 'cardHolderName'].includes(item.name)) {
              submitData[item.name] = this.form.CARD[item.name];
            }
          });
        }
      } else {
        if (fieldConfiguration && fieldConfiguration.length) {
          fieldConfiguration.forEach((item) => {
            if (item.name === 'cardNum') {
              submitData.cardNumber = this.form.LOCAL.cardNum.replace(/\s*/g, '');
            } else if (item.name === 'effectiveDate') {
              submitData.month = this.form.LOCAL.effectiveDate.split('/')[0]?.trim();
              submitData.year = getCardExpiredFullYear(this.form.LOCAL.effectiveDate.split('/')[1]?.trim());
            } else if (item.name === 'cardHolderName') {
              submitData.holderName = this.form.LOCAL.cardHolderName?.trim();
            } else if (item.name === 'walletAccountName') {
              submitData.holderName = this.form.LOCAL.walletAccountName;
            } else {
              submitData[item.name] = this.form.LOCAL[item.name];
            }
          });
        }
      }
      submitData.country = this.form.CARD.country;
      if (methodType === 'GooglePay') {
        submitData.tokenInfo = {
          provider: 'GooglePay',
          tokenId: payToken,
        };
        submitData.gatewayName = this.gatewayName;
      } else if (methodType === 'ApplePay') {
        submitData.tokenInfo = {
          provider: 'ApplePay',
          tokenId: payToken,
        };
        submitData.gatewayName = this.applePayGatewayName;
      }
      if (submitData.identityNumber) {
        submitData.identityNumber = submitData.identityNumber?.trim();
        if (submitData.country === 'BR') {
          submitData.identityNumber = submitData.identityNumber.replace(/[^\d]/g, '');
        }
      }
      try {
        if (!submitData.key) { // key 为空，上报日志
          addLog({
            key: submitData.sessionId || '00000000000000000000000000000000',
            merchantNo: this.order.merchantNo,
            externalOrderId: this.older.merchantTxnId,
            message: '支付参数缺失 key: ' + JSON.stringify(submitData),
          });
          if (submitData.sessionId) {
            submitData.key = submitData.sessionId;
          }
        }
      } catch (err) {
        //
      }

      // 特殊卡种传参
      if (BankCardNames.includes(submitData.cardName)) {
        submitData.bankName = this.selectedBankCode;
      }

      // 处理birthDate、issueDate
      if (submitData.birthDate) {
        submitData.birthDate = submitData.birthDate?.replace(/\s*/g, '');
      }
      if (submitData.issueDate) {
        submitData.issueDate = submitData.issueDate?.replace(/\s*/g, '');
      }
      return submitData;
    },
    // 这里为什么要抽离 是因为googlePay从原来的交互设计中拿出来了，这里数据单独抽出来
    getGooglePayRequesData(payToken = '') {
      const currentMethod = this.payMethods[this.googlePayFormIndex];
      const fieldConfiguration = [];
      if (currentMethod.paymentConfigurationFields) {
        fieldConfiguration.push(...currentMethod.paymentConfigurationFields);
      }
      if (currentMethod.billConfigurationFields) {
        fieldConfiguration.push(...currentMethod.billConfigurationFields);
      }
      let methodType = currentMethod.cardName;
      if (currentMethod.children && currentMethod.children.length) {
        const subMethod = currentMethod.children[this.activeChildPaymentMethod];
        methodType = subMethod.cardName;
        if (subMethod.paymentConfigurationFields) {
          fieldConfiguration.push(...subMethod.paymentConfigurationFields);
        }
        if (subMethod.billConfigurationFields) {
          fieldConfiguration.push(...subMethod.billConfigurationFields);
        }
      }
      const browerInfo = getBrowerInfo();
      const submitData = {
        key: this.$route.query.key ? this.$route.query.key : this.$route.params.id,
        cardName: methodType,
        paymentMode: this.device.device,
        osType: this.device.system,
        sessionId: this.key,
        referer: window.document.referrer,
        ...browerInfo,
      };
      if (methodType === 'CARD') {
        submitData.cardNumber = this.form.CARD.cardNum.replace(/\s*/g, '');
        submitData.month = this.form.CARD.effectiveDate.split('/')[0].trim();
        submitData.year = getCardExpiredFullYear(this.form.CARD.effectiveDate.split('/')[1].trim());
        submitData.cvv = this.form.CARD.cvv;
        submitData.holderName = this.form.CARD.cardHolderName.trim();
        if (this.form.CARD.periodValue) {
          submitData.periodValue = this.form.CARD.periodValue;
          if (this.instalmentInfo.institution === 'DLOCAL') {
            for (let i = 0; i < this.instalmentInfo.stages.length; i++) {
              const stage = this.instalmentInfo.stages[i];
              if (stage.stageNumber === this.form.CARD.periodValue) {
                submitData.installmentPlanId = stage.installmentPlanId;
                break;
              }
            }
          }
        }
        if (fieldConfiguration && fieldConfiguration.length) {
          fieldConfiguration.forEach((item) => {
            if (!['cardNum', 'effectiveDate', 'cardHolderName'].includes(item.name)) {
              submitData[item.name] = this.form.CARD[item.name];
            }
          });
        }
      } else {
        if (fieldConfiguration && fieldConfiguration.length) {
          fieldConfiguration.forEach((item) => {
            if (item.name === 'cardNum') {
              submitData.cardNumber = this.form.LOCAL.cardNum.replace(/\s*/g, '');
            } else if (item.name === 'effectiveDate') {
              submitData.month = this.form.LOCAL.effectiveDate.split('/')[0].trim();
              submitData.year = getCardExpiredFullYear(this.form.LOCAL.effectiveDate.split('/')[1].trim());
            } else if (item.name === 'cardHolderName') {
              submitData.holderName = this.form.LOCAL.cardHolderName.trim();
            } else if (item.name === 'walletAccountName') {
              submitData.holderName = this.form.LOCAL.walletAccountName;
            } else {
              submitData[item.name] = this.form.LOCAL[item.name];
            }
          });
        }
      }
      submitData.country = this.form.CARD.country;
      if (methodType === 'GooglePay') {
        submitData.tokenInfo = {
          provider: 'GooglePay',
          tokenId: payToken,
        };
        submitData.gatewayName = this.gatewayName;
      } else if (methodType === 'ApplePay') {
        submitData.tokenInfo = {
          provider: 'ApplePay',
          tokenId: payToken,
        };
        submitData.gatewayName = this.applePayGatewayName;
      }
      if (submitData.identityNumber) {
        submitData.identityNumber = submitData.identityNumber.trim();
        if (submitData.country === 'BR') {
          submitData.identityNumber = submitData.identityNumber.replace(/[^\d]/g, '');
        }
      }
      try {
        if (!submitData.key) { // key 为空，上报日志
          addLog({
            key: submitData.sessionId || '00000000000000000000000000000000',
            merchantNo: this.order.merchantNo,
            externalOrderId: this.older.merchantTxnId,
            message: '支付参数缺失 key: ' + JSON.stringify(submitData),
          });
          if (submitData.sessionId) {
            submitData.key = submitData.sessionId;
          }
        }
      } catch (err) {
        //
      }

      if (BankCardNames.includes(submitData.cardName)) {
        submitData.bankName = this.selectedBankCode;
      }
      return submitData;
    },
    getApplePayRequesData(payToken = '') {
      const currentMethod = this.payMethods[this.applePayFormIndex];
      const fieldConfiguration = [];
      if (currentMethod.paymentConfigurationFields) {
        fieldConfiguration.push(...currentMethod.paymentConfigurationFields);
      }
      if (currentMethod.billConfigurationFields) {
        fieldConfiguration.push(...currentMethod.billConfigurationFields);
      }
      let methodType = currentMethod.cardName;
      if (currentMethod.children && currentMethod.children.length) {
        const subMethod = currentMethod.children[this.activeChildPaymentMethod];
        methodType = subMethod.cardName;
        if (subMethod.paymentConfigurationFields) {
          fieldConfiguration.push(...subMethod.paymentConfigurationFields);
        }
        if (subMethod.billConfigurationFields) {
          fieldConfiguration.push(...subMethod.billConfigurationFields);
        }
      }
      const browerInfo = getBrowerInfo();
      const submitData = {
        key: this.$route.query.key ? this.$route.query.key : this.$route.params.id,
        cardName: methodType,
        paymentMode: this.device.device,
        osType: this.device.system,
        sessionId: this.key,
        referer: window.document.referrer,
        ...browerInfo,
      };
      if (methodType === 'CARD') {
        submitData.cardNumber = this.form.CARD.cardNum.replace(/\s*/g, '');
        submitData.month = this.form.CARD.effectiveDate.split('/')[0].trim();
        submitData.year = getCardExpiredFullYear(this.form.CARD.effectiveDate.split('/')[1].trim());
        submitData.cvv = this.form.CARD.cvv;
        submitData.holderName = this.form.CARD.cardHolderName.trim();
        if (this.form.CARD.periodValue) {
          submitData.periodValue = this.form.CARD.periodValue;
          if (this.instalmentInfo.institution === 'DLOCAL') {
            for (let i = 0; i < this.instalmentInfo.stages.length; i++) {
              const stage = this.instalmentInfo.stages[i];
              if (stage.stageNumber === this.form.CARD.periodValue) {
                submitData.installmentPlanId = stage.installmentPlanId;
                break;
              }
            }
          }
        }
        if (fieldConfiguration && fieldConfiguration.length) {
          fieldConfiguration.forEach((item) => {
            if (!['cardNum', 'effectiveDate', 'cardHolderName'].includes(item.name)) {
              submitData[item.name] = this.form.CARD[item.name];
            }
          });
        }
      } else {
        if (fieldConfiguration && fieldConfiguration.length) {
          fieldConfiguration.forEach((item) => {
            if (item.name === 'cardNum') {
              submitData.cardNumber = this.form.LOCAL.cardNum.replace(/\s*/g, '');
            } else if (item.name === 'effectiveDate') {
              submitData.month = this.form.LOCAL.effectiveDate.split('/')[0].trim();
              submitData.year = getCardExpiredFullYear(this.form.LOCAL.effectiveDate.split('/')[1].trim());
            } else if (item.name === 'cardHolderName') {
              submitData.holderName = this.form.LOCAL.cardHolderName.trim();
            } else if (item.name === 'walletAccountName') {
              submitData.holderName = this.form.LOCAL.walletAccountName;
            } else {
              submitData[item.name] = this.form.LOCAL[item.name];
            }
          });
        }
      }
      submitData.country = this.form.CARD.country;
      if (methodType === 'GooglePay') {
        submitData.tokenInfo = {
          provider: 'GooglePay',
          tokenId: payToken,
        };
        submitData.gatewayName = this.gatewayName;
      } else if (methodType === 'ApplePay') {
        submitData.tokenInfo = {
          provider: 'ApplePay',
          tokenId: payToken,
        };
        submitData.gatewayName = this.applePayGatewayName;
      }
      if (submitData.identityNumber) {
        submitData.identityNumber = submitData.identityNumber.trim();
        if (submitData.country === 'BR') {
          submitData.identityNumber = submitData.identityNumber.replace(/[^\d]/g, '');
        }
      }
      try {
        if (!submitData.key) { // key 为空，上报日志
          addLog({
            key: submitData.sessionId || '00000000000000000000000000000000',
            merchantNo: this.order.merchantNo,
            externalOrderId: this.older.merchantTxnId,
            message: '支付参数缺失 key: ' + JSON.stringify(submitData),
          });
          if (submitData.sessionId) {
            submitData.key = submitData.sessionId;
          }
        }
      } catch (err) {
        //
      }

      // DANA_传参
      if (BankCardNames.includes(submitData.cardName)) {
        submitData.bankName = this.selectedBankCode;
      }
      return submitData;
    },
    async formInlineItemBlurHandler() {
      const name = this.payMethods[this.activePaymentMethod].cardName;
      if (name !== 'CARD') {
        return;
      }
      let message = '';
      await this.$refs.formRef[this.activePaymentMethod].validateField(['effectiveDate', 'cvv'], (error) => {
        message += error;
      });
      if (message) {
        this.marginBottom = '30px';
      } else {
        this.marginBottom = '10px';
      }
    },
    getCardTypeInfos(cards) {
      this.supportCardTypeNames = [];
      this.supportCardTypes = [];
      cards.forEach((item) => {
        // [VISA, MASTERCARD]卡种去重
        if (['VISA COMMERCIAL', 'MASTERCARD COMMERCIAL'].indexOf(item.cardType) < 0 ||
          (item.cardType === 'VISA COMMERCIAL' && this.supportCardTypeNames.indexOf('VISA') < 0) ||
          (item.cardType === 'MASTERCARD COMMERCIAL' && this.supportCardTypeNames.indexOf('MASTERCARD') < 0)) {
          this.supportCardTypeNames.push(item.cardType);
          this.supportCardTypes.push(item);
        }
      });
    },
    addGooglePayScript() {
      const googleScript = document.createElement('script');
      googleScript.src = 'https://pay.google.com/gp/p/js/pay.js';
      googleScript.onload = () => {
        this.googleScriptLoaded = 'success';
      };
      googleScript.onerror = () => {
        this.googleScriptLoaded = 'error';
      };
      document.body.appendChild(googleScript);
    },
    // sendGoogleToken(token) {
    //   const submitData = this.getPaymentData(token);
    //   this.cardInfoLoading = true;
    //   this.requestPayment(submitData);
    // },
    async sendGoogleToken(token) {
      this.lastPaymentMethod = this.activePaymentMethod;
      this.activePaymentMethod = this.googlePayFormIndex;
      const submitData = this.getGooglePayRequesData(token);
      submitData.appId = this.order.appId;
      this.cardInfoLoading = true;
      this.submitBtnLoading = true;
      try {
        const res = await googlePayValidateMerchant(submitData);
        if (res.respCode === '20000') {
          if (!res.data.checkResult && res.data.cardNum) {
            // 需要 cvv 验证
            this.cardInfoLoading = false;
            this.submitBtnLoading = false;
            this.showValidateCvvPopup = true;
            this.validateGooglePayCVVForm = {
              token,
              cardNum: res.data.cardNum,
              identityNumber: res.data.identityNumber || '',
              country: this.form.CARD.country || 'BR',
              googlePayPaymentConfigurationFields: res.data?.paymentConfigurationFields || [],
            };
            return;
          }
        }
      } catch (err) {
        //
        this.cardInfoLoading = false;
        this.submitBtnLoading = false;
        this.activePaymentMethod = this.lastPaymentMethod;
      }
      this.requestPayment(submitData);
    },
    onGooglePay(data) {
      // cvv校验通过埋点
      this.sendRiskDeviceFingerPrint({ e: 'google_pay_only_pass' });
      this.showValidateCvvPopup = false;
      const submitData = this.getPaymentData(data.token);
      submitData.cardInfo = { cvv: data.cvv };
      // 添加identityNumber到提交数据中
      if (data.identityNumber) {
        submitData.identityNumber = data.identityNumber.trim();
        // 处理巴西格式化
        if (submitData.country === 'BR') {
          submitData.identityNumber = submitData.identityNumber.replace(/[^\d]/g, '');
        }
      }
      this.cardInfoLoading = true;
      this.submitBtnLoading = true;
      this.requestPayment(submitData);
    },

    handleValidateCvvPopupCancel() {
      this.showValidateCvvPopup = false;
      this.activePaymentMethod = this.lastPaymentMethod;
    },

    googlePayUnsupport() {
      if (this.canShowPayReturnAlert) {
        this.showPayReturnAlert = true;
      }
    },
    initGooglePayButton() {
      // 获取GooglePay的countryCode - 开发者：Nemo
      const googlePayMethod = this.payMethods?.find(item => item.cardName === 'GooglePay');
      const countryCode = googlePayMethod?.countryCode || this.form.LOCAL.country;

      const transactionInfo = {
        countryCode,
        currencyCode: this.order.txnCurrency,
        totalPriceStatus: 'FINAL',
        // set to cart total
        totalPrice: this.order.txnAmount,
      };
      let allowedCardNetworks = [];
      let website = this.order.website;
      if (this.order.checkoutModels && this.order && this.order.checkoutModels.length) {
        const googlePayConfig = this.order.checkoutModels
          .find(item => item.cardName === 'GooglePay');

        allowedCardNetworks =
          this.order.checkoutModels
            .find(item => item.cardName === 'GooglePay')
            .cardTypeInfo
            .find(item => item.cardType === 'GooglePay')
            .subCardTypes;

        if (googlePayConfig && googlePayConfig.merchantName) {
          website = googlePayConfig.merchantName;
        }
      }

      const init = () => {
        this.googlePayInstance = GooglePay.init(this.googlePayConfig, {
          transactionInfo,
          gatewayName: this.gatewayName,
          gatewayMerchantId: this.googlePayGatewayMerchantId || this.googlePayMerchantId,
          merchantId: this.googlePayMerchantId,
          website,
          language: this.lang,
          merchantNo: this.order.merchantNo,
          externalOrderId: this.order.merchantTxnId,
          subscription: (this.order.subProductType === 'SUBSCRIBE' && this.order.subscription) ? this.order.subscription : '',
          gaData: {
            key: this.key,
            merchant_id: this.order.merchantNo,
            txn_id: this.order.txnId,
            checkout_type: '聚合',
            element_name: this.payMethods[this.activePaymentMethod],
            checkout_order_amount: this.order.txnAmount,
            checkout_order_currency: this.order.txnCurrency,
            checkout_language: this.lang,
            checkout_country: this.form.CARD.country,
          },
        }, '.google-pay-button', null, this.sendGoogleToken, this.googlePayUnsupport, allowedCardNetworks);
      };

      if (this.googleScriptLoaded === 'loading') {
        this.googleBtnLoading = true;
        const timer = setInterval(() => {
          if (this.googleScriptLoaded === 'success') {
            clearInterval(timer);
            init();
            this.googleBtnLoading = false;
          } else if (this.googleScriptLoaded === 'error') {
            clearInterval(timer);
            showMessage(this.$t('message.result.timeout'));
            this.googleBtnLoading = false;
            // Log
            addLog({
              merchantNo: this.order.merchantNo,
              externalOrderId: this.older.merchantTxnId,
              message: 'GooglePay script load error',
            });
          }
        }, 500);
      } else {
        if (this.googleScriptLoaded === 'success') {
          init();
        } else {
          showMessage(this.$t('message.result.timeout'));
          // Log
          addLog({
            merchantNo: this.order.merchantNo,
            externalOrderId: this.older.merchantTxnId,
            message: 'GooglePay script load error',
          });
        }
      }
    },
    addApplePayScript() {
      const applePayScript = document.createElement('script');
      applePayScript.src = 'https://applepay.cdn-apple.com/jsapi/v1/apple-pay-sdk.js';
      applePayScript.onload = () => {
        this.applePayScriptLoaded = 'success';
      };
      /** ***********  ✨ Codeium Command ⭐  *************/
      // Log an error if the Apple Pay script fails to load
      /** ****  9a12fccc-7bf8-4825-88a6-2d3f3981c2f8  *******/
      applePayScript.onerror = () => {
        this.applePayScriptLoaded = 'error';
      };
      document.body.appendChild(applePayScript);
    },
    async initApplePayButton() {
      if (this.applePayBtnShow !== 0) {
        if (this.applePayBtnShow === 2) {
          if (this.canShowPayReturnAlert) {
            this.showPayReturnAlert = true;
          }
        }
        return;
      }
      this.applePayBtnLoading = true;
      if (this.applePayScriptLoaded === 'loading') {
        const timer = setInterval(async () => {
          if (this.applePayScriptLoaded === 'success') {
            clearInterval(timer);
            const appPayEnable = await ApplePay.initButton(this.applePayMerchantIdentifier, this.lang, this.order.merchantNo, this.order.merchantTxnId);
            if (appPayEnable) {
              this.applePayBtnShow = 1;
            } else {
              this.applePayBtnShow = 2;
              if (this.canShowPayReturnAlert) {
                this.showPayReturnAlert = true;
              }
            }
            const timer1 = setTimeout(() => {
              this.applePayBtnLoading = false;
              clearTimeout(timer1);
            }, 1000);
          } else if (this.applePayScriptLoaded === 'error') {
            clearInterval(timer);
            showMessage(this.$t('message.result.timeout'));
            addLog({
              merchantNo: this.order.merchantNo,
              externalOrderId: this.older.merchantTxnId,
              message: 'ApplePay script load error',
            });
            this.applePayBtnShow = 2;
            if (this.canShowPayReturnAlert) {
              this.showPayReturnAlert = true;
            }
            this.applePayBtnLoading = false;
          }
        }, 500);
      } else if (this.applePayScriptLoaded === 'success') {
        const appPayEnable = await ApplePay.initButton(this.applePayMerchantIdentifier, this.lang, this.order.merchantNo, this.order.merchantTxnId);
        if (appPayEnable) {
          this.applePayBtnShow = 1;
        } else {
          this.applePayBtnShow = 2;
          if (this.canShowPayReturnAlert) {
            this.showPayReturnAlert = true;
          }
        }
        const timer1 = setTimeout(() => {
          this.applePayBtnLoading = false;
          clearTimeout(timer1);
        }, 1000);
      } else {
        showMessage(this.$t('message.result.timeout'));
        addLog({
          merchantNo: this.order.merchantNo,
          externalOrderId: this.older.merchantTxnId,
          message: 'ApplePay script load error',
        });
        this.applePayBtnShow = 2;
        if (this.canShowPayReturnAlert) {
          this.showPayReturnAlert = true;
        }
        this.applePayBtnLoading = false;
      }
    },

    handleGooglePayClick() {
      this.currentPaymentMethod = 'google';
      const dialog = this.$refs.responsiveDialog;
      const googlePayFileds = this.order.checkoutModels.find(item => item.cardName === 'GooglePay')?.billConfigurationFields;

      if (googlePayFileds && Array.from(googlePayFileds) && googlePayFileds.length > 0) {
        // 记录当前滚动位置
        this.scrollPosition = window.pageYOffset || document.documentElement.scrollTop;

        dialog.open({
          type: 'google',
          billingFields: googlePayFileds,
          resetForm: this.resetApplePayOrGooglePayForm,
        });

        this.resetApplePayOrGooglePayForm = false;
      } else {
        this.googlePayInstance.onGooglePaymentButtonClicked();
      }
    },

    handleApplePayClick() {
      this.currentPaymentMethod = 'apple';
      const dialog = this.$refs.responsiveDialog;
      const applePayFileds = this.order.checkoutModels.find(item => item.cardName === 'ApplePay')?.billConfigurationFields;

      if (applePayFileds && Array.from(applePayFileds) && applePayFileds.length > 0) {
        // 记录当前滚动位置
        this.scrollPosition = window.pageYOffset || document.documentElement.scrollTop;

        dialog.open({
          type: 'apple',
          billingFields: applePayFileds,
          resetForm: this.resetApplePayOrGooglePayForm,
        });

        this.resetApplePayOrGooglePayForm = false;
      } else {
        this.startApplePay();
      }
    },

    // 处理对话框关闭事件
    handleDialogClose() {
      // 恢复滚动位置，添加平滑过渡动画
      setTimeout(() => {
        window.scrollTo({
          top: this.scrollPosition,
          behavior: 'smooth',
        });
      }, 50);
    },

    // 响应式弹窗确认
    handleResponsiveDialogConfirm(data) {
      this.form.LOCAL = {
        ...this.form.LOCAL,
        ...data,
      };

      if (this.currentPaymentMethod === 'google') {
        this.googlePayInstance.onGooglePaymentButtonClicked();
      } else {
        this.startApplePay();
      }
    },

    startApplePay() {
      // this.$refs.formRef[this.applePayFormIndex].validate((valid) => {
      // this.activePaymentMethod = this.applePayFormIndex;
      this.sendGaEvent(this.order, 'click_payment_button');
      this.sendRiskDeviceFingerPrint({ e: 'click_payment_button', kal: 'AP' });
      // if (valid) {
      // 设置兜底 防止后端返回卡类型为空的情况
      let supportedNetworks = [];
      if (this.order.checkoutModels && this.order && this.order.checkoutModels.length) {
        supportedNetworks =
          this.order.checkoutModels
            .find(item => item.cardName === 'ApplePay')
            .cardTypeInfo
            .find(item => item.cardType === 'ApplePay')
            .subCardTypes;
      }
      // this.cardInfoLoading = true;
      // 获取ApplePay的countryCode - 开发者：Nemo
      const applePayMethod = this.payMethods?.find(item => item.cardName === 'ApplePay');
      const countryCode = applePayMethod?.countryCode || this.form.LOCAL.country;

      const request = {
        countryCode,
        currencyCode: this.order.txnCurrency,
        // supportedNetworks: ['visa', 'masterCard', 'amex', 'jcb', 'discover'],
        // 需求--修改为动态配置
        supportedNetworks: supportedNetworks && supportedNetworks.length ? supportedNetworks : ['visa', 'masterCard'],
        merchantCapabilities: ['supports3DS'],
        total: { label: this.order.website, type: 'final', amount: this.order.txnAmount },
      };
      if (this.order.subProductType === 'SUBSCRIBE' && this.order.subscription) {
        const subscription = this.order.subscription;
        let managementURL = this.order.website;
        if (!managementURL.startsWith('http')) {
          managementURL = `https://${managementURL}`;
        }
        // 订阅周期支持年  月 周  日
        let recurringPaymentIntervalUnit = 'day';
        switch (subscription.frequencyType) {
          case 'Y':
            recurringPaymentIntervalUnit = 'year';
            break;
          case 'M':
            recurringPaymentIntervalUnit = 'month';
            break;
          case 'W':
            recurringPaymentIntervalUnit = 'week';
            break;
          default:
            recurringPaymentIntervalUnit = 'day';
            break;
        }

        if (!subscription.amountOff) {
          request.recurringPaymentRequest = {
            paymentDescription: 'Recurring payment',
            managementURL,
            regularBilling: {
              label: 'Recurring',
              amount: this.order.txnAmount,
              recurringPaymentIntervalCount: subscription.frequencyPoint,
              recurringPaymentIntervalUnit, // 目前只支持天
              paymentTiming: 'recurring',
              type: 'final',
              // recurringPaymentEnd  Date: subscription.expireDate ? new Date(subscription.expireDate.replace(/-/g, '/')) : null,
              recurringPaymentEndDate: null,
            },
          };
        } else {
          const { billingCycleBeginAnchor } = subscription?.contractInfo;
          const { amountOffEnd } = subscription;
          const billingCycleBeginAnchorFormat = moment(billingCycleBeginAnchor).format('YYYY/MM/DD');
          const billingCycleAnchorFormat = moment(amountOffEnd).format('YYYY/MM/DD');
          request.recurringPaymentRequest = {
            paymentDescription: 'Recurring payment',
            managementURL,
            trialBilling: {
              label: 'Special Offer',
              amount: this.order?.txnAmount,
              type: "final",
              paymentTiming: "recurring",
              recurringPaymentIntervalCount: this.order?.subscription?.frequencyPoint,
              recurringPaymentIntervalUnit,
              recurringPaymentStartDate: new Date(billingCycleBeginAnchorFormat),
              recurringPaymentEndDate: new Date(billingCycleAnchorFormat),
            },
            regularBilling: {
              label: 'Then Full Service Plan',
              amount: this.order?.subscription?.orderAmount,
              recurringPaymentIntervalCount: this.order?.subscription?.frequencyPoint,
              recurringPaymentIntervalUnit,
              paymentTiming: 'recurring',
              type: 'final',
              recurringPaymentStartDate: new Date(billingCycleAnchorFormat),
              // recurringPaymentEndDate: subscription.expireDate ? new Date(subscription.expireDate.replace(/-/g, '/')) : null,
              recurringPaymentEndDate: null,
            },
          };
        }
      }
      try {
        ApplePay.startPay(request, this.key, this.order.merchantNo, this.order.merchantTxnId, this.applePayComplted, this.closeLoading);
      } catch (err) {
        this.cardInfoLoading = false;
        this.submitBtnLoading = false;
        this.$emit('updateStatus', CHECKOUT_STATUS.FILLING);
      }
      // }
      // });
    },
    applePayComplted(token, applePaySession) {
      const submitData = this.getApplePayRequesData(JSON.stringify(token));
      this.submitBtnLoading = true;
      this.requestPayment(submitData, applePaySession);
    },
    closeLoading() {
      this.cardInfoLoading = false;
      this.submitBtnLoading = false;
      this.$emit('updateStatus', CHECKOUT_STATUS.FILLING);
    },
    clickCountryHandler(evt) {
      if (evt) {
        this.sendGaEvent(this.order, 'click_country_dropdown');
        this.sendRiskDeviceFingerPrint({ e: 'click_country_dropdown' });
      }
    },
    beforeUnloadEvent() {
      this.sendGaEvent(this.order, 'exit_checkout');
      this.sendRiskDeviceFingerPrint({ e: 'exit_checkout' });
    },
    clickSelectHandler(event, type, field) {
      if (event) {
        if (type === 'payment') {
          this.sendGaEvent(this.order, 'focus_payment_info', field);
          this.sendRiskDeviceFingerPrint({ e: 'focus_info', lmo: field });
        } else {
          this.sendGaEvent(this.order, 'focus_billing_info', field);
          this.sendRiskDeviceFingerPrint({ e: 'focus_info', lmo: field });
        }
      }
    },
    sendPaymentInfoFocusEvent(field) {
      this.sendGaEvent(this.order, 'focus_payment_info', field);
      this.sendRiskDeviceFingerPrint({ e: 'focus_info', lmo: field });
      if (field === 'cardNum' && !this.cardNumFocusTime) {
        this.cardNumFocusTime = Date.now();
      }
    },
    sendPaymentInfoInputEvent(field) {
      this.sendGaEvent(this.order, 'input_payment_info', field);
      this.sendRiskDeviceFingerPrint({ e: 'input_info', lmo: field });
      if (field === 'cardNum') {
        this.sendRiskDeviceFingerPrint({ e: 'fill_cardnumber' });
      }
    },
    sendBillingInfoFocusEvent(field) {
      this.sendGaEvent(this.order, 'focus_billing_info', field);
      this.sendRiskDeviceFingerPrint({ e: 'focus_info', lmo: field });
    },
    sendBillingInfoInputEvent(field) {
      this.sendGaEvent(this.order, 'input_billing_info', field);
      this.sendRiskDeviceFingerPrint({ e: 'input_info', lmo: field });
    },
    viewPolicy() {
      this.showPolicy = true;
      // gtag
      this.sendGaEvent(this.order, 'click_privacy_policy');
      this.sendRiskDeviceFingerPrint({ e: 'click_privacy_policy' });
    },
    sendGaEvent(orderInfo, eventName, field = '', extra = {}) {
      try {
        const params = {
          key: this.key,
          merchant_id: orderInfo && orderInfo.merchantNo,
          txn_id: orderInfo && orderInfo.txnId,
          checkout_type: '聚合',
          ...extra,
        };
        // 支付方式
        if (this.payMethods && this.payMethods.length) {
          const currentMethod = this.payMethods[this.activePaymentMethod];
          let methodType = currentMethod.cardName;
          if (currentMethod.children && currentMethod.children.length) {
            const subMethod = currentMethod.children[this.activeChildPaymentMethod];
            methodType = subMethod.cardName;
          }
          params.element_name = methodType;
        }
        // 触发字段
        if (field) {
          params.element_name = field;
        }
        if (['visit_checkout', 'exit_checkout', 'click_payment_button'].includes(eventName)) {
          params.checkout_order_amount = orderInfo && orderInfo.txnAmount;
          params.checkout_order_currency = orderInfo && orderInfo.txnCurrency;
          params.checkout_language = this.lang;
          params.checkout_country = this.form.CARD.country;
        }
        if (eventName === 'visit_checkout' && this.requestingTime) {
          params.api_requesting_time = (this.requestingTime === -1 ? 0 : (Date.now() - this.requestingTime));
          params.visit_checkout_count = 1;
        }
        if (eventName === 'visit_checkout_time' && this.requestingTime) {
          params.time_spent = (this.requestingTime === -1 ? 0 : (Date.now() - this.requestingTime));
        }
        if (eventName === 'click_payment_button' && this.cardNumFocusTime) {
          params.time_spent = Date.now() - this.cardNumFocusTime;
        }
        window.gtag('event', eventName, params);
      } catch (error) { }
    },
    // 返回商户
    onCancel() {
      this.sendGaEvent(this.order, 'cancel_interaction');
      this.sendRiskDeviceFingerPrint({ e: 'cancel_interaction' });
      let url = this.order.cancelUrl || this.order.returnUrl;
      if (url) {
        if (url.indexOf('?') > -1) {
          url = `${url}&transactionId=${this.order.txnId}`;
        } else {
          url = `${url}?transactionId=${this.order.txnId}`;
        }
        window.location.href = url;
      }
    },
    onSuccess() {
      const url = this.order.returnUrl || '';
      this.sendGaEvent('visit_payment_result_page');
      this.sendRiskDeviceFingerPrint({ e: 'visit_payment_result_page' });
      if (url) {
        window.location.href = url;
      }
    },
    queryEmailSearch(queryString, cb) {
      let results = [];
      try {
        const i = queryString.indexOf('@');
        if (i > -1 && i < queryString.length - 1) {
          results = EMAIL_OPTIONS.filter(item => item.value.includes(queryString.substring(i))).map(item => ({ value: queryString.split('@')[0] + item.value }));
        }
      } catch (err) {
        //
      }
      cb(results);
    },
    initCountryList() {
      this.countryList = COUNTRY_OPTIONS.map(item => ({
        ...item,
        label: this.$t(`message.country.${item.code}`),
      })).sort((s1, s2) => {
        try {
          const l = (this.lang === 'zh-tw' || this.lang === 'zh-cn') ? 'zh' : this.lang;
          return s1.label.localeCompare(s2.label, l, { ignorePunctuation: true });
        } catch (err) {
          //
        }
        return 1;
      });
    },

    handleShowRetryReason() {
      this.showRetryReason = !this.showRetryReason;
      this.retryInfo.CollapseTips = this.showRetryReason ? ' More' : 'Collapse';
    },
    // 发送埋点
    sendRiskDeviceFingerPrint(params) {
      const param = {
        m: this.order?.merchantTxnId || '',
        kd: this.order?.merchantNo || '',
        re: this.retryInfo?.retry || '',
        k: this.$route.query?.key || '',
        ct: 'AGGREGATE',
        co: this.order?.txnCurrency || '',
        at: this.order?.txnAmount || '',
        gwq: this.order?.txnId || '',
        bh: this.form?.CARD?.country || '',
        ...params,
      };
      deviceFingerprintManager.send(param);
    },

    /**
     * 收集所有校验错误并发送埋点
     */
    trackAllValidationErrors() {
      try {
        const errors = { required: [], format: [] };

        // 收集卡信息错误
        if (this.activePaymentMethod === this.cardPayMethods) {
          const cardInfoRef = this.$refs[`cardInformationRef${this.activePaymentMethod}`];
          if (cardInfoRef && cardInfoRef[0]) {
            const cardErrors = cardInfoRef[0].getValidationErrors();
            errors.required.push(...cardErrors.required);
            errors.format.push(...cardErrors.format);
          }
        }

        // 收集表单错误
        this.$refs.formRef[this.activePaymentMethod].fields.forEach(field => {
          if (field.validateState === 'error') {
            const value = this.form[this.paymentType]?.[field.prop];
            (value ? errors.format : errors.required).push(field.prop);
          }
        });

        // 发送埋点
        if (errors.required.length || errors.format.length) {
          this.trackValidationFailed(errors);
        }
      } catch (err) {
        console.error('收集校验错误失败:', err);
      }
    },

    /**
     * 发送校验失败埋点
     */
    trackValidationFailed(errors) {
      try {
        const payment = this.payMethods[this.activePaymentMethod]?.cardName || 'UNKNOWN';
        let kal = 'CARD';
        if (this.activePaymentMethod === this.applePayFormIndex) kal = 'AP';
        else if (this.activePaymentMethod === this.googlePayFormIndex) kal = 'GP';
        else if (payment !== 'CARD') kal = 'LOCAL';

        this.sendRiskDeviceFingerPrint({
          e: 'validation_failed',
          lmo: JSON.stringify({ ...errors, payment }),
          kal,
        });
      } catch (err) {
        console.error('发送校验失败埋点失败:', err);
      }
    },
    /**
     * 判断是否要显示右上角的Required
     * 1.点击了支付按钮
     * 2.配置了必填且值为空
     */
    judgeRequired(filedName, value) {
      try {
        if (this.payMethods[this.activePaymentMethod]?.rules[filedName]?.some(item => item.name === 'required' && item.required) && !value) {
          return true;
        }
        return false;
      } catch (error) {
        return false;
      }
    },

    exceptionShow({ respCode: code, respMsg, data }, isSkipPending = false) {
      if ((code === '00020|50054' || code === '50054') && !isSkipPending) { // 订单超时未支付
        this.$emit('updateStatus', CHECKOUT_STATUS.PENDING, '', this.order);

        if (code === '00020|50051') { // 成功订单
          this.$emit('updateStatus', CHECKOUT_STATUS.SUCCESS, '', this.order);
        }
        if (code === '00020|50052') { // 失败订单
          this.$emit('updateStatus', CHECKOUT_STATUS.FAILED, data?.reason || respMsg, this.order);
        }
        if (code === '00020|50053') { // 订单已被取消
          this.$emit('updateStatus', CHECKOUT_STATUS.ERROR, '', this.order);
        }
        if (code === '00020|50050') { // 错误的订单
          this.$emit('updateStatus', CHECKOUT_STATUS.ERROR, '', this.order);
        }
      }

      return false;
    },

    /**
     * 切换到Token支付模式
     * @author Nemo
     */
    switchToTokenPayment() {
      this.useTokenPayment = true;
      this.sendPaymentModeChangeEvent('token');
    },

    /**
     * 切换到新卡支付模式
     * @author Nemo
     */
    switchToCardPayment() {
      this.useTokenPayment = false;
      this.selectedTokenCardId = '';
      this.sendPaymentModeChangeEvent('card');
    },

    /**
     * Token支付提交处理
     * @author Nemo
     */
    async submitWithToken(tokenData) {

      if (this.submitBtnLoading) return;

      this.sendGaEvent(this.order, 'click_payment_button');
      this.sendRiskDeviceFingerPrint({ e: 'click_payment_button' });

      this.submitBtnLoading = true;

      try {
        const selectedCard = this.checkoutTokenInfos.find(c => c.id === tokenData.card.id);
        if (!selectedCard) {
          throw new Error('Card not found');
        }

        // 获取标准的支付参数
        let submitData = this.getPaymentData();

        // 修改为Token支付的特定字段
        // 1. cardName字段为TOKEN表示token支付
        submitData.cardName = 'TOKEN';
        submitData = { ...submitData, ...tokenData.formData };

        // 2. Token支付将tokenId放入cardInfo字段中的tokenId
        // 3. TOKEN支付的CVV放在cardInfo字段的cvv字段中
        submitData.tokenInfo = {
          tokenId: selectedCard.tokenId,
        };

        // 调用支付请求
        this.requestPayment(submitData);

      } catch (error) {
        console.error('Token支付失败:', error);
        this.submitBtnLoading = false;
      }
    },

    /**
     * 移除Token卡片
     * @author Nemo
     */
    async removeTokenCard(cardId) {
      this.cardInfoLoading = true; // 开始loading

      try {
        const selectedCard = this.checkoutTokenInfos.find(c => c.id === cardId);
        if (!selectedCard) {
          return;
        }

        // 调用解绑接口
        const res = await unbindCard({
          key: this.$route.query.key || this.$route.params.id,
          id: selectedCard.id
        });

        if (res.respCode === '20000') {
          // 刷新Token列表
          await this.refreshTokenCards();

          // 显示成功消息
          OnMessage.success(this.$t('message.checkout.cardRemovedSuccess'));

          // 如果移除的是当前选中的卡片，清空选中状态
          if (this.selectedTokenCardId === cardId) {
            this.selectedTokenCardId = '';
          }

          // 如果没有可用卡片了，切换回卡支付模式
          if (this.checkoutTokenInfos.length === 0) {
            this.switchToCardPayment();
          }
        } else {
          this.$message.error(res.respMsg || 'Remove card failed');
        }
      } catch (error) {
        console.error('移除Token卡片失败:', error);
        this.$message.error('Remove card failed');
      } finally {
        this.cardInfoLoading = false; // 结束loading
      }
    },

    /**
     * 刷新Token卡片列表
     * @author Nemo
     */
    async refreshTokenCards() {
      try {
        const res = await getOrderInfo_aggregate({
          key: this.$route.query.key || this.$route.params.id,
          country: this.form.CARD.country || this.order.paymentCountry
        });

        if (res.respCode === '20000' && res.data) {
          this.enableCheckoutToken = res.data.enableCheckoutToken || false;
          this.checkoutTokenInfos = res.data.checkoutTokenInfos || [];
        }
      } catch (error) {
        console.error('刷新Token列表失败:', error);
      }
    },

    /**
     * 发送支付模式切换埋点事件
     * @author Nemo
     */
    sendPaymentModeChangeEvent(mode) {
      // TODO: 根据实际埋点需求实现
      console.log('支付模式切换:', mode);
    },
  },
  watch: {
    lang: function (value) {
      // 更新rules
      for (let i = 0; i < this.payMethods.length; i++) {
        const method = this.payMethods[i];
        let rules = {};
        const methodFields = [];
        if (method.paymentConfigurationFields) {
          methodFields.push(...method.paymentConfigurationFields);
        }
        if (method.billConfigurationFields) {
          methodFields.push(...method.billConfigurationFields);
        }
        if (method.cardName === 'CARD') {
          rules = cardFormRules();
          fieldConfigurationRulesAndNamesHandler(methodFields, rules, this.order.paymentCountry);
          Object.assign(method.rules, rules);
        } else {
          if (method.children && method.children.length) {
            for (let j = 0; j < method.children.length; j++) {
              const subMethod = method.children[j];
              rules = {};
              const subMethodFields = [];
              if (subMethod.paymentConfigurationFields) {
                subMethodFields.push(...subMethod.paymentConfigurationFields);
              }
              if (subMethod.billConfigurationFields) {
                subMethodFields.push(...subMethod.billConfigurationFields);
              }
              fieldConfigurationRulesAndNamesHandler(subMethodFields, rules, this.order.paymentCountry);
              Object.assign(subMethod.rules, rules);
            }
          } else {
            fieldConfigurationRulesAndNamesHandler(methodFields, rules, this.order.paymentCountry);
            Object.assign(method.rules, rules);
          }
        }
      }
      // 更新页面显示的rules
      const activePaymentMethod = this.payMethods[this.activePaymentMethod];
      const activeMethodFields = [];
      if (activePaymentMethod.paymentConfigurationFields) {
        activeMethodFields.push(...activePaymentMethod.paymentConfigurationFields);
      }
      if (activePaymentMethod.billConfigurationFields) {
        activeMethodFields.push(...activePaymentMethod.billConfigurationFields);
      }
      if (activePaymentMethod.cardName === 'CARD') {
        const cardFields = ['periodValue'];
        cardFields.forEach((item) => {
          const ref = this.$refs[`${item}RefCard`] && this.$refs[`${item}RefCard`][0];
          if (ref && ref.$el.className.indexOf('is-error') > -1) {
            this.$refs.formRef[this.activePaymentMethod].validateField(item);
          }
        });
        activeMethodFields.forEach((item) => {
          const ref = this.$refs[`${item.name}RefCard`] && this.$refs[`${item.name}RefCard`][0];
          if (ref && ref.$el.className.indexOf('is-error') > -1) {
            this.$refs.formRef[this.activePaymentMethod].validateField(item.name);
          }
        });
      } else {
        if (activePaymentMethod.children && activePaymentMethod.children.length) {
          const realActivePaymentMethod = activePaymentMethod.children[this.activeChildPaymentMethod];
          const activeSubMethodFields = [];
          if (realActivePaymentMethod.paymentConfigurationFields) {
            activeSubMethodFields.push(...realActivePaymentMethod.paymentConfigurationFields);
          }
          if (realActivePaymentMethod.billConfigurationFields) {
            activeSubMethodFields.push(...realActivePaymentMethod.billConfigurationFields);
          }
          activeSubMethodFields.forEach((item, idx) => {
            const ref = this.$refs[`${item.name}Ref${this.activeChildPaymentMethod}`] && this.$refs[`${item.name}Ref${this.activeChildPaymentMethod}`][0];
            if (ref && ref.$el.className.indexOf('is-error') > -1) {
              this.$refs.formRef[this.activePaymentMethod].validateField(item.name);
            }
          });
        } else {
          activeMethodFields.forEach((item, idx) => {
            const ref = this.$refs.formRef[this.activePaymentMethod].fields[idx];
            if (ref && ref.$el.className.indexOf('is-error') > -1) {
              this.$refs.formRef[this.activePaymentMethod].validateField(item.name);
            } else {
            }
          });
        }
      }

      this.initCountryList();
    },

  },
};
</script>
<style lang="scss">
@import '@/styles/mobile/checkout.scss';

//表单报错提示信息样式修改
.el-form-item__error {
  font-size: 14px !important;
}

.el-loading-spinner .path {
  stroke: var(--brand-color);
}

.special-payment-item {
  max-height: 38px !important;

  apple-pay-button {
    --apple-pay-button-height: 38px;
  }
}
</style>
<style lang="scss" scoped>
@import '@/styles/element-variables.scss';
// @import '../../../styles/mobile/aggregate.scss';

@import "@/styles/mobile/common-retry.scss"; //样式剥离维护 ，交易重试报错提示

.content-wrapper {
  .checkout-outer-wrapper {
    padding-top: 0px;
  }

  .checkout-wrapper {
    text-align: left;
    margin: 0 auto;

    .country-select-box {
      margin-top: 24px;

      .top-country {
        padding-bottom: 0;
      }
    }

    .payment-wrapper {
      margin-top: 40px;
      padding-left: 10px;
      padding-right: 10px;
    }

    .top-country {
      display: flex;
      align-items: center;
    }

    .country-selector-box {
      margin-right: 10px;
    }

    .country-selector {
      display: inline-block !important;
      // width: 315px !important;
      max-width: calc(100vw - 50px);
      // margin-right: 10px;
    }

    .payment-content-wrapper {
      display: inline-block;
    }
  }

  .policy {
    margin: 24px 0;
  }
}

// .policy {
//   margin: 24px 0;
// }

$color-payment-method-border: #D0D5DD;
$color-card-border: #979797;

::v-deep .el-select-dropdown__item .selected {
  color: var(--brand-color);
  font-weight: normal !important;
}

::v-deep .el-form-item__content {
  line-height: 0;
}

:deep(.el-input.is-disabled .el-input__inner) {
  color: #9EA9C1 !important;
}

.custom_loading {
  height: 100vh;
}

.country-selector-box {
  width: 100% !important;
  margin: 0 !important;
}

::v-deep {
  .el-collapse-item__arrow.el-icon-arrow-right {
    display: none;
  }
}

.order-box {
  .method-title {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    padding: 0;

    .payments-support {
      display: flex;
      align-items: center;
      font-size: 20px;
      overflow: hidden;
      line-height: 20px;
      // float: right \9;

      .img {
        margin-right: 5px;
        width: auto;

        &:last-child {
          margin-right: 0;
        }
      }

      .card-number {
        color: #99A3AD;
        font-size: 13px;
        line-height: 20px;
      }
    }
  }

  &.payment-content {
    width: 100%;

    .fields-row {
      display: flex;
      flex-wrap: wrap;
    }

    // payment method部分样式
    .payment-method-wrapper {
      margin-bottom: 24px;

      .checkout-btn {
        border-radius: 8px 8px 8px 8px;
        border: none;
        height: 38px;
        font-size: 16px;
        font-weight: 400;
        padding: 0px !important;
        margin-left: 10px;
        margin-right: 10px;
        display: inline-block;
        width: calc(100% - 20px);

        .el-button {
          font-weight: 400;
          font-size: 16px;
        }
      }

      ::v-deep .el-collapse {
        // border: 0;
        border: 1px solid $color-payment-method-border;
        border-radius: 8px;
        box-shadow: 0px 1px 2px 0px rgba(0, 0, 0, 0.1);

        .method-collapse-item {
          // padding: 0px;
          // transition: background-color .5s;
          border-bottom: 1px solid $color-payment-method-border;

          &.is-active {}

          &:first-child {}

          &:last-child {
            border-bottom: 0;

          }

          &.before {}

          &.after {}

          .el-collapse-item__header {
            background-color: transparent;
            border: 0;
            cursor: auto;
            padding: 10px 10px 10px 10px;
            height: 44px;
            display: flex;
            align-items: center;
            box-sizing: border-box;

            &.is-active {}
          }

          .el-collapse-item__wrap {
            transition: height 0s ease !important;
            /* 确保和内部内容动画一致 */

            background-color: transparent;
            border: 0;

            overflow: visible !important;

            .el-collapse-item__content {
              padding-top: 2px !important;
              padding-bottom: 24px !important;
            }
          }

          .card-type-radio {
            display: flex;
            align-items: center;

            .el-radio__input {
              vertical-align: top;

              .el-radio__inner {
                transform: scale(1.143);
              }
            }

            .el-radio__label {
              height: auto;
              display: flex;
              align-items: center;
              padding-left: 16px;
            }
          }

          .card-name {
            display: inline-flex;
            align-items: center;
            color: $color-text;

            .card-img-wrapper {
              display: inline-block;
              margin-right: 6px;
              border-radius: 2px;
              position: relative;
              width: 42px;
              height: auto;
              box-sizing: border-box;
              vertical-align: top;

              img {
                width: 42px;
                height: auto;
                display: block;
                position: absolute;
                // left: 50%;
                top: 50%;
                transform: translate(0%, -50%);
              }
            }

            .card-type-name {
              font-family: "Open Sans regular";
              font-weight: 400;
              font-size: 14px;
              color: #1A202C;
              line-height: 18px;
              text-align: left;
              font-style: normal;
              text-transform: none;
            }
          }

        }

        .el-collapse-item__arrow {
          &::before {
            display: none;
          }
        }
      }

      &.onlyShowCardPayMethod {
        border: none;
        margin-bottom: 0px !important;

        .checkout-btn {
          width: 100%;
          margin-left: 0;
          margin-right: 0;
        }

        ::v-deep .el-collapse {
          border: 0;
          box-shadow: none;

          .method-collapse-item {
            border: none;

            .el-collapse-item__header {
              display: none;
            }

            .el-collapse-item__wrap {
              overflow: visible !important;

              .el-collapse-item__content {
                padding-bottom: 0px;
              }
            }

          }

          .el-collapse-item__arrow {
            &::before {
              display: none;
            }
          }
        }
      }

      // 账单样式
      .billing-title {
        font-family: "Open Sans regular";
        font-weight: 500;
        font-size: 16px;
        color: $color-text;
        line-height: 20px;
        padding-top: 10px;
        padding-bottom: 0px;
        box-sizing: border-box;
        font-weight: bold;
        margin-bottom: 24px;
      }

      .billing-row {
        display: inline-flex;
        display: -ms-flex;
        flex-wrap: wrap;
        width: 100%;

        :deep .el-form-item {
          margin-right: -2.5px;
        }

      }

      .sub-payment-method {
        padding: 0 36px 0px;

        ::v-deep(.el-radio__inner) {
          transform: scale(1.143);
        }

        ::v-deep(.el-collapse) {
          border: 0;
          box-shadow: none;
        }

        ::v-deep(.sub-method-collapse-item) {

          &:first-child {
            margin-top: 10px;
          }

          .el-collapse-item__header {
            padding: 0;
            height: 26px;
            min-height: initial;
            margin-bottom: 10px;
          }

          &:last-child {
            .el-collapse-item__content {
              padding-bottom: 0 !important;
            }
          }

          .sub-method-radio {
            display: block;
            height: 26px;
            line-height: 26px;
          }

          .sub-method-title {
            display: flex;
            align-items: center;
          }

          .sub-method-img-wrapper {
            display: inline-block;
            margin-right: 6px;
            border-radius: 2px;
            position: relative;
            width: 50px;
            height: 26px;
            box-sizing: border-box;
            vertical-align: top;

            &::after {
              content: '';
              position: absolute;
              width: 335%;
              height: 332%;
              top: 0;
              left: 0;
              transform-origin: 0 0;
              border: 1px solid $color-card-border;
              transform: scale(0.3);
              border-radius: 2px;
              box-sizing: border-box;
              pointer-events: none;
            }

            img {
              max-width: 42px;
              max-height: 18px;
              display: block;
              position: absolute;
              left: 50%;
              top: 50%;
              transform: translate(-50%, -50%);
            }
          }

          .sub-method-name {
            color: $color-text;
          }

          .billing-title {
            background-color: transparent;
            padding: 0;
            margin-top: 10px;
            border: 0;
            font-weight: 800;
          }
        }
      }
    }
  }

  .btns {
    text-align: center;
    padding-left: 10px;
    padding-right: 10px;
    // margin-bottom: 24px;

    .btn-submit {
      width: 100%;
      height: 38px;
      background: #182058;
      border-radius: 8px 8px 8px 8px;
      border: none;

      &.disabled-tip {
        background-color: #B3B3B3 !important;
        color: #FFF !important;
        border-color: #B3B3B3 !important;
      }
    }
  }
}

.btn-cancel-box {
  // height: 16px;
  overflow: hidden;
  text-align: center;
  // margin-bottom: 20px;
  box-sizing: border-box;
  margin-top: 24px !important;
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;

  .btn-cancel {
    font-weight: 400;
    font-size: 12px;
    color: #8D98AF !important;
    text-align: center;
    text-decoration: underline;
    transform: translateY(-6px);

    .back {
      width: 16px;
      height: 16px;
      position: relative;
      top: 4px;
    }

  }

  .btn-cancel-text:hover {
    color: #1A202C !important;
  }
}

.cvv {
  ::v-deep &.el-input--suffix {
    .el-input__inner {
      padding-right: 60px;
    }
  }
}

.DANA_wrap {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  margin-bottom: 20px;

  .DANA_item {
    cursor: pointer;
    flex: 0 0 calc(25% - 20px);
    height: 50px;
    border: 2px solid $color-payment-method-border;
    border-radius: 14px;
    padding: 20px 5px;
    display: flex;
    justify-content: center;
    align-items: center;

    img {
      width: 80px;
    }
  }

  .DANA_active {
    border-color: var(--brand-color);
  }
}

.special-payment-wrapper {
  // margin-top: 24px;

  .special-payment-item {
    position: relative;
    margin-bottom: 24px;

    .submiting_disable_bg {
      position: absolute;
      left: 0;
      right: 0;
      bottom: 0;
      top: 0;
      background: rgb(240, 243, 246, 0.3);
      z-index: 10000;
    }
  }

  .special-payment-divider {
    margin-bottom: 24px;
    position: relative;
    font-family: Open Sans regular;
    font-weight: 400;
    font-size: 14px;
    color: #8D98AF;
    line-height: 16px;
    text-align: left;
    font-style: normal;
    text-transform: none;
    white-space: nowrap;

    display: flex;
    align-items: center;
  }

  .special-payment-divider::before,
  .special-payment-divider::after {
    content: '';
    flex: 1;
    height: 1px;
    background: #EDF1F7;
  }

  .special-payment-divider::before {
    margin-right: 14px;
  }

  .special-payment-divider::after {
    margin-left: 14px;
  }
}

.filed-title {
  font-family: "Open Sans regular";
  font-weight: 400 !important;
  font-size: 14px !important;
  color: #1A202C !important;
  line-height: 18px;
  text-align: left;
  font-style: normal;
  text-transform: none;
  margin-bottom: 6px;
}

.country-wrapper {
  margin-bottom: 24px;
}

// 支付方式的文案加粗处理，因为使用的是同一个类
._payment-wrapper {
  // padding-bottom: 2px;

  padding-left: 0px !important;
  padding-right: 0px !important;

  .filed-title {
    font-weight: bold !important;
    padding-left: 0px;
  }

  // loading 状态下隐藏 TokenPayment 组件内的卡片 border - 开发者：Nemo
  &.card-info-loading {
    ::v-deep .token-payment-container .card-item {
      border: 0 !important;
      box-shadow: none !important;
    }
  }

  &.onlyShowCardPayMethod {
    // margin-top: 24px !important;
  }

  ::v-deep .path {
    stroke: var(--brand-color) !important;
  }
}

:deep(.el-input__inner) {
  background: #FFFFFF;
  box-shadow: 0px 1px 2px 0px rgba(0, 0, 0, 0.1);
  border-radius: 8px 8px 8px 8px;
  border: 1px solid #D0D5DD;
  position: relative;
  height: 38px !important;
  padding: 0 12px !important;
  font-family: 'Open Sans regular' !important;

  &:focus {
    border-color: var(--brand-color) !important;
    box-shadow: 0px 0px 0px 3px #F1F1FF !important;

    :deep(.el-input__suffix) {
      // border-color: var(--color-primary) !important;
      box-shadow: 0px 0px 0px 3px #F1F1FF !important;
    }

  }
}

:deep(.el-textarea__inner) {
  background: #FFFFFF;
  box-shadow: 0px 1px 2px 0px rgba(0, 0, 0, 0.1);
  border-radius: 8px 8px 8px 8px;
  border: 1px solid #D0D5DD;
  position: relative;
  min-height: 38px !important;
  padding: 5px 12px !important;
  font-size: 16px;
  color: #1a202c;
  font-family: 'Open Sans regular' !important;

  &:focus {
    border-color: var(--brand-color) !important;
    box-shadow: 0px 0px 0px 3px #F1F1FF !important;

    :deep(.el-input__suffix) {
      // border-color: var(--color-primary) !important;
      box-shadow: 0px 0px 0px 3px #F1F1FF !important;
    }

  }
}

.form-label {
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-family: "Open Sans regular";
  font-weight: 400;
  font-size: 14px;
  color: #1A202C;
  line-height: 18px;
  text-align: left;
  font-style: normal;
  text-transform: none;
  // padding-left: 4px;
  padding-left: 0px;

  .required-tip {
    // font-family: Open Sans, Open Sans;
    font-weight: 400;
    font-size: 14px;
    color: #F53F3F;
    line-height: 18px;
    text-align: right;
    font-style: normal;
    text-transform: none;
  }
}

:deep(.el-input__suffix) {
  border-top-right-radius: 8px !important;
  border-bottom-right-radius: 8px !important;
}

:deep(.el-form-item__error) {
  position: static;
  // top: 6;
  color: #F53F3F !important;
  font-size: 14px !important;
  line-height: 18px !important;
  font-family: "Open Sans regular" !important;
  padding-top: 0px !important;
}

:deep(.el-form-item) {
  &.is-error {
    position: relative;
    margin-bottom: 24px;
  }
}

.viewPolicy {
  padding: 0 !important;
}

.top-country {
  box-sizing: border-box
}

:deep .on-select-dropdown__item {
  height: 38px !important;
  line-height: 38px !important;
}

:deep(.on-select-dropdown__item .selecte) {
  background: #F6F6FF !important;
  color: #667085 !important;
}

:deep(.el-radio__input.is-checked .el-radio__inner) {
  background: #182058 !important;
  border-color: #182058 !important;
}

:deep(.el-radio__inner) {
  &:hover {
    border-color: #182058 !important;
  }
}

:deep(.el-radio:focus:not(.is-focus):not(:active):not(.is-disabled) .el-radio__inner) {
  box-shadow: 0 0 2px 2px #fff !important;
}

:deep.el-form--label-top .el-form-item__label {
  font-family: "Open Sans regular";
  padding: 0 0 6px;
  font-size: 14px !important;
  color: #1A202C;
}

:deep .el-form-item {
  margin-bottom: 24px;
}

.subsciption {
  font-weight: 400;
  font-size: 12px;
  color: #1A202C;
  line-height: 16px;
  text-align: center;
  // margin: 24px auto;/
  margin-top: 24px;
  width: 100%;
  // word-break: break-all;
  box-sizing: border-box;
  margin: 0 auto;
  margin-top: 24px;
  overflow: hidden;
  width: calc(100% - 32px);

}

.country-loading {
  width: 100%;
  margin-top: 4px;
  height: 32px;

  ::v-deep .circular {
    width: 32px;
    height: 32px;
  }

  ::v-deep .path {
    stroke: var(--brand-color) !important;
  }

}

.card-info-suffix {

  // width: 132px;
  .card-info-suffix-content {
    display: flex;
    align-items: center;
    justify-content: end;
    gap: 4px;

    img {
      width: 32px;
      height: auto;
    }
  }
}

.fixed-item {
  width: 30px;
  height: 16px;
}

.fade-carousel {
  position: relative;
  width: 30px;
  height: auto;
  bottom: 11px;
}

.fade-item {
  position: absolute;
  top: 0;
  left: 0;
  width: 30px;
  height: 16px;
  opacity: 0;
  transition: opacity 1s ease;
}

.fade-item.active {
  opacity: 1;
}

.tipsBox {
  width: 100%;
  padding: 16px;
  box-sizing: border-box;
  position: sticky;
  top: 0;
  z-index: 9999;

  .tipsheader {
    display: flex;
    justify-content: space-between;
    align-items: center;

    .logo {
      display: flex;
      align-items: center;
    }

    .word {
      font-weight: 600;
      font-size: 16px;
      color: #1D2129;
      margin-left: 4px;
    }

    .close {
      color: #4E5969;
      // position: absolute;
      // right: 16px;
      // top: 16px;
      // top:0px;
      // right: 0px;
    }
  }

  .message {
    font-weight: 400;
    font-size: 14px;
    color: #1D2129;
    line-height: 22px;
    text-align: left;
    margin-top: 4px
  }

  .isPadding {
    padding-left: 19px;
    padding-right: 19px;
  }

  .img {
    width: 16px;
    height: 16px;
    vertical-align: middle;

  }
}

.err {
  background: #FFECE8;
  // top: 80px !important
}

.topErr {
  top: 58px !important;
}

.topHeight {
  top: 80px !important
}

.submit-btn-wrapper {
  .btn-submit {
    width: 100%;
    background: #182058;
    border-radius: 8px 8px 8px 8px;
    border: none;
    position: relative;
    height: 38px;
    font-size: 16px;
    font-weight: 400;
  }

  .el-icon-loading {
    position: absolute;
    right: 26px;
    color: #182058 !important;
    z-index: 100;
  }

  .btn-submit-loading {
    background: #F0F3F6 !important;
    color: #9EA9C1 !important;
    position: relative;
  }
}

.payment-title-text {
  font-family: Open Sans regular;
  font-weight: 600;
  font-size: 18px;
  line-height: 24px;
  letter-spacing: 0px;
  color: rgba(26, 32, 44, 1);
  margin-bottom: 24px !important;
  text-align: left;
  margin-top: 0;
}

.payment-content-wrapper {
  width: 100% !important;
}

// 账单信息区域样式 - 根据onlyShowCardPayMethod动态控制
// 只有卡支付时的样式
.onlyShowCardPayMethod .billing-section {
  border-top: none;
  background-color: transparent;
  padding-top: 0;
  margin-top: 0;
}

// 账单信息折叠样式
h2.billing-title {
  display: flex;
  align-items: center;
  cursor: pointer;
  user-select: none;
  font-family: "Open Sans regular";
  font-weight: 500;
  font-size: 16px;
  color: #1A202C;
  line-height: 20px;
  padding-top: 10px;
  padding-bottom: 0px;
  box-sizing: border-box;
  font-weight: bold;
  justify-content: space-between;
  margin-top: 0 !important;
  margin-bottom: 24px !important;
}

.arrow-icon {
  width: 14px;
  height: 8px;
  margin-left: 8px;
  transition: transform 0.2s;
  transform: rotate(0deg);
}

.arrow-open {
  transform: rotate(180deg);
}

/* 折叠动画样式 */
.collapse-enter-active,
.collapse-leave-active {
  transition: max-height 0.3s cubic-bezier(0.4, 0, 0.2, 1), opacity 0.3s;
  overflow: hidden;
}

.collapse-enter,
.collapse-leave-to {
  max-height: 0;
  opacity: 0;
}

.collapse-enter-to,
.collapse-leave {
  max-height: 1000px;
  opacity: 1;
}

/* 加载状态覆盖层 */
.field-loading-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(255, 255, 255, 0.7);
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 8px;
  z-index: 10;

  .loading-container {
    width: 100%;
    height: 100%;

    /* 修改Element UI的loading样式 */
    ::v-deep .el-loading-mask {
      background-color: transparent;
    }

    ::v-deep .el-loading-spinner {
      top: 58% !important;
      margin-top: 0 !important;
      transform: translateY(-50%) !important;
    }

    ::v-deep .circular {
      width: 20px !important;
      height: 20px !important;
    }
  }
}

/* 去除number类型input的增减箭头 */
::v-deep .el-input__inner[type="number"]::-webkit-outer-spin-button,
::v-deep .el-input__inner[type="number"]::-webkit-inner-spin-button {
  -webkit-appearance: none !important;
  margin: 0 !important;
}

::v-deep .el-input__inner[type="number"] {
  -moz-appearance: textfield !important;
}

/* 自定义el-select下拉箭头样式 */
::v-deep .el-select {
  height: 38px !important;

  .el-input__suffix {

    /* 隐藏默认箭头 */
    .el-select__caret {
      display: none !important;
    }

    /* 添加自定义箭头 */
    &::after {
      content: '';
      position: absolute;
      top: 50%;
      right: 12px;
      transform: translateY(-50%);
      width: 9.33px;
      height: 5.33px;
      background-image: url("data:image/svg+xml,%3csvg width='10' height='6' viewBox='0 0 10 6' fill='none' xmlns='http://www.w3.org/2000/svg'%3e%3cpath d='M1 1L5 5L9 1' stroke='%23D0D5DD' stroke-width='1.5' stroke-linecap='round' stroke-linejoin='round'/%3e%3c/svg%3e");
      background-repeat: no-repeat;
      background-position: center;
      background-size: contain;
      pointer-events: none;
      transition: transform 0.3s ease;
      z-index: 1;
    }
  }

  /* 展开状态时箭头旋转 */
  &.is-focus .el-input__suffix::after {
    transform: translateY(-50%) rotate(180deg);
  }
}

.intallment-text {
  font-size: 14px;
  font-weight: 400;
  color: #616d7a;
  line-height: 20px;
  margin: 6px 0 0;
}

@keyframes loading-arrow-spin {
  100% {
    transform: rotate(360deg);
  }
}

// 分期加载样式 - 开发者：Nemo
.installment-loading-pc {
  width: 100%;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;

  :deep(.el-loading-mask) {
    background-color: transparent;
  }

  :deep(.circular) {
    width: 20px;
    height: 20px;
  }

  :deep(.path) {
    stroke: var(--color-primary, #503df6) !important;
  }

  :deep(.el-loading-spinner) {
    position: relative !important;
    top: auto !important;
    left: auto !important;
    margin: 0 !important;
    transform: translateY(-4px) !important;
  }
}

// Token支付相关样式 - 新增

// 保存卡片勾选框区域 - 开发者：Nemo
.save-card-checkbox-wrapper {
  margin-bottom: 24px;
  padding: 16px 12px; // 默认padding（只有卡支付时为12px，有其他支付时会被动态class覆盖为10px）
  border: 1px solid #E5E7EB;
  border-radius: 8px;

  .checkbox-label {
    font-size: 14px;
    font-weight: 500;
    color: #1F2937;
  }

  .checkbox-desc {
    margin-top: 4px;
    margin-left: 24px;
    font-size: 12px;
    color: #6B7280;
    line-height: 1.5;
  }

  :deep(.el-checkbox__label) {
    font-weight: normal;
  }

  // checkbox 选中状态使用主题色
  :deep(.el-checkbox__input.is-checked .el-checkbox__inner) {
    background-color: var(--brand-color);
    border-color: var(--brand-color);
  }

  // checkbox hover 状态
  :deep(.el-checkbox__input:not(.is-disabled):hover .el-checkbox__inner) {
    border-color: var(--brand-color);
  }

  // checkbox focus 状态
  :deep(.el-checkbox__input.is-focus .el-checkbox__inner) {
    border-color: var(--brand-color);
  }

  // checkbox 选中且 hover 状态
  :deep(.el-checkbox__input.is-checked:not(.is-disabled):hover .el-checkbox__inner) {
    background-color: var(--brand-color);
    border-color: var(--brand-color);
    opacity: 0.8;
  }

  // 保持 label 颜色不变
  :deep(.el-checkbox__input.is-checked + .el-checkbox__label) {
    color: inherit;
  }
}

// Token支付切换按钮
.switch-to-token-wrapper {
  text-align: center;
  margin-top: 24px;

  .use-saved-card-btn {
    color: var(--brand-color);
    font-family: "Open Sans regular";
    font-weight: 500;
    cursor: pointer;
    font-size: 16px;
    line-height: 22px;

    &:hover {
      text-decoration: underline;
    }
  }
}

// 卡支付模式标题（Token/新卡）
.card-payment-mode-title {
  font-size: 18px;
  font-weight: 600;
  margin-bottom: 8px;
  color: #1F2937;
  font-family: "Open Sans regular";

  // 可点击状态 - 开发者：Nemo
  &.clickable {
    cursor: pointer;
    user-select: none;
    display: flex;
    align-items: center;
    justify-content: space-between;

    .arrow-icon {
      width: 14px;
      height: 8px;
      margin-left: 8px;
      transition: transform 0.2s;
      transform: rotate(0deg);
      flex-shrink: 0;
    }

    .arrow-open {
      transform: rotate(180deg);
    }
  }
}
</style>
